/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Partners API
 * OpenAPI spec version: 1.0.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import { useFetchWrapper } from '../fetchClient.ts';
import type { ErrorType , BodyType } from '../fetchClient.ts';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

export type ANFAccount = {
  approvalDate: string;
  clientId: string;
  daysSinceApproval: number;
  email: string;
  fullName: string;
  rebateAccount: string;
  tradingAccountID: string;
  tradingAccountType: string;
};

export type ClientOutputMetadata = {
  /** Current page number (1-based) */
  currentPage?: number;
  /** Number of records per page */
  pageSize?: number;
  /**
     * Fields that are redacted due to privacy concerns.
     * @nullable
     */
  redactedFields?: string[] | null;
  /** Total number of records */
  totalCount?: number;
};

export type ANFReportOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  list: ANFAccount[] | null;
  metadata: ClientOutputMetadata;
};

export type ClientAccount = {
  accountID: string;
  clientID: string;
  email: string;
  executionType: string;
  firstTradedDate: string;
  /**
     * The offer ID linked to this account's rebate configuration, if any
     * @nullable
     */
  hasOfferID: string | null;
  lastTradedDate: string;
  name: string;
  rebateAccountID: string;
};

export type AccountReport = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  clientsAccounts: ClientAccount[] | null;
  metadata: ClientOutputMetadata;
};

export type AccountTypeCount = {
  count: number;
  name: string;
};

export type AccountsList = {
  /** @nullable */
  accountsType: AccountTypeCount[] | null;
  /** @nullable */
  platformAccounts: AccountTypeCount[] | null;
  total: number;
};

export type AccountReportStats = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  accountsList: AccountsList;
};

export type ClientSubIB = {
  /** The sub IB's IB ID */
  id: string;
  /** The sub IB's masked name */
  name: string;
};

export type ClientAccountV3 = {
  accountID: string;
  clientID: string;
  email: string;
  executionType: string;
  firstTradedDate: string;
  /**
     * The offer ID linked to this account's rebate configuration, if any
     * @nullable
     */
  hasOfferID: string | null;
  lastTradedDate: string;
  name: string;
  rebateAccountID: string;
  /**
     * Sub IBs the client's rebate program is shared with
     * @nullable
     */
  subIBs?: ClientSubIB[] | null;
};

export type AccountReportV3 = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  clientsAccounts: ClientAccountV3[] | null;
  metadata: ClientOutputMetadata;
};

export type AffiliateUserDetails = {
  /** User does not provide signals */
  doesNotProvideSignals?: boolean;
  /** Identifies the user holds a license */
  holdsLicense?: boolean;
  /** User manages a website or digital channels */
  managesWebsiteOrDigitalChannels?: boolean;
  /** User provides copy trading services */
  providesCopyTradingServices?: boolean;
  /** User provides EA or copy trading services */
  providesEAOrCopyTradingServices?: boolean;
};

export type ArchiveSingleOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Timestamp when the program was archived
     * @nullable
     */
  archivedAt: string | null;
  /** ID of the archived rebate program */
  id: number;
};

export type AssetGroup = {
  /** Asset class name (e.g. Forex, Metals). */
  name: string;
  /**
     * Symbols under this asset class.
     * @nullable
     */
  symbols: string[] | null;
};

export type SymbolRateBody = {
  /** Islamic-account rebate per lot, in the body's currency */
  islamicValue: number;
  /** Razor-account rebate per lot, in the body's currency */
  razorValue: number;
  /** Standard-account rebate per lot, in the body's currency */
  standardValue: number;
  /** Symbol ticker, e.g. AUDUSD */
  symbol: string;
};

export type AssetRateBody = {
  /** Asset class, e.g. FX, Commodity */
  asset: string;
  /** Islamic-account rebate per lot, in the body's currency */
  islamicValue: number;
  /** Razor-account rebate per lot, in the body's currency */
  razorValue: number;
  /** Standard-account rebate per lot, in the body's currency */
  standardValue: number;
  /**
     * Per-symbol rebate rates within this asset class
     * @nullable
     */
  symbols: SymbolRateBody[] | null;
};

export type AssetsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Asset classes and the symbols each covers, for use when configuring a rebate program.
     * @nullable
     */
  data: AssetGroup[] | null;
};

export type BannerAsset = {
  code?: string;
  fileId: number;
  fileName: string;
  height: number;
  id: string;
  language: string;
  offerId: string;
  thumbnail?: string;
  type: string;
  width: number;
};

export type BannerAssetsFilterOptionsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Distinct lower-cased language codes across all successful banner assets, alphabetically sorted.
     * @nullable
     */
  languages: string[] | null;
  /**
     * Distinct banner sizes ("<width>x<height>") across all successful banner assets, sorted by width then height.
     * @nullable
     */
  sizes: string[] | null;
};

export type BannerAssetsMetadata = {
  /** Current page number (1-based) */
  currentPage?: number;
  /** Number of records per page */
  pageSize?: number;
  /** Total number of banner groups */
  totalCount?: number;
};

export type BannerGroup = {
  /** @nullable */
  assets: BannerAsset[] | null;
  name: string;
  offerId: number;
  thumbnail?: string;
};

export type SymbolDetails = {
  clientsPercents: number;
  deals: number;
  users: number;
  volumePercents: number;
};

export type TradedSymbol = {
  details: SymbolDetails;
  name: string;
  value: number;
};

export type ByClients = {
  /** @nullable */
  counts: TradedSymbol[] | null;
  /** @nullable */
  percents: TradedSymbol[] | null;
};

export type Campaign = {
  createdAt: string;
  id: number;
  isDefault: boolean;
  name: string;
  updatedAt: string;
};

export type ChildIB = {
  email: string;
  id: string;
  scaUserID: string;
};

export type Client = {
  /** The unique identifier for the client */
  clientId: string;
  currency: string;
  email: string;
  fullName: string;
  /**
     * The offer ID linked to this client's rebate configuration, if any
     * @nullable
     */
  hasOfferID: string | null;
  rebateAccountID: string;
  /** The total earnings for the IB in their currency for that client */
  totalEarnings: number;
  /**
     * The total volume in USD for that client
     * @nullable
     */
  totalVolumeUSD: number | null;
  tradingAccountID: string;
  tradingAccountType: string;
  /** The number of LOTS the client has in volumeCFD */
  volumeCFD: number;
  /** The number of LOTS the client has in volumeCommodity */
  volumeCommodity: number;
  /** The number of LOTS the client has in volumeCrypto */
  volumeCrypto: number;
  /** The number of LOTS the client has in volumeEquities */
  volumeEquities: number;
  /** The number of LOTS the client has in volumeFX */
  volumeFX: number;
  /** The number of LOTS the client has in volumeIndex */
  volumeIndex: number;
  /** The number of LOTS the client has in volumeOil */
  volumeOil: number;
  /** The number of LOTS the client has in volumeSB */
  volumeSB: number;
  /** The number of LOTS the client has in volumeXAG */
  volumeXAG: number;
  /** The number of LOTS the client has in volumeXAU */
  volumeXAU: number;
};

/**
 * Lead's status
 */
export type ClientV2Status = typeof ClientV2Status[keyof typeof ClientV2Status];


export const ClientV2Status = {
  Started: 'Started',
  Pending: 'Pending',
  Approved: 'Approved',
  Demo: 'Demo',
  Unknown: 'Unknown',
} as const;

export type ClientV2 = {
  clientID: string;
  /** Client created time in milliseconds since epoch */
  createdAt: number;
  currency: string;
  email: string;
  fullName: string;
  rebateAccountID: string;
  /** Lead's status */
  status: ClientV2Status;
  /** The total earnings for the IB in their currency for that client */
  totalEarnings: number;
  tradingAccountID: string;
  tradingAccountType: string;
  /** The number of LOTS the client has in volumeCFD */
  volumeCFD: number;
  /** The number of LOTS the client has in volumeFX */
  volumeFX: number;
  /** The number of LOTS the client has in volumeOil */
  volumeOil: number;
  /** The number of LOTS the client has in volumeXAG */
  volumeXAG: number;
  /** The number of LOTS the client has in volumeXAU */
  volumeXAU: number;
};

export type ClientV3 = {
  /** The unique identifier for the client */
  clientId: string;
  currency: string;
  email: string;
  fullName: string;
  /**
     * The offer ID linked to this client's rebate configuration, if any
     * @nullable
     */
  hasOfferID: string | null;
  rebateAccountID: string;
  /**
     * Sub IBs the client's rebate program is shared with
     * @nullable
     */
  subIBs?: ClientSubIB[] | null;
  /** The total earnings for the IB in their currency for that client */
  totalEarnings: number;
  /**
     * The total volume in USD for that client
     * @nullable
     */
  totalVolumeUSD: number | null;
  tradingAccountID: string;
  tradingAccountType: string;
  /** The number of LOTS the client has in volumeCFD */
  volumeCFD: number;
  /** The number of LOTS the client has in volumeCommodity */
  volumeCommodity: number;
  /** The number of LOTS the client has in volumeCrypto */
  volumeCrypto: number;
  /** The number of LOTS the client has in volumeEquities */
  volumeEquities: number;
  /** The number of LOTS the client has in volumeFX */
  volumeFX: number;
  /** The number of LOTS the client has in volumeIndex */
  volumeIndex: number;
  /** The number of LOTS the client has in volumeOil */
  volumeOil: number;
  /** The number of LOTS the client has in volumeSB */
  volumeSB: number;
  /** The number of LOTS the client has in volumeXAG */
  volumeXAG: number;
  /** The number of LOTS the client has in volumeXAU */
  volumeXAU: number;
};

export type CreateAPIKeyInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Optional label for the key
     * @maxLength 256
     */
  name?: string;
};

export type CreateAPIKeyOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** AWS API Gateway key ID */
  apiKeyId: string;
  createdAt: string;
  id: string;
  /** The API key value. Returned only in this response and cannot be retrieved again. */
  key: string;
  /** @nullable */
  name: string | null;
};

export type CreateCampaignInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Campaign name
     * @minLength 1
     * @maxLength 255
     */
  name: string;
};

export type CreateCampaignOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  createdAt: string;
  id: number;
  isDefault: boolean;
  name: string;
  partnerId: string;
  updatedAt: string;
};

export type PartnerSplit = {
  /**
     * Master's note about this Sub IB.
     * @maxLength 60
     */
  comment?: string;
  /** The Sub IB's IB.ID. */
  ibId: string;
  /**
     * @minimum 0
     * @maximum 100
     */
  pct: number;
  /** Whether the Sub IB may see the Master's email. */
  showEmail?: boolean;
  /** Whether the Sub IB may see the Master's name. */
  showName?: boolean;
};

export type OverrideSpecScopeType = typeof OverrideSpecScopeType[keyof typeof OverrideSpecScopeType];


export const OverrideSpecScopeType = {
  symbol: 'symbol',
  assetClass: 'assetClass',
} as const;

export type OverrideSpec = {
  /**
     * @minimum 0
     * @maximum 100
     */
  masterPct: number;
  /** @nullable */
  partnerSplits: PartnerSplit[] | null;
  scopeType: OverrideSpecScopeType;
  /** Symbol (e.g. ETHUSD) or asset class (e.g. FX). */
  scopeValue: string;
};

export type SplitSpec = {
  /**
     * @minimum 0
     * @maximum 100
     */
  masterPct: number;
  /**
     * @minItems 1
     * @maxItems 2
     * @nullable
     */
  partners: PartnerSplit[] | null;
};

export type CreateInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Per-asset-class split overrides. Each must total 100.
     * @nullable
     */
  assetOverrides?: OverrideSpec[] | null;
  /** Base rebate split; must total 100 across Master and Subs. */
  split: SplitSpec;
  /**
     * Per-symbol split overrides. Each must total 100.
     * @nullable
     */
  symbolOverrides?: OverrideSpec[] | null;
};

export type CreateMarketingBannerInputBodyType = typeof CreateMarketingBannerInputBodyType[keyof typeof CreateMarketingBannerInputBodyType];


export const CreateMarketingBannerInputBodyType = {
  html_ad: 'html_ad',
  image_banner: 'image_banner',
} as const;

export type CreateMarketingBannerInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  HOID: string;
  bannerGroup: string;
  campaignID?: number;
  creativeFileID: string;
  creativeFileName: string;
  /** @minimum 1 */
  height: number;
  language?: string;
  name: string;
  offerID: string;
  type: CreateMarketingBannerInputBodyType;
  /** @minimum 1 */
  width: number;
};

export type CreateMarketingBannerOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  creativeCode: string;
  id: string;
};

export type Participant = {
  name: string;
  pct: number;
  rebateLogin: number;
  subRef: string;
};

export type ReferralLinkOutput = {
  /** Full referral tracking link. */
  full: string;
  /** Shortened referral tracking link, minted on Tune. */
  short: string;
};

export type CreateOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Creation date, YYYY-MM-DD. */
  createdAt: string;
  hoid: string;
  /** @nullable */
  participants: Participant[] | null;
  programId: number;
  rebateProgramLabel: string;
  referralLink: ReferralLinkOutput;
  status: string;
};

export type CreateReferralLinkInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  HOID: string;
  campaignId?: number;
  landingPageName?: string;
  language: string;
  license?: string;
  linkType?: string;
  name?: string;
  offerID: string;
  urlID?: string;
};

export type CreateReferralLinkOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  referralLink: string;
};

export type CreativeCodeOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  creativeCode: string;
};

export type CriteriaMonthValue = {
  /** Month this value belongs to, YYYY-MM */
  month: string;
  /** Criterion value recorded for this month */
  value: number;
};

export type CriteriaProgressEntry = {
  /**
     * Per-month breakdown for the trailing 3-month window
     * @nullable
     */
  months: CriteriaMonthValue[] | null;
  /** Criterion type: VolumeUSD, ActiveClients */
  type: string;
};

export type DataPoint = {
  date: string;
  value: number;
};

export type Earning = {
  /** The account balance */
  accountBalance: number;
  /** Account ID */
  accountID: string;
  /** Account name */
  accountName: string;
  /** Currency code */
  currencyCode: string;
};

export type EarningsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Earnings information for each account.
     * @nullable
     */
  earnings: Earning[] | null;
};

export type EmailVerificationStatusBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** True when the authenticated user's email address is verified in Auth0 */
  emailVerified: boolean;
};

export type ErrorDetail = {
  /** Where the error occurred, e.g. 'body.items[3].tags' or 'path.thing-id' */
  location?: string;
  /** Error message text */
  message?: string;
  /** The value at the given location */
  value?: unknown;
};

export type ErrorModel = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** A human-readable explanation specific to this occurrence of the problem. */
  detail?: string;
  /**
     * Optional list of individual error details
     * @nullable
     */
  errors?: ErrorDetail[] | null;
  /** A URI reference that identifies the specific occurrence of the problem. */
  instance?: string;
  /** HTTP status code */
  status?: number;
  /** A short, human-readable summary of the problem type. This value should not change between occurrences of the error. */
  title?: string;
  /** A URI reference to human-readable documentation for the error. */
  type?: string;
};

export type FNTData = {
  accountID: string;
  accountType: string;
  clientID: string;
  currencyCode: string;
  depositedAmount: number;
  depositedAt: string;
  email: string;
  name: string;
  rebateAccountID: string;
};

export type FNTReport = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  list: FNTData[] | null;
  metadata: ClientOutputMetadata;
};

export type Featureflag = {
  enabled: boolean;
};

export type FeatureflagsListBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  hidePIIData: Featureflag;
  showClientReporting: Featureflag;
  /** True when the signed-in user has an eligible Master IB record */
  showIBNetworkTab: boolean;
  showNewMarketingPage: Featureflag;
  showPreOnboardingTriage: Featureflag;
  useFakeTuneClient: Featureflag;
  useMockData: Featureflag;
  useMockOnboarding: Featureflag;
};

export type FilterOption = {
  label: string;
  value: string;
};

export type ReferralLinkCampaignOption = {
  id: number;
  name: string;
};

export type FilterOptionsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * The partner's campaigns (default campaign first, then alphabetical).
     * @nullable
     */
  campaigns: ReferralLinkCampaignOption[] | null;
  /**
     * Distinct destination page names derived from the partner's existing referral links.
     * @nullable
     */
  destinationPages: string[] | null;
  /**
     * Distinct raw language codes derived from the partner's existing referral links.
     * @nullable
     */
  languages: string[] | null;
  /**
     * Distinct HOID values derived from the partner's existing referral links.
     * @nullable
     */
  rebatePrograms: string[] | null;
};

export type FlagUser = {
  email: string;
};

export type GetAffiliateApprovalStatusBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** The affiliate's approval status for this offer. */
  approvalStatus: string;
};

/**
 * User's saved answers
 */
export type GetAnswersResponseAnswers = {[key: string]: unknown};

export type GetAnswersResponse = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** User's saved answers */
  answers: GetAnswersResponseAnswers;
  /** Whether answers have been submitted */
  is_submitted: boolean;
};

export type GetBannerAssetsBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  bannerGroups: BannerGroup[] | null;
  metadata?: BannerAssetsMetadata;
};

export type GetCampaignsOutputMetadata = {
  /** Current page number (1-based) */
  currentPage?: number;
  /** Number of records per page */
  pageSize?: number;
  /** Total number of records */
  totalCount?: number;
};

export type GetCampaignsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  campaigns: Campaign[] | null;
  metadata?: GetCampaignsOutputMetadata;
};

export type LandingPageLink = {
  id: string;
  languageCode: string;
  license?: string;
  name: string;
  previewUrl: string;
};

export type OfferLandingPages = {
  id: string;
  /** @nullable */
  landingPages: LandingPageLink[] | null;
  name: string;
  thumbnailUrl?: string;
};

export type GetLandingPagesOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  offers: OfferLandingPages[] | null;
};

/**
 * Arbitrary params belonging to this notification, for example tier names and ISO dates. Shape differs per domain. Null when the notification has none.
 * @nullable
 */
export type GetLatestNotificationOutputBodyMetadata = {[key: string]: unknown} | null;

export type GetLatestNotificationOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** When the notification was created; determines which one is latest */
  createdAt: string;
  /**
     * When the partner dismissed this notification, or null when they have not. A non-null value means the client should not show it again -- this endpoint returns the newest notification regardless of dismissal.
     * @nullable
     */
  dismissedAt: string | null;
  /** Feature that owns this notification */
  domain: string;
  /** Notification ID, passed to PATCH /v1/notifications/{id} to dismiss it */
  id: string;
  /**
     * Notification body, returned as stored. Null when the notification has no body.
     * @nullable
     */
  message: string | null;
  /**
     * Arbitrary params belonging to this notification, for example tier names and ISO dates. Shape differs per domain. Null when the notification has none.
     * @nullable
     */
  metadata: GetLatestNotificationOutputBodyMetadata;
  /**
     * When the partner read this notification. Not yet written by anything.
     * @nullable
     */
  readAt: string | null;
  /**
     * ID of the record that caused this notification. Which table it belongs to follows from domain and type: for rebate-tier, TIER_UPGRADED/TIER_DOWNGRADED point at a partner tier, GP_*\/GP_EXPIRED at a grace period, and TF_*\/FP_EXPIRED at a freeze period. A closing notification (TF_UNASSIGNED, FP_EXPIRED, GP_EXPIRED) shares the reference_id of the one that opened the state. TIER_AT_RISK carries a synthetic id, one per partner and cycle, that points at no table row. Null when the notification has no originating record.
     * @nullable
     */
  referenceId: string | null;
  /**
     * What referenceId points at: partner_tier_id, grace_period_id, freeze_period_id or tier_at_risk_cycle for rebate-tier, rebate_program_id:sub_ib_id for ib-status. Null exactly when referenceId is null.
     * @nullable
     */
  referenceName: string | null;
  /** Notification title, returned as stored */
  title: string;
  /** Machine category, matching activity_log.event_name: TIER_UPGRADED, TIER_DOWNGRADED, TIER_AT_RISK, FP_EXPIRED, GP_ASSIGNED, GP_EXPIRED, GP_EXTENDED, TF_ASSIGNED, TF_EXTENDED, TF_UNASSIGNED. TIER_AT_RISK is a forecast and has no activity_log row. */
  type: string;
};

export type MarketingBannerType = typeof MarketingBannerType[keyof typeof MarketingBannerType];


export const MarketingBannerType = {
  html_ad: 'html_ad',
  image_banner: 'image_banner',
} as const;

export type MarketingBanner = {
  bannerGroup: string;
  /**
     * Id of the campaign this banner is attached to; null if none.
     * @nullable
     */
  campaignId: number | null;
  /**
     * Name of the campaign this banner is attached to; null if none.
     * @nullable
     */
  campaignName: string | null;
  createdAt: string;
  /** HTML creative code with the tracking URL embedded. */
  creativeCode: string;
  creativeFileId: string;
  creativeFileName: string;
  height: number;
  id: string;
  /** Language code (e.g. en, vi). Empty if not set. */
  language?: string;
  /**
     * Most recent click timestamp (hour precision) for this banner; null if never clicked.
     * @nullable
     */
  lastClickedAt: string | null;
  name: string;
  offerId: string;
  /** Rebate program (Referral.Offers_ID). Empty if unknown. */
  rebateProgram: string;
  type: MarketingBannerType;
  updatedAt: string;
  width: number;
};

export type GetMarketingBannersOutputMetadata = {
  /** Current page number (1-based) */
  currentPage?: number;
  /** Number of records per page */
  pageSize?: number;
  /** Total number of records */
  totalCount?: number;
};

export type GetMarketingBannersOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  marketingBanners: MarketingBanner[] | null;
  metadata?: GetMarketingBannersOutputMetadata;
};

export type GetRebateRatesOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Rebate rates for the default set, optionally filtered by asset
     * @nullable
     */
  assets: AssetRateBody[] | null;
  /** ISO currency every value is in: the partner's latest rebate account currency, USD when unavailable */
  currency: string;
};

export type GetReferralLinksOutputMetadata = {
  /** Current page number (1-based) */
  currentPage?: number;
  /** Number of records per page */
  pageSize?: number;
  /** Total number of records */
  totalCount?: number;
};

export type ReferralLink = {
  /**
     * Id of the campaign this link is attached to; null if none.
     * @nullable
     */
  campaignId: number | null;
  /**
     * Name of the campaign this link is attached to; null if none.
     * @nullable
     */
  campaignName: string | null;
  createdAt: string;
  fullLink: string;
  id: string;
  isDefault: boolean;
  isShort: boolean;
  /** Language code of the landing page (e.g. en, vi). */
  languageCode: string;
  /**
     * Most recent click timestamp (hour precision) for this link; null if never clicked.
     * @nullable
     */
  lastClickedAt: string | null;
  /** Regulatory license code (e.g. ASIC, FCA, SCB). Empty if unknown. */
  license?: string;
  linkType: string;
  name: string;
  rebateProgram: string;
  shortLink: string;
  tuneLandingPageId: number;
  tuneLandingPageName: string;
  tuneLandingPageStatus: string;
  tuneOfferId: number;
  tuneOfferName: string;
  updatedAt: string;
};

export type GetReferralLinksOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  metadata?: GetReferralLinksOutputMetadata;
  /** @nullable */
  referralLinks: ReferralLink[] | null;
};

/**
 * The status of the triage
 */
export type GetTriageListOutputBodyStatus = typeof GetTriageListOutputBodyStatus[keyof typeof GetTriageListOutputBodyStatus];


export const GetTriageListOutputBodyStatus = {
  STARTED: 'STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
} as const;

/**
 * IB's type
 */
export type IBUserDetailsType = typeof IBUserDetailsType[keyof typeof IBUserDetailsType];


export const IBUserDetailsType = {
  individual: 'individual',
  company: 'company',
} as const;

export type IBUserDetails = {
  /** IB acknowledged the Colombia country-of-residence disclosure */
  colombiaDisclosureAccepted?: boolean;
  /** IB's country of residence */
  countryOfResidence?: string;
  /** IB's first name */
  firstName?: string;
  /** Identifies the user holds a license */
  holdsLicense?: boolean;
  /** IB's nationality */
  nationality?: string;
  /** Indicates this is a reapplication for a rejected IB user */
  reapply?: boolean;
  /** IB's type */
  type?: IBUserDetailsType;
};

export type MAMQualificationForm = {
  /**
     * User's company name
     * @maxLength 250
     */
  companyName: string;
  /**
     * The country most of partner's client referrals will come from
     * @maxLength 250
     */
  countryOfClients: string;
  /**
     * User's email
     * @maxLength 250
     */
  email: string;
  /**
     * User's first name
     * @maxLength 250
     */
  firstName: string;
  /**
     * Initial investment amount and currency
     * @maxLength 250
     */
  initialInvestmentAmountAndCurrency: string;
  /**
     * User's last name
     * @maxLength 250
     */
  lastName: string;
  /** Number of clients the partner expects to refer each month */
  numberOfClients: number;
  /**
     * User's phone number
     * @maxLength 250
     */
  phone: string;
  /**
     * Partner's website
     * @maxLength 250
     */
  website?: string;
};

export type MAMUser = {
  /** Identifies the user has trading experience */
  hasTradingExperience?: boolean;
  /** Identifies the user holds a license */
  holdsLicense?: boolean;
  /** MAM qualification form answers */
  mamQualificationForm?: MAMQualificationForm;
};

/**
 * Triaged partner type
 */
export type TriagePartnerType = typeof TriagePartnerType[keyof typeof TriagePartnerType];


export const TriagePartnerType = {
  affiliate: 'affiliate',
  IB: 'IB',
  MAM: 'MAM',
  restrictedCountryUser: 'restrictedCountryUser',
} as const;

export type RestrictedCountryUser = {
  /**
     * The country most of partner's client referrals will come from
     * @maxLength 250
     */
  countryOfReferrals: string;
  /**
     * Restricted country user's name
     * @maxLength 250
     */
  name: string;
  /** Number of clients the partner expects to refer each month? */
  numberOfClients: number;
  /**
     * Partner's website
     * @maxLength 250
     */
  website?: string;
};

export type TriageStatus = typeof TriageStatus[keyof typeof TriageStatus];


export const TriageStatus = {
  STARTED: 'STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
} as const;

export type Triage = {
  affiliateUserDetails?: AffiliateUserDetails;
  /** Triaged partner's country of operation */
  countryOfOperation: string;
  ibUserDetails?: IBUserDetails;
  mamUser?: MAMUser;
  /** Triaged partner type */
  partnerType: TriagePartnerType;
  restrictedCountryUser?: RestrictedCountryUser;
  status?: TriageStatus;
};

export type GetTriageListOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  details: Triage;
  /** The status of the triage */
  status: GetTriageListOutputBodyStatus;
  triageID: string;
};

export type VolumeUnitOption = {
  /** USD value of one lot of the symbol, from end-of-day rates */
  perLotUsd: number;
  /** Symbol ticker, e.g. XAUUSD */
  symbol: string;
};

export type GetVolumeUnitsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * USD value of one lot for each supported symbol, in display order
     * @nullable
     */
  options: VolumeUnitOption[] | null;
  /** When the end-of-day rates used took effect, in UTC: 17:15 New York time on their trading day. May be an earlier day than the latest when that day has no data */
  rateDate: string;
};

export type Stat = {
  /** Change in percent of the stat */
  changeInPercent?: number;
  /** Error message if any */
  error?: string;
  /** Unit of stat */
  unit?: string;
  /** Value of the	stat */
  value?: number;
};

export type HeadlineMetrics = {
  approved: Stat;
  onboarding: Stat;
  profileCreated: Stat;
};

export type HealthcheckOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** API is up */
  api: boolean;
};

/**
 * UI language active when the registration was submitted; one of the portal translation locales
 */
export type IBRegistrationInputBodyLang = typeof IBRegistrationInputBodyLang[keyof typeof IBRegistrationInputBodyLang];


export const IBRegistrationInputBodyLang = {
  ar: 'ar',
  en: 'en',
  'es-419': 'es-419',
  id: 'id',
  mn: 'mn',
  'pt-BR': 'pt-BR',
  th: 'th',
  vi: 'vi',
  zh: 'zh',
  'zh-TW': 'zh-TW',
} as const;

export type IBRegistrationInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Confirms the user has agreed to the policy */
  agreedToIBTerms?: boolean;
  /** Confirms the user wants to receive updates */
  agreedToReceiveUpdate?: boolean;
  chineseName?: string;
  dateOfBirth?: string;
  firstName: string;
  /** Confirms the user is a non-US citizen */
  isNotUSTaxResident?: boolean;
  /** UI language active when the registration was submitted; one of the portal translation locales */
  lang?: IBRegistrationInputBodyLang;
  lastName: string;
  /** Optional desired IB license code; forwarded to SCA when set */
  license?: string;
  phoneCountryCode: string;
  phoneNumber: string;
  preferredRebateCurrency?: string;
  title?: string;
  triageID: string;
};

export type IBRegistrationOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Process Status */
  processStatus: string;
  /** The SCA User ID created during registration */
  scaUserID: string;
  /** Process timestamp */
  timestamp?: string;
  triageID: string;
};

export type InstrumentBarChartData = {
  clientCount: number;
  instrumentType: string;
  totalVolume: number;
  totalVolumeUSD: number;
};

/**
 * Status of the KYC applicant
 */
export type KYCApplicantResponseStatus = typeof KYCApplicantResponseStatus[keyof typeof KYCApplicantResponseStatus];


export const KYCApplicantResponseStatus = {
  applicantCreated: 'applicantCreated',
  applicantPending: 'applicantPending',
  applicantApproved: 'applicantApproved',
  applicantOnHold: 'applicantOnHold',
  applicantRejected: 'applicantRejected',
  applicantResubmissionRequested: 'applicantResubmissionRequested',
  applicantReset: 'applicantReset',
} as const;

export type KYCApplicantResponse = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  applicantId: string;
  /** Status of the KYC applicant */
  status: KYCApplicantResponseStatus;
};

export type KYCSessionResponse = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  token: string;
  userId: string;
};

export type LabgroupRegistrationLinkBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** The LabGroup registration link */
  registrationLink: string;
};

export type LadderTier = {
  /** Active-clients target, if this region tracks it */
  ac?: number;
  /** Tier slug, lowercase tier name */
  key: string;
  /** New-clients target, if this region tracks it */
  nc?: number;
  /** Tier rank, matches /me.tierRank */
  rank: number;
  /** Rebate default set ID for this tier, accepted by GET /v1/rebate-tiers/rebate-details; omitted when the tier has no valid set */
  rebateDefaultSetId?: number;
  /** Trading-volume target (USD), if this region tracks it */
  tv?: number;
};

export type LeadOutputMetadata = {
  /** Current page number (1-based) */
  currentPage?: number;
  /** Number of records per page */
  pageSize?: number;
  /**
     * Fields that are redacted due to privacy concerns.
     * @nullable
     */
  redactedFields?: string[] | null;
  /** Total number of records */
  totalCount?: number;
};

export type LeadStatusCount = {
  /** Number of leads with this status */
  count: number;
  /** Lead status (frontend enum value) */
  status: string;
};

/**
 * Lead's status
 */
export type LeadV2Status = typeof LeadV2Status[keyof typeof LeadV2Status];


export const LeadV2Status = {
  Approved: 'Approved',
  Unknown: 'Unknown',
  IncompleteProfile: 'IncompleteProfile',
  CompletingProfile: 'CompletingProfile',
  ReviewingSuitability: 'ReviewingSuitability',
  IdentifyVerification: 'IdentifyVerification',
  VerifyingIdentity: 'VerifyingIdentity',
} as const;

export type LeadV2 = {
  /** Lead's client ID */
  clientId: string;
  /** Lead's country code */
  countryCode: string;
  /** Lead created time in milliseconds since epoch */
  createdAt: number;
  /** Lead's email */
  email: string;
  /** Lead's name */
  name: string;
  /** Lead's raw status from source, used to map to frontend status */
  rawStatus: string;
  /** Lead's status */
  status: LeadV2Status;
};

export type LeadsData = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  leads: LeadV2[] | null;
  metadata: LeadOutputMetadata;
};

export type LeadsFilters = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Distinct country codes present in the partner's leads
     * @nullable
     */
  countryCodes: string[] | null;
  /**
     * Available lead statuses and their counts
     * @nullable
     */
  statuses: LeadStatusCount[] | null;
};

export type LeadsStatsOutputBodyV2 = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  headlineMetrics: HeadlineMetrics;
};

export type LocateMarketingBannerOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** 1-based page the banner falls on; 0 when not found / not the caller's. */
  page: number;
};

export type MarketingAsset = {
  campaignId: string;
  code: string;
  display: string;
  filename: string;
  height: string;
  id: string;
  isPrivate: string;
  language: string;
  status: string;
  thumbnail: string;
  type: string;
  url: string;
  width: string;
};

export type MarketingBannerCampaignOption = {
  id: number;
  name: string;
};

export type MarketingBannersFilterOptionsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Distinct banner_group values from the calling partner's marketing banners, alphabetically sorted.
     * @nullable
     */
  bannerGroups: string[] | null;
  /**
     * The partner's campaigns (default campaign first, then alphabetical).
     * @nullable
     */
  campaigns: MarketingBannerCampaignOption[] | null;
  /**
     * Distinct language codes from the calling partner's marketing banners, alphabetically sorted.
     * @nullable
     */
  languages: string[] | null;
  /**
     * Distinct rebate program identifiers (Referral.Offers_ID) used by the calling partner's marketing banners, alphabetically sorted.
     * @nullable
     */
  rebatePrograms: string[] | null;
  /**
     * Distinct banner sizes ("<width>x<height>") from the calling partner's marketing banners, sorted by width then height.
     * @nullable
     */
  sizes: string[] | null;
};

export type MarketingCampaign = {
  description: string;
  featured: string;
  id: string;
  name: string;
  previewUrl: string;
  status: string;
};

export type MarketingOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  marketingAssets: MarketingAsset[] | null;
  /** @nullable */
  marketingCampaigns: MarketingCampaign[] | null;
};

export type MasterStatus = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Number of non-archived shared rebate programs currently owned by this Master. */
  activeRebatePrograms: number;
  /** True when the Master's effective tier in v_partner_tier_summary has a default_set_id that is a whole number from 1 to 4294967295, the same rule rebate program creation applies. False when the Master has no row in the view. */
  hasDefaultSetId: boolean;
  /** True when the caller has at least one RebateAccount with LifeCycleState = 'Enabled' and Enabled = true. */
  hasRebateAccount: boolean;
  /** The Master's own rebate account login (SCAMT4Account_ID), the most recently created enabled one, that a newly created program's earnings are paid to. Absent when HasRebateAccount is false. */
  latestRebateAccount?: string;
  /** Maximum non-archived shared rebate programs this Master may own, from ib_eligibility.configs.master.max_rebate_programs. */
  maxRebatePrograms: number;
  /** Number of shared rebate programs owned by this Master, counting archived programs as well as active ones. */
  totalRebatePrograms: number;
};

export type MaxRebateTier = {
  /** Whether the tier is exclusive (non-standard) */
  isExclusive: boolean;
  /** Tier slug, lowercase tier name; matches /v1/rebate-tiers/ladder tiers[].key */
  key: string;
  /**
     * Maximum rebate per lot, in the body's currency, for this tier's GRS default set; null when unavailable
     * @nullable
     */
  maxRebatePerLot: number | null;
  /** Tier rank; matches /v1/rebate-tiers/ladder tiers[].rank and /v1/rebate-tiers/me tierRank */
  rank: number;
  /** Rebate default set ID for this tier; omitted when the tier has no valid set */
  rebateDefaultSetId?: number;
};

export type MaxRebatePerLotOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Currency every tiers[].maxRebatePerLot is in: the partner's latest rebate account currency, USD when unavailable */
  currency: string;
  /**
     * Every tier in the caller's region, exclusive tiers included, ordered low to high by rank
     * @nullable
     */
  tiers: MaxRebateTier[] | null;
};

export type OfferProgram = {
  currency: string;
  hoid: string;
  rebateAccount: string;
};

export type OfferURL = {
  id: string;
  name: string;
  previewUrl: string;
};

export type OnboardingStatusBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Dashboard Setup Process Status */
  dashboardSetupProcess: string;
  /** Rebate Account Process Status */
  rebateAccountProcess: string;
  /** Referral Link Process Status */
  referralLinkProcess: string;
  /** The triage ID */
  triageID: string;
  /** User Profile Process Status */
  userProfileProcess: string;
};

export type TargetPage = {
  id: string;
  name: string;
  /** @nullable */
  offerUrls: OfferURL[] | null;
};

export type OutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  targetPages: TargetPage[] | null;
};

export type OutputOverviewMetadataV2 = {
  /**
     * Fields that are redacted due to privacy concerns.
     * @nullable
     */
  redactedFields?: string[] | null;
};

export type TotalStats = {
  activeClients: Stat;
  approvedNotFunded: Stat;
  clients: Stat;
  earnings: Stat;
  fundedNotTraded: Stat;
};

export type OverviewOutputBodyV2 = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Error message if any */
  error?: string;
  metadata: OutputOverviewMetadataV2;
  /** @nullable */
  newClients: ClientV2[] | null;
  /** @nullable */
  recentLeads: LeadV2[] | null;
  /** @nullable */
  topEarners: Client[] | null;
  totalStats: TotalStats;
};

export type PatchRebateTierInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Volume unit to save as the partner's default: USD or one of the volume converter's lot symbols
     * @minLength 1
     */
  defaultVolumeUnit: string;
};

/**
 * Triaged partner type
 */
export type PatchTriageInputBodyPartnerType = typeof PatchTriageInputBodyPartnerType[keyof typeof PatchTriageInputBodyPartnerType];


export const PatchTriageInputBodyPartnerType = {
  affiliate: 'affiliate',
  IB: 'IB',
  MAM: 'MAM',
  restrictedCountryUser: 'restrictedCountryUser',
} as const;

export type PatchTriageInputBodyStatus = typeof PatchTriageInputBodyStatus[keyof typeof PatchTriageInputBodyStatus];


export const PatchTriageInputBodyStatus = {
  STARTED: 'STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
} as const;

export type PatchTriageInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  affiliateUserDetails?: AffiliateUserDetails;
  /** Triaged partner's country of operation */
  countryOfOperation?: string;
  ibUserDetails?: IBUserDetails;
  mamUser?: MAMUser;
  /** Triaged partner type */
  partnerType?: PatchTriageInputBodyPartnerType;
  restrictedCountryUser?: RestrictedCountryUser;
  status?: PatchTriageInputBodyStatus;
};

export type PerformanceOutput = {
  /** Distinct trading accounts under this program within the date range. */
  clientAccounts: number;
  /** Distinct clients who traded under this program within the date range. */
  clients: number;
  /** Sum of all Subs' payouts for this program within the date range. */
  subIbPayout: number;
  /** Sum of all earnings (Master + Sub shares) for this program within the date range. */
  totalEarning: number;
  /** Trading volume in USD, for this program within the date range. */
  tradingVolume: number;
  /** Master's own payout for this program within the date range. */
  yourPayout: number;
};

export type PerformanceReportFilterOptionsBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Distinct banner groups from the calling IB's marketing banners.
     * @nullable
     */
  bannerGroups: FilterOption[] | null;
  /**
     * Distinct countries from the calling IB's TUNE performance data. value=ISO code, label=country name.
     * @nullable
     */
  countries: FilterOption[] | null;
  /**
     * Distinct landing pages from the calling IB's referral links. value=tune_landing_page_id, label=name.
     * @nullable
     */
  landingPages: FilterOption[] | null;
  /**
     * Distinct rebate programs (HOIDs) from the calling IB's referral links and marketing banners. value=HOID, label="HOID {id}".
     * @nullable
     */
  rebatePrograms: FilterOption[] | null;
  /**
     * Available source types (static: Links, Banners).
     * @nullable
     */
  sourceTypes: FilterOption[] | null;
};

export type PerformanceReportPagination = {
  /** Current page (1-based). */
  page: number;
  /** Rows per page. */
  pageSize: number;
  /** Total matching rows across all pages. */
  total: number;
};

export type PerformanceReportRow = {
  /** Approved clients. */
  approved: number;
  /** Marketing banner format/type (source tab, banners only). */
  bannerType?: string;
  /** Clicks. */
  clicks: number;
  /** ISO country code (country tab). */
  code?: string;
  /** Click-to-approved conversion rate (percentage), computed as 100 * approved / clicks. */
  conversionApproved: number;
  /** Click-to-funded conversion rate (percentage), computed as 100 * funded / clicks. */
  conversionFunded: number;
  /** Click-to-registration conversion rate (percentage), computed as 100 * registrations / clicks. */
  conversionRegistration: number;
  /** Click-to-traded conversion rate (percentage), computed as 100 * traded / clicks. */
  conversionTraded: number;
  /** Raw banner creative HTML/code used to render the preview (source tab, banners only). */
  creativeCode?: string;
  /** Earnings in USD. */
  earnings: number;
  /** Funded clients. */
  funded: number;
  /** Banner group (source tab, banners only). */
  group?: string;
  /** Banner height in pixels (source tab, banners only). */
  height?: number;
  /** Rebate program HOID (rebate tab, and source rows where known). */
  hoid?: string;
  /** Impressions aggregated for the row. */
  impressions: number;
  /** Whether this referral link is the partner's default link (source tab, links only; always false for banner, country and rebate rows). */
  isDefault: boolean;
  /** Configured language of the link/banner (source tab). */
  language?: string;
  /** Primary display label for the dimension. */
  name: string;
  /** Landing page name (source tab, links only). */
  page?: string;
  /** Commercial region the country belongs to, e.g. APAC or EEA (country tab). */
  region?: string;
  /** Registrations. */
  registration: number;
  /** Stable label used for dimension-column sorting. */
  sortName: string;
  /** Traded clients. */
  traded: number;
  /** Row dimension type: link, banner (source tab), country, or plan (rebate tab). */
  type: string;
  /** Referral base URL (source tab, links only). */
  url?: string;
  /** Trading volume in USD. */
  volume: number;
  /** Banner width in pixels (source tab, banners only). */
  width?: number;
};

export type PerformanceReportStats = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  activeClients: number;
  clicks: number;
  earnings: number;
  registration: number;
  tradingVolume: number;
};

export type PerformanceReportTableBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Paging info and total matching row count. */
  pagination: PerformanceReportPagination;
  /**
     * Table rows for the current page.
     * @nullable
     */
  rows: PerformanceReportRow[] | null;
};

export type PostTriageInputBodyPartnerType = typeof PostTriageInputBodyPartnerType[keyof typeof PostTriageInputBodyPartnerType];


export const PostTriageInputBodyPartnerType = {
  IB: 'IB',
  Affiliate: 'Affiliate',
  MAM: 'MAM',
  RestrictedCountry: 'RestrictedCountry',
} as const;

export type PostTriageInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  partnerType?: PostTriageInputBodyPartnerType;
};

/**
 * UI language; one of the portal translation locales
 */
export type PreferencesLanguage = typeof PreferencesLanguage[keyof typeof PreferencesLanguage];


export const PreferencesLanguage = {
  ar: 'ar',
  en: 'en',
  'es-419': 'es-419',
  id: 'id',
  mn: 'mn',
  'pt-BR': 'pt-BR',
  th: 'th',
  vi: 'vi',
  zh: 'zh',
  'zh-TW': 'zh-TW',
} as const;

export type Preferences = {
  /** UI language; one of the portal translation locales */
  language: PreferencesLanguage;
};

export type ProcessReapplicationOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** User-friendly message about the result */
  message: string;
};

/**
 * Whether this party is the Master or a Sub IB.
 */
export type SplitOverridePartyEntryRole = typeof SplitOverridePartyEntryRole[keyof typeof SplitOverridePartyEntryRole];


export const SplitOverridePartyEntryRole = {
  master: 'master',
  subIb: 'subIb',
} as const;

export type SplitOverridePartyEntry = {
  /** Display name of the party -- "You" for the authenticated Master, the Sub's masked name otherwise. */
  party: string;
  /** This party's share percentage under this override rule. */
  pct: number;
  /** Whether this party is the Master or a Sub IB. */
  role: SplitOverridePartyEntryRole;
};

/**
 * Whether this override rule applies to a specific symbol or an entire asset class.
 */
export type RebateSplitOverrideRuleScope = typeof RebateSplitOverrideRuleScope[keyof typeof RebateSplitOverrideRuleScope];


export const RebateSplitOverrideRuleScope = {
  symbol: 'symbol',
  assetClass: 'assetClass',
} as const;

export type RebateSplitOverrideRule = {
  /** The symbol (e.g. "XAUUSD") or asset class (e.g. "Commodities") this override rule applies to. */
  label: string;
  /** @nullable */
  parties: SplitOverridePartyEntry[] | null;
  /** Whether this override rule applies to a specific symbol or an entire asset class. */
  scope: RebateSplitOverrideRuleScope;
};

/**
 * Whether this party is the Master or a Sub IB.
 */
export type RebateSplitPayoutEntryRole = typeof RebateSplitPayoutEntryRole[keyof typeof RebateSplitPayoutEntryRole];


export const RebateSplitPayoutEntryRole = {
  master: 'master',
  subIb: 'subIb',
} as const;

export type RebateSplitPayoutEntry = {
  /** Display name of the party -- "You" for the authenticated Master, the Sub's masked name otherwise. */
  party: string;
  /** This party's payout for this program within the date range. */
  payout: number;
  /** This party's share percentage. */
  pct: number;
  /** Whether this party is the Master or a Sub IB. */
  role: RebateSplitPayoutEntryRole;
  /** The Sub IB's IB id (UUID), matching the rebate-programs list endpoint's partners[].subIbId. Omitted for the Master's own (role=master) entry. */
  subIbId?: string;
};

export type ProgramDetail = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  performance: PerformanceOutput;
  /** @nullable */
  rebateSplitOverride: RebateSplitOverrideRule[] | null;
  /** @nullable */
  rebateSplitPayout: RebateSplitPayoutEntry[] | null;
};

/**
 * Type of question input
 */
export type QuestionType = typeof QuestionType[keyof typeof QuestionType];


export const QuestionType = {
  text: 'text',
  checkbox: 'checkbox',
  dropdown: 'dropdown',
  radio: 'radio',
} as const;

export type QuestionDependency = {
  /** Slug of the question this one depends on */
  slug: string;
  /** Value that triggers this question to be shown */
  value: string;
};

export type QuestionExtra = {
  /** Dependency condition for displaying the question */
  dependency?: QuestionDependency;
  /** Translation key for help text */
  helpText?: string;
  /** Maximum length for text input */
  maxLength?: number;
  /** Minimum number of selections for checkbox */
  minSelections?: number;
  /** Translation key for placeholder text */
  placeholder?: string;
  /** Whether the question is only shown during reapplication flow */
  reapplyOnly?: boolean;
  /** Whether the question is required */
  required?: boolean;
};

export type QuestionOption = {
  /** Translation key for the option title */
  title: string;
  /** Value to be submitted for this option */
  value: string;
};

export type Question = {
  /** Additional metadata for the question */
  extra: QuestionExtra;
  /**
     * Available options for the question
     * @nullable
     */
  options: QuestionOption[] | null;
  /** Order of the question within the step */
  order: number;
  /** Translation key for the question text */
  question: string;
  /** Unique slug for the question */
  slug: string;
  /** Step number in the questionnaire flow */
  step: number;
  /** Type of question input */
  type: QuestionType;
};

export type QuestionsResponse = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * List of questionnaire questions
     * @nullable
     */
  questions: Question[] | null;
};

export type RateOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Raw response from Pepperstone rate API */
  rate: unknown;
};

export type RebateAccount = {
  /** The account balance */
  accountBalance?: number;
  /** Account name */
  accountName: string;
  /** Currency code */
  currencyCode?: string;
  /** ID */
  id: string;
  /** SCAMT4Account ID */
  scaMT4AccountID: string;
};

export type RebateAccountOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  listRebateAccount: RebateAccount[] | null;
};

export type RebateProgram = {
  /** Rebate program ID */
  id: string;
  /** Offer ID linked to this rebate program, matching a client's hasOfferID */
  offerID: string;
};

export type RebateProgramOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** @nullable */
  listRebateProgram: RebateProgram[] | null;
};

export type RebateTierLadderOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Criteria types this region tracks: tv, ac, nc
     * @nullable
     */
  criteria: string[] | null;
  /** The partner's latest rebate account currency, USD when unavailable; omitted when the ladder has no tiers */
  currency?: string;
  /**
     * Tiers ordered low to high by rank
     * @nullable
     */
  tiers: LadderTier[] | null;
};

export type RebateTierOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Current 3-month active clients, null if the region doesn't track this criterion
     * @nullable
     */
  activeClients: number | null;
  /**
     * Per-month breakdown for each criterion applicable to the partner's region, trailing 3 months
     * @nullable
     */
  criteriaProgress: CriteriaProgressEntry[] | null;
  /**
     * The partner's latest rebate account currency, USD when unavailable; null when the partner has no tier record
     * @nullable
     */
  currency: string | null;
  /**
     * Partner's saved default volume unit: USD or a lot symbol; null when never saved (the widget falls back to USD)
     * @nullable
     */
  defaultVolumeUnit: string | null;
  /** Partner total earning */
  earning: number;
  /** When the daily job last refreshed this partner's criteria progress; omitted when the partner has no criteria progress rows yet */
  evaluatedAt?: string;
  /**
     * Freeze period expiry, null if not frozen
     * @nullable
     */
  freezePeriodValidTo: string | null;
  /**
     * Grace period expiry, null if no grace period
     * @nullable
     */
  gracePeriodValidTo: string | null;
  /** Whether the current tier is exclusive (non-standard) */
  isExclusive: boolean;
  /** Whether the partner's currently-active grace period was assigned by jobs/ib-onboarding, as opposed to a manually granted maintain-grace. False when there is no active grace period at all — see gracePeriodValidTo for the expiry. */
  isOnboardingGrace: boolean;
  /** Whether the entire tier block should render; independent of tierStatus/frozen */
  isTierVisible: boolean;
  /** Whether the current tier is whitelisted */
  isTierWhitelisted: boolean;
  /** Internal partner tier record ID */
  partnerTierID: string;
  /** Qualified tier name */
  qualifiedTierName: string;
  /** Qualified tier rank */
  qualifiedTierRank: number;
  /** Partner region, used to index the tier ladder */
  region: string;
  /** Current tier name */
  tierName: string;
  /** Current tier rank */
  tierRank: number;
  /** Tier status: Fraudulent, Tier frozen, Maintaining, Upgrading */
  tierStatus: string;
  /** Trade volume in USD for criteria progress */
  tradeVolumeUSD: number;
};

export type RenameMarketingBannerInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * New name for the marketing banner
     * @minLength 1
     * @maxLength 255
     */
  name: string;
};

export type RenameReferralLinkInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * New name for the referral link
     * @minLength 1
     * @maxLength 60
     */
  name: string;
};

/**
 * Structured questionnaire answers
 */
export type SaveAnswersRequestAnswers = {[key: string]: unknown};

export type SaveAnswersRequest = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Structured questionnaire answers */
  answers: SaveAnswersRequestAnswers;
  /** License associated with the answers */
  license: string;
};

export type SaveAnswersResponse = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Success message */
  message?: string;
};

/**
 * Program status derived from archived_at.
 */
export type SharedRebateProgramStatus = typeof SharedRebateProgramStatus[keyof typeof SharedRebateProgramStatus];


export const SharedRebateProgramStatus = {
  active: 'active',
  archived: 'archived',
} as const;

/**
 * Participant role: master or subIb.
 */
export type SharedRebateProgramOverrideSplitRole = typeof SharedRebateProgramOverrideSplitRole[keyof typeof SharedRebateProgramOverrideSplitRole];


export const SharedRebateProgramOverrideSplitRole = {
  master: 'master',
  subIb: 'subIb',
} as const;

export type SharedRebateProgramOverrideSplit = {
  /** Masked Sub IB name; empty for the master row (FE renders "You"). */
  name?: string;
  /** This participant's override share percentage. */
  pct: number;
  /** Participant role: master or subIb. */
  role: SharedRebateProgramOverrideSplitRole;
  /** Sub IB's IB id (UUID); empty for the master row. */
  subIbId?: string;
};

export type SharedRebateProgramOverride = {
  /** The symbol (e.g. XAUUSD) or asset class (e.g. Commodities) the override applies to. */
  scope: string;
  /**
     * Per-participant split under this override.
     * @nullable
     */
  splits: SharedRebateProgramOverrideSplit[] | null;
};

/**
 * This Sub IB's own IB status: approved, rejected, or pendingKYC for anything not yet decided.
 */
export type SharedRebateProgramPartnerIbStatus = typeof SharedRebateProgramPartnerIbStatus[keyof typeof SharedRebateProgramPartnerIbStatus];


export const SharedRebateProgramPartnerIbStatus = {
  approved: 'approved',
  pendingKYC: 'pendingKYC',
  rejected: 'rejected',
} as const;

export type SharedRebateProgramPartner = {
  /** This Sub IB's own IB status: approved, rejected, or pendingKYC for anything not yet decided. */
  ibStatus: SharedRebateProgramPartnerIbStatus;
  /** Masked Sub IB display name (Phase 1 masking). */
  name: string;
  /**
     * ID of the Master's undismissed ib-status/IB_REJECTED notification for this Sub IB on this program; null when none exists. Dismiss it with PATCH /v1/notifications/{id}. The worker dismisses it once the Sub IB leaves the rejected status.
     * @nullable
     */
  rejectedNotificationId: string | null;
  /** This Sub IB's rebate share percentage for the program. */
  splitPct: number;
  /** Participating Sub IB's IB id (UUID). */
  subIbId: string;
};

export type SharedRebateProgram = {
  /** When the program was archived; null when active. */
  archivedAt?: string;
  /**
     * Per-asset-class rebate-split overrides (e.g. Commodities).
     * @nullable
     */
  assetOverrides: SharedRebateProgramOverride[] | null;
  /** Distinct trading accounts on the program (all-time, not date-scoped). */
  clientAccounts: number;
  /** When the program was created (drives the "New" badge). */
  createdAt: string;
  /** True when the program has any symbol- or asset-level split overrides. */
  hasOverrides: boolean;
  /** Program HOID (rebate_program.offer_id). */
  hoid: number;
  /**
     * Date of the most recent rebate payment (YYYY-MM-DD); null when none.
     * @nullable
     */
  lastPayment: string | null;
  /** The Master's own rebate share percentage. */
  masterSplitPct: number;
  /**
     * Sub IBs participating in this program.
     * @nullable
     */
  partners: SharedRebateProgramPartner[] | null;
  /** rebate_program.id. */
  programId: number;
  /** The Master's rebate account login for this program (where its payout is paid); empty when none. */
  rebateAccount: string;
  /** Display label, e.g. "HOID 9001". */
  rebateProgramLabel: string;
  /** Program referral tracking link. */
  referralLink: string;
  /** Program status derived from archived_at. */
  status: SharedRebateProgramStatus;
  /**
     * Per-symbol rebate-split overrides (e.g. XAUUSD).
     * @nullable
     */
  symbolOverrides: SharedRebateProgramOverride[] | null;
  /** Total earnings (Master + Sub shares) within the reporting date range (USD). */
  totalEarning: number;
  /** Distinct clients on the program (all-time, not date-scoped). */
  uniqueClients: number;
  /** The Master's own payout within the reporting date range (USD). */
  yourPayout: number;
};

export type SharedRebateProgramsFilterOption = {
  key?: string;
  label?: string;
  value: string;
};

export type SharedRebateProgramsFilterOptionsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Active/archived status options for the authenticated Master's shared rebate programs.
     * @nullable
     */
  statuses: SharedRebateProgramsFilterOption[] | null;
  /**
     * Distinct Sub IBs participating in the authenticated Master's shared rebate programs.
     * @nullable
     */
  subIbs: SharedRebateProgramsFilterOption[] | null;
};

export type SharedRebateProgramsListBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Current page (1-based). */
  currentPage: number;
  /** Rows per page. */
  pageSize: number;
  /**
     * Programs for the current page.
     * @nullable
     */
  sharedRebatePrograms: SharedRebateProgram[] | null;
  /** Total matching programs across all pages. */
  totalCount: number;
};

export type SharedRebateProgramsStats = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Count of programs with status = active for this Master. */
  activePrograms: number;
  /** Total trading accounts linked across all programs (active and archived). Not affected by the date range. */
  clientAccounts: number;
  /** Sum of all earnings (Master + Sub shares) across all programs within the date range. */
  totalEarning: number;
  /** Distinct clients, deduplicated across programs. Not affected by the date range. */
  uniqueClients: number;
  /** Master's own payout portion across all programs within the date range. */
  yourPayout: number;
};

/**
 * Resolved step-up authentication method
 */
export type StepUpMethodBodyMethod = typeof StepUpMethodBodyMethod[keyof typeof StepUpMethodBodyMethod];


export const StepUpMethodBodyMethod = {
  MFA: 'MFA',
  EMAIL: 'EMAIL',
} as const;

export type StepUpMethodBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Resolved step-up authentication method */
  method: StepUpMethodBodyMethod;
  /** True only when method=EMAIL and the user's email is not yet verified */
  requiresEmailVerification: boolean;
};

export type SubIB = {
  /** The Sub IB's masked full name. Empty when the Sub IB has no profile name. */
  name: string;
  /** The Sub IB's IB.ID. */
  subIbId: string;
};

export type SubIBList = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * The Sub IBs sharing a rebate program with the authenticated IB.
     * @nullable
     */
  listSubIBs: SubIB[] | null;
};

export type SubIBLookup = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Count of active shared rebate programs between this Master and the Sub IB. */
  activePrograms: number;
  /** The matched Sub IB's email. */
  email: string;
  /** The matched Sub IB's IB.ID (UUID). */
  ibID: string;
  /** Masked partner name (e.g. "L***s B****r"). */
  name: string;
  /** True when the matched Sub IB has registered but is not yet approved (KYC, questionnaire or Ops sign-off outstanding). */
  pendingKYC: boolean;
  /** Count of all (active + archived) shared rebate programs between this Master and the Sub IB. */
  totalPrograms: number;
};

export type SubProgram = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Whether the IB is a Sub IB in at least one rebate program, including closed ones. False when the user has no IB */
  hasSubProgram: boolean;
};

export type SubmitQuestionnairePayload = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Agree accuracy verification (0/1)
     * @nullable
     */
  agreeAccuracyVerification: string | null;
  /**
     * Agree terms and conditions (0/1)
     * @nullable
     */
  agreeTermsAndConditions: string | null;
  /** Whether this submission is part of the reapplication flow */
  isReapply?: boolean;
  /** License associated with the answers */
  license: string;
};

/**
 * Structured questionnaire answers
 */
export type TestSaveAndSubmitRequestAnswers = {[key: string]: unknown};

export type TestSaveAndSubmitRequest = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /**
     * Agree accuracy verification (0/1)
     * @nullable
     */
  agreeAccuracyVerification: string | null;
  /**
     * Agree terms and conditions (0/1)
     * @nullable
     */
  agreeTermsAndConditions: string | null;
  /** Structured questionnaire answers */
  answers: TestSaveAndSubmitRequestAnswers;
  /** License associated with the answers */
  license: string;
  /** SCA User ID to save answers for */
  scaUserId: string;
};

export type TodayStats = {
  amount: number;
  changeType: string;
  percent: number;
};

export type VolumeMetric = {
  currencyCode: string;
  total: number;
  /** @nullable */
  tradedSymbols: TradedSymbol[] | null;
};

export type VolumeTraded = {
  currency: VolumeMetric;
  lots: VolumeMetric;
};

export type TradingMetric = {
  /** @nullable */
  data: DataPoint[] | null;
  today: TodayStats;
  total: number;
};

export type TradingMetricData = {
  currencyCode: string;
  /** @nullable */
  data: DataPoint[] | null;
  today: TodayStats;
  total: number;
};

export type TradingVolume = {
  lots: TradingMetricData;
  usd: TradingMetricData;
};

export type TradingMetrics = {
  clients: TradingMetric;
  volume: TradingVolume;
};

export type TradingGraphs = {
  totalByClients: ByClients;
  totalVolumeTraded: VolumeTraded;
  tradingBy: TradingMetrics;
};

export type TradingReport = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  graphsData?: TradingGraphs;
  metadata: ClientOutputMetadata;
  /** @nullable */
  tradingList: Client[] | null;
};

export type TradingReportStatsOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  graphsData: TradingGraphs;
  /** @nullable */
  instrumentsData: InstrumentBarChartData[] | null;
};

export type TradingReportV3 = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  metadata: ClientOutputMetadata;
  /** @nullable */
  tradingList: ClientV3[] | null;
};

export type TriageOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  triageID: string;
};

/**
 * Action to apply to the notification. Only dismiss is supported.
 */
export type UpdateNotificationInputBodyType = typeof UpdateNotificationInputBodyType[keyof typeof UpdateNotificationInputBodyType];


export const UpdateNotificationInputBodyType = {
  dismiss: 'dismiss',
} as const;

export type UpdateNotificationInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Action to apply to the notification. Only dismiss is supported. */
  type: UpdateNotificationInputBodyType;
};

/**
 * UI language; one of the portal translation locales
 */
export type UserPreferencesInputBodyLanguage = typeof UserPreferencesInputBodyLanguage[keyof typeof UserPreferencesInputBodyLanguage];


export const UserPreferencesInputBodyLanguage = {
  ar: 'ar',
  en: 'en',
  'es-419': 'es-419',
  id: 'id',
  mn: 'mn',
  'pt-BR': 'pt-BR',
  th: 'th',
  vi: 'vi',
  zh: 'zh',
  'zh-TW': 'zh-TW',
} as const;

export type UserPreferencesInputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** UI language; one of the portal translation locales */
  language: UserPreferencesInputBodyLanguage;
};

/**
 * User license
 */
export type UserProfileLicense = typeof UserProfileLicense[keyof typeof UserProfileLicense];


export const UserProfileLicense = {
  asic: 'asic',
  cma: 'cma',
  dfsa: 'dfsa',
  sca: 'sca',
  scb: 'scb',
  fca: 'fca',
  cysec: 'cysec',
  bafin: 'bafin',
  fsc: 'fsc',
} as const;

/**
 * User onboarding state
 */
export type UserProfileOnboardingState = typeof UserProfileOnboardingState[keyof typeof UserProfileOnboardingState];


export const UserProfileOnboardingState = {
  OnlyAuth0Created: 'OnlyAuth0Created',
  OnlySignedUp: 'OnlySignedUp',
  IBApplicationNotComplete: 'IBApplicationNotComplete',
  IBApplicationComplete: 'IBApplicationComplete',
} as const;

export type UserProfile = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** User's Chinese name */
  chineseName?: string;
  /** User's country */
  country?: string;
  /** User's date of birth */
  dateOfBirth?: string;
  /** User's first name */
  firstName: string;
  /** Whether the user's IB is a Sub IB in at least one rebate program, including closed ones. Absent when the user has no IB */
  hasSubProgram?: boolean;
  /** Flag indicating if the user's IB application was made editable */
  isEditable: boolean;
  /** Flag indicating if the user is an individual trader */
  isIndividualTrader?: boolean;
  /** Flag indicating if the User has MAM account */
  isMAMMaster: boolean;
  /** Flag indicating if the User is coming from new onboarding flow */
  isQuickStart: boolean;
  /** Flag indicating if the user's IB application was rejected */
  isRejected: boolean;
  /** User's last name */
  lastName: string;
  /** User license */
  license: UserProfileLicense;
  /** User's first name. Chinese name instead, if present */
  name: string;
  /** User onboarding state */
  onboardingState: UserProfileOnboardingState;
  /** User's phone number */
  phone?: string;
  preferences?: Preferences;
  /** User's referral link */
  referralLink: string;
  /** Flag indicating if the user is flagged for review, which locks rebate withdrawals and transfers */
  riskFlag?: boolean;
  /** User's title */
  title?: string;
  /** Cloudfront geolocation of the user */
  viewerCountry: string;
};

/**
 * Confirms the verification email was sent
 */
export type VerifyEmailOutputBodyStatus = typeof VerifyEmailOutputBodyStatus[keyof typeof VerifyEmailOutputBodyStatus];


export const VerifyEmailOutputBodyStatus = {
  SENT: 'SENT',
} as const;

export type VerifyEmailOutputBody = {
  /** A URL to the JSON Schema for this object. */
  readonly $schema?: string;
  /** Confirms the verification email was sent */
  status: VerifyEmailOutputBodyStatus;
};

export type GetEarningsHeaders = {
Authorization?: string;
};

export type InitiateIbRegistrationHeaders = {
Authorization?: string;
};

export type GetMarketingAssetsParams = {
affiliateID?: string;
};

export type GetCreativeCodeParams = {
offerFileID?: string;
affiliateID?: string;
};

export type GetLabgroupRegistrationLinkHeaders = {
Authorization?: string;
};

export type CreateSubIbsSharedDataExportParams = {
/**
 * ID of the Sub-IB to export data for
 */
subIBID: string;
/**
 * Start date for export (ISO 8601 format)
 */
dateFrom: string;
/**
 * End date for export (ISO 8601 format)
 */
dateTo: string;
/**
 * List of report types to include in the export
 * @minItems 1
 * @nullable
 */
reports: string[] | null;
/**
 * API version for the export format
 */
version: string;
};

export type FindLatestTriageParams = {
partnerType: FindLatestTriagePartnerType;
};

export type FindLatestTriagePartnerType = typeof FindLatestTriagePartnerType[keyof typeof FindLatestTriagePartnerType];


export const FindLatestTriagePartnerType = {
  IB: 'IB',
  affiliate: 'affiliate',
  MAM: 'MAM',
  restrictedCountryUser: 'restrictedCountryUser',
} as const;

export type GetTriagesParams = {
status?: GetTriagesStatus;
};

export type GetTriagesStatus = typeof GetTriagesStatus[keyof typeof GetTriagesStatus];


export const GetTriagesStatus = {
  started: 'started',
  complete: 'complete',
} as const;

export type GetUserHeaders = {
Authorization?: string;
'CloudFront-Viewer-Country'?: string;
};

export type GetCampaignsParams = {
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term applied to campaign name
 */
search?: string;
};

export type GetLandingPagesParams = {
HOID?: string;
};

export type GetReferralLinksParams = {
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term applied to referral link name, full link and short link
 */
search?: string;
/**
 * Sorting column for referral links (e.g. CreatedAt, Name, LinkType, ShortLink, OfferID, RebateProgram, LastClickedAt, Campaign)
 */
sortColumn?: string;
/**
 * Sort descending when true
 */
sortDesc?: boolean;
/**
 * Filter by language codes (ISO 639-1 lowercase)
 * @nullable
 */
languages?: string[] | null;
/**
 * Filter by destination page name
 * @nullable
 */
destinationPages?: string[] | null;
/**
 * Filter by platform (e.g. web, app)
 * @nullable
 */
platforms?: string[] | null;
/**
 * Filter by rebate program
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include links with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaignIds?: number[] | null;
/**
 * When true, returns only the default referral link
 */
isDefault?: boolean;
};

export type ExportReferralLinksParams = {
/**
 * Search term applied to referral link name, full link and short link
 */
search?: string;
/**
 * Sorting column for referral links (e.g. CreatedAt, Name, LinkType, ShortLink, RebateProgram, TuneLandingPageName, Campaign)
 */
sortColumn?: string;
/**
 * Sort descending when true
 */
sortDesc?: boolean;
/**
 * Filter by language codes (ISO 639-1 lowercase)
 * @nullable
 */
languages?: string[] | null;
/**
 * Filter by destination page name
 * @nullable
 */
destinationPages?: string[] | null;
/**
 * Filter by platform (e.g. web, app)
 * @nullable
 */
platforms?: string[] | null;
/**
 * Filter by rebate program
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include links with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaignIds?: number[] | null;
/**
 * IANA timezone (e.g. Asia/Bangkok) used to render the Created date; defaults to UTC.
 */
timezone?: string;
/**
 * Include the Campaign column; the client sends false when the campaigns feature flag is off.
 */
includeCampaign?: boolean;
/**
 * Include the Last Clicked column; gated by the lastClickInformation feature flag on the client.
 */
includeLastClicked?: boolean;
};

export type GetTargetPagesParams = {
HOID?: string;
};

export type GetMarketingBannersParams = {
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term applied to banner name.
 */
search?: string;
/**
 * Sorting column (name, bannerGroup, type, language, rebateProgram, createdAt, lastClickedAt, campaign)
 */
sortColumn?: string;
/**
 * Sort descending when true
 */
sortDesc?: boolean;
/**
 * Filter by banner group
 * @nullable
 */
bannerGroups?: string[] | null;
/**
 * Filter by language codes (ISO 639-1 lowercase)
 * @nullable
 */
languages?: string[] | null;
/**
 * Filter by banner size; each value is '<width>x<height>' (e.g. 728x90)
 * @nullable
 */
sizes?: string[] | null;
/**
 * Filter by banner type
 * @nullable
 */
types?: GetMarketingBannersTypesItem[] | null;
/**
 * Filter by rebate program
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include banners with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaignIds?: number[] | null;
};

export type GetMarketingBannersTypesItem = typeof GetMarketingBannersTypesItem[keyof typeof GetMarketingBannersTypesItem];


export const GetMarketingBannersTypesItem = {
  html_ad: 'html_ad',
  image_banner: 'image_banner',
} as const;

export type GetAffiliateApprovalStatusParams = {
/**
 * Tune offer ID.
 */
offer_id: string;
/**
 * Tune affiliate ID (HOID).
 */
affiliate_id: string;
};

export type GetBannerAssetsParams = {
/**
 * Filter by language codes (e.g. en, vi). Supports multiple values.
 * @nullable
 */
languages?: string[] | null;
/**
 * Filter by banner sizes in format widthxheight (e.g. 300x250, 728x90). Supports multiple values.
 * @nullable
 */
sizes?: string[] | null;
/**
 * Filter by asset type (e.g. html_ad, image_banner). If not provided, returns all types.
 */
type?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
};

export type DownloadBannerImageParams = {
/**
 * Tune offer ID the banner belongs to.
 */
offerID: string;
/**
 * Creative file ID (marketing_assets.file_id) of the banner image to download.
 */
creativeFileId: string;
};

export type ExportMarketingBannersParams = {
/**
 * Search term applied to banner name.
 */
search?: string;
/**
 * Sorting column (name, bannerGroup, type, language, rebateProgram, createdAt, campaign)
 */
sortColumn?: string;
/**
 * Sort descending when true
 */
sortDesc?: boolean;
/**
 * Filter by banner group
 * @nullable
 */
bannerGroups?: string[] | null;
/**
 * Filter by language codes (ISO 639-1 lowercase)
 * @nullable
 */
languages?: string[] | null;
/**
 * Filter by banner size; each value is '<width>x<height>' (e.g. 728x90)
 * @nullable
 */
sizes?: string[] | null;
/**
 * Filter by banner type
 * @nullable
 */
types?: ExportMarketingBannersTypesItem[] | null;
/**
 * Filter by rebate program
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include banners with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaignIds?: number[] | null;
/**
 * IANA timezone (e.g. Asia/Bangkok) used to render the Created date; defaults to UTC.
 */
timezone?: string;
/**
 * Include the Campaign column; the client sends false when the campaigns feature flag is off.
 */
includeCampaign?: boolean;
/**
 * Include the Last clicked column; gated by the lastClickInformation feature flag on the client.
 */
includeLastClicked?: boolean;
};

export type ExportMarketingBannersTypesItem = typeof ExportMarketingBannersTypesItem[keyof typeof ExportMarketingBannersTypesItem];


export const ExportMarketingBannersTypesItem = {
  html_ad: 'html_ad',
  image_banner: 'image_banner',
} as const;

export type LocateMarketingBannerParams = {
/**
 * Banner id to locate.
 */
id: string;
/**
 * Number of records per page.
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Sorting column, same set as the list endpoint.
 */
sortColumn?: string;
/**
 * Sort descending when true.
 */
sortDesc?: boolean;
};

export type GetRebateProgramsParams = {
/**
 * Start of reporting date range (ISO 8601, YYYY-MM-DD). Scopes totalEarning / yourPayout / partner payout.
 */
startDate: string;
/**
 * End of reporting date range (ISO 8601, YYYY-MM-DD), inclusive.
 */
endDate: string;
/**
 * Free-text search over the program HOID. Matches every program when omitted.
 */
search?: string;
/**
 * Filter by program status. Omit for all.
 * @nullable
 */
program_status?: GetRebateProgramsProgramStatusItem[] | null;
/**
 * Filter to programs including any of these participating Sub IB ids (UUID).
 * @nullable
 */
subIbs?: string[] | null;
/**
 * Sort column id; omit for the default sort.
 */
sortColumn?: GetRebateProgramsSortColumn;
/**
 * Sort descending when true, ascending when false.
 */
sortDesc?: boolean;
/**
 * Page number (1-based).
 * @minimum 1
 */
page?: number;
/**
 * Rows per page.
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
};

export type GetRebateProgramsProgramStatusItem = typeof GetRebateProgramsProgramStatusItem[keyof typeof GetRebateProgramsProgramStatusItem];


export const GetRebateProgramsProgramStatusItem = {
  active: 'active',
  archived: 'archived',
} as const;

export type GetRebateProgramsSortColumn = typeof GetRebateProgramsSortColumn[keyof typeof GetRebateProgramsSortColumn];


export const GetRebateProgramsSortColumn = {
  rebateProgram: 'rebateProgram',
  subIbs: 'subIbs',
  rebateSplit: 'rebateSplit',
  lastPayment: 'lastPayment',
  totalEarning: 'totalEarning',
  yourPayout: 'yourPayout',
  clients: 'clients',
} as const;

export type CreateRebateProgramHeaders = {
/**
 * Bearer token for authentication
 */
Authorization?: string;
/**
 * Request origin, used as the program emails' portal link base
 */
Origin?: string;
};

export type ExportRebateProgramsParams = {
/**
 * Start of reporting date range (ISO 8601, YYYY-MM-DD). Scopes totalEarning / yourPayout / partner payout.
 */
startDate: string;
/**
 * End of reporting date range (ISO 8601, YYYY-MM-DD), inclusive.
 */
endDate: string;
/**
 * Free-text search over the program HOID. Matches every program when omitted.
 */
search?: string;
/**
 * Filter by program status. Omit for all.
 * @nullable
 */
program_status?: ExportRebateProgramsProgramStatusItem[] | null;
/**
 * Filter to programs including any of these participating Sub IB ids (UUID).
 * @nullable
 */
subIbs?: string[] | null;
/**
 * Sort column id; omit for the default sort.
 */
sortColumn?: ExportRebateProgramsSortColumn;
/**
 * Sort descending when true, ascending when false.
 */
sortDesc?: boolean;
};

export type ExportRebateProgramsProgramStatusItem = typeof ExportRebateProgramsProgramStatusItem[keyof typeof ExportRebateProgramsProgramStatusItem];


export const ExportRebateProgramsProgramStatusItem = {
  active: 'active',
  archived: 'archived',
} as const;

export type ExportRebateProgramsSortColumn = typeof ExportRebateProgramsSortColumn[keyof typeof ExportRebateProgramsSortColumn];


export const ExportRebateProgramsSortColumn = {
  rebateProgram: 'rebateProgram',
  subIbs: 'subIbs',
  rebateSplit: 'rebateSplit',
  lastPayment: 'lastPayment',
  totalEarning: 'totalEarning',
  yourPayout: 'yourPayout',
  clients: 'clients',
} as const;

export type GetRebateProgramsStatsParams = {
/**
 * Start of reporting date range (ISO 8601, YYYY-MM-DD).
 */
startDate: string;
/**
 * End of reporting date range (ISO 8601, YYYY-MM-DD), inclusive.
 */
endDate: string;
/**
 * Free-text search over the rebate program's HOID. Matches every program when omitted.
 */
search?: string;
/**
 * Filter by program status. Matches every status when omitted or both are given.
 * @nullable
 */
statuses?: GetRebateProgramsStatsStatusesItem[] | null;
/**
 * Filter to programs where any of these Sub IB.ID UUIDs participates. Matches every program when omitted.
 * @nullable
 */
subIbs?: string[] | null;
};

export type GetRebateProgramsStatsStatusesItem = typeof GetRebateProgramsStatsStatusesItem[keyof typeof GetRebateProgramsStatsStatusesItem];


export const GetRebateProgramsStatsStatusesItem = {
  active: 'active',
  archived: 'archived',
} as const;

export type GetRebateProgramDetailParams = {
/**
 * Start of reporting date range (ISO 8601, YYYY-MM-DD).
 */
startDate: string;
/**
 * End of reporting date range (ISO 8601, YYYY-MM-DD), inclusive.
 */
endDate: string;
};

export type ArchiveSharedRebateProgramHeaders = {
/**
 * Bearer token for authentication
 */
Authorization?: string;
/**
 * 2FA verification code
 */
'X-Verification-Code'?: string;
/**
 * Request origin, used as the closure email's portal link base
 */
Origin?: string;
};

export type GetSubIbLookupParams = {
/**
 * The email address to look up. Format is validated on the front end.
 */
email: string;
};

export type GetLatestNotificationParams = {
/**
 * Narrows the search to these notification types, as a comma-separated list. Considers every type when omitted. Values match activity_log.event_name so a notification can be correlated with its audit row, except TIER_AT_RISK, a forecast with no audit row. Note that filtering asks for the latest notification of those types, which is not the same as the partner's current state -- a freeze that has since been lifted still has the latest TF_ASSIGNED notification. Read current tier state from GET /v1/rebate-tiers/me.
 * @nullable
 */
type?: GetLatestNotificationTypeItem[] | null;
/**
 * Narrows the search to these domains, as a comma-separated list. Considers every domain when omitted.
 * @nullable
 */
domain?: GetLatestNotificationDomainItem[] | null;
};

export type GetLatestNotificationTypeItem = typeof GetLatestNotificationTypeItem[keyof typeof GetLatestNotificationTypeItem];


export const GetLatestNotificationTypeItem = {
  TIER_UPGRADED: 'TIER_UPGRADED',
  TIER_DOWNGRADED: 'TIER_DOWNGRADED',
  TIER_AT_RISK: 'TIER_AT_RISK',
  FP_EXPIRED: 'FP_EXPIRED',
  GP_ASSIGNED: 'GP_ASSIGNED',
  GP_EXPIRED: 'GP_EXPIRED',
  GP_EXTENDED: 'GP_EXTENDED',
  TF_ASSIGNED: 'TF_ASSIGNED',
  TF_EXTENDED: 'TF_EXTENDED',
  TF_UNASSIGNED: 'TF_UNASSIGNED',
} as const;

export type GetLatestNotificationDomainItem = typeof GetLatestNotificationDomainItem[keyof typeof GetLatestNotificationDomainItem];


export const GetLatestNotificationDomainItem = {
  'rebate-tier': 'rebate-tier',
} as const;

export type GetLatestNotificationHeaders = {
Authorization?: string;
};

export type UpdateNotificationHeaders = {
Authorization?: string;
};

export type GetPerformanceReportParams = {
/**
 * Grouping dimension (exactly one).
 */
tab?: GetPerformanceReportTab;
/**
 * Inclusive start date (YYYY-MM-DD).
 */
startDate?: string;
/**
 * Inclusive end date (YYYY-MM-DD).
 */
endDate?: string;
/**
 * Source-type filter: Links and/or Banners.
 * @nullable
 */
sourceTypes?: string[] | null;
/**
 * Landing page filter (tune_landing_page_id values).
 * @nullable
 */
landingPages?: string[] | null;
/**
 * Banner group filter.
 * @nullable
 */
bannerGroups?: string[] | null;
/**
 * Rebate program filter (HOID values).
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Country filter (ISO country codes).
 * @nullable
 */
countries?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include rows with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaigns?: number[] | null;
/**
 * Sort column id (matches a table column); omit for default sort.
 */
sortColumn?: string;
/**
 * Sort descending when true, ascending when false.
 */
sortDesc?: boolean;
/**
 * Page number (1-based).
 * @minimum 1
 */
page?: number;
/**
 * Rows per page.
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
};

export type GetPerformanceReportTab = typeof GetPerformanceReportTab[keyof typeof GetPerformanceReportTab];


export const GetPerformanceReportTab = {
  source: 'source',
  country: 'country',
  rebate: 'rebate',
  campaign: 'campaign',
} as const;

export type ExportPerformanceReportParams = {
/**
 * View tab: source, country, rebate or campaign. Determines the dimension column and grouping.
 */
tab?: ExportPerformanceReportTab;
/**
 * Inclusive start date (YYYY-MM-DD).
 */
startDate?: string;
/**
 * Inclusive end date (YYYY-MM-DD).
 */
endDate?: string;
/**
 * Source-type filter: Links and/or Banners.
 * @nullable
 */
sourceTypes?: string[] | null;
/**
 * Filter by landing page id.
 * @nullable
 */
landingPages?: string[] | null;
/**
 * Filter by banner group.
 * @nullable
 */
bannerGroups?: string[] | null;
/**
 * Filter by rebate program (HOID).
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Filter by ISO country code.
 * @nullable
 */
countries?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include rows with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaigns?: number[] | null;
/**
 * Sort column id (name, source, country, impressions, clicks, registration, approved, funded, traded, volume, earnings, cr_reg, cr_app, cr_funded, cr_traded); omit for default sort.
 */
sortColumn?: string;
/**
 * Sort descending when true.
 */
sortDesc?: boolean;
/**
 * Metric columns to include, matching the table's visible columns (impressions, clicks, registration, approved, funded, traded, cr_reg, cr_app, cr_funded, cr_traded, volume, earnings). Omit to export all columns, or pass 'none' to export only the dimension column when every metric column is hidden. Rendered in the table's canonical order regardless of the order supplied.
 * @nullable
 */
columns?: string[] | null;
};

export type ExportPerformanceReportTab = typeof ExportPerformanceReportTab[keyof typeof ExportPerformanceReportTab];


export const ExportPerformanceReportTab = {
  source: 'source',
  country: 'country',
  rebate: 'rebate',
  campaign: 'campaign',
} as const;

export type GetPerformanceReportStatsParams = {
/**
 * Start of the date range (YYYY-MM-DD, inclusive). Defaults to 30 days before 'endDate'.
 */
startDate?: string;
/**
 * End of the date range (YYYY-MM-DD, inclusive). Defaults to today (UTC).
 */
endDate?: string;
/**
 * Filter by MV source type (referral_link, marketing_banner).
 * @nullable
 */
sourceTypes?: string[] | null;
/**
 * Filter by specific referral link / banner id.
 * @nullable
 */
sourceIds?: string[] | null;
/**
 * Filter by ISO country code.
 * @nullable
 */
countries?: string[] | null;
/**
 * Filter by landing page id (tune_landing_page_id / offer_url_id).
 * @nullable
 */
landingPages?: string[] | null;
/**
 * Filter by banner group.
 * @nullable
 */
bannerGroups?: string[] | null;
/**
 * Filter by rebate program (HOID).
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include rows with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaigns?: number[] | null;
};

export type GetRebateTierLadderHeaders = {
Authorization?: string;
};

export type GetMaxRebatePerLotHeaders = {
Authorization?: string;
};

export type GetRebateTierHeaders = {
Authorization?: string;
};

export type PatchRebateTierHeaders = {
Authorization?: string;
};

export type GetRebateDetailsParams = {
/**
 * Default set ID to fetch rebate rates for
 * @minimum 1
 * @maximum 2147483647
 */
defaultSetId: number;
/**
 * Optional asset class filter, e.g. FX
 * @maxLength 50
 * @pattern ^[A-Za-z0-9]*$
 */
asset?: string;
};

export type GetRebateDetailsHeaders = {
Authorization?: string;
};

export type GetVolumeUnitsHeaders = {
Authorization?: string;
};

export type GetClientsAccountReportParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
};

export type GetClientsAccountReportHeaders = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type ExportClientsAccountReportParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
};

export type ExportClientsAccountReportHeaders = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetClientsAccountReportStatsParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
};

export type GetClientsAccountReportStatsHeaders = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetClientsApprovedNotFundedParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data in ISO UTC format.
 */
startDate?: string;
/**
 * End date for the client data in ISO UTC format.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
};

export type ExportApprovedNotFundedParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
};

export type ExportApprovedNotFundedHeaders = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetClientsFundedNotTradedParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data in ISO UTC format.
 */
startDate?: string;
/**
 * End date for the client data in ISO UTC format.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
};

export type ExportFundedNotTradedParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
};

export type ExportFundedNotTradedHeaders = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetRebateAccountsForIbHeaders = {
Authorization?: string;
};

export type GetRebateProgramsForIbHeaders = {
Authorization?: string;
};

export type GetClientsTradingReportParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
};

export type GetClientsTradingReportHeaders = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type ExportClientsTradingReportParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
};

export type ExportClientsTradingReportHeaders = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetClientsTradingReportStatsParams = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
};

export type GetClientsTradingReportStatsHeaders = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetEarningsV2Headers = {
Authorization?: string;
};

export type GetLeadsV2Params = {
/**
 * Start date in ISO UTC format
 */
startDate?: string;
/**
 * End date in ISO UTC format
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by lead status values (IncompleteProfile, CompletingProfile, ReviewingSuitability, IdentifyVerification, VerifyingIdentity, Approved, Unknown)
 * @nullable
 */
statuses?: string[] | null;
/**
 * Filter by country code values (ISO 3166-1 alpha-2, e.g. AU, GB, SG)
 * @nullable
 */
countryCodes?: string[] | null;
};

export type GetLeadsV2Headers = {
Authorization?: string;
/**
 * Version of the status labels to use in the exported CSV. Use 'v2' for updated labels. Defaults to 'v1'.
 */
version?: string;
};

export type ExportLeadsParams = {
/**
 * Start date in ISO UTC format
 */
startDate?: string;
/**
 * End date in ISO UTC format
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by lead status values (IncompleteProfile, CompletingProfile, ReviewingSuitability, IdentifyVerification, VerifyingIdentity, Approved, Unknown)
 * @nullable
 */
statuses?: string[] | null;
/**
 * Filter by country code values (ISO 3166-1 alpha-2, e.g. AU, GB, SG)
 * @nullable
 */
countryCodes?: string[] | null;
};

export type ExportLeadsHeaders = {
Authorization?: string;
/**
 * Version of the status labels to use in the exported CSV. Use 'v2' for updated labels. Defaults to 'v1'.
 */
version?: string;
};

export type GetLeadsFiltersV2Params = {
/**
 * Start date in ISO UTC format to filter status counts and country codes.
 */
startDate?: string;
/**
 * End date in ISO UTC format to filter status counts and country codes.
 */
endDate?: string;
/**
 * Filter country codes to reflect status counts for the given countries (ISO 3166-1 alpha-2, e.g. AU, GB, SG)
 * @nullable
 */
countryCodes?: string[] | null;
/**
 * Filter statuses to reflect country code list for the given statuses (IncompleteProfile, CompletingProfile, ReviewingSuitability, IdentifyVerification, VerifyingIdentity, Approved, Unknown)
 * @nullable
 */
statuses?: GetLeadsFiltersV2StatusesItem[] | null;
/**
 * Search term to filter leads included in the filter counts.
 */
search?: string;
};

export type GetLeadsFiltersV2StatusesItem = typeof GetLeadsFiltersV2StatusesItem[keyof typeof GetLeadsFiltersV2StatusesItem];


export const GetLeadsFiltersV2StatusesItem = {
  IncompleteProfile: 'IncompleteProfile',
  CompletingProfile: 'CompletingProfile',
  ReviewingSuitability: 'ReviewingSuitability',
  IdentifyVerification: 'IdentifyVerification',
  VerifyingIdentity: 'VerifyingIdentity',
  Approved: 'Approved',
  Unknown: 'Unknown',
} as const;

export type GetLeadsFiltersV2Headers = {
Authorization?: string;
};

export type GetLeadsStatsV2Params = {
/**
 * Start date in ISO UTC format
 */
startDate?: string;
/**
 * End date in ISO UTC format
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by lead status values (IncompleteProfile, CompletingProfile, ReviewingSuitability, IdentifyVerification, VerifyingIdentity, Approved, Unknown)
 * @nullable
 */
statuses?: string[] | null;
/**
 * Filter by country code values (ISO 3166-1 alpha-2, e.g. AU, GB, SG)
 * @nullable
 */
countryCodes?: string[] | null;
};

export type GetLeadsStatsV2Headers = {
Authorization?: string;
/**
 * Version of the status labels to use in the exported CSV. Use 'v2' for updated labels. Defaults to 'v1'.
 */
version?: string;
};

export type GetOverviewV2Headers = {
Authorization?: string;
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetPerformanceReportV2Params = {
/**
 * Grouping dimension (exactly one).
 */
tab?: GetPerformanceReportV2Tab;
/**
 * Inclusive start date (YYYY-MM-DD).
 */
startDate?: string;
/**
 * Inclusive end date (YYYY-MM-DD).
 */
endDate?: string;
/**
 * Source-type filter: Links and/or Banners.
 * @nullable
 */
sourceTypes?: string[] | null;
/**
 * Landing page filter (tune_landing_page_id values).
 * @nullable
 */
landingPages?: string[] | null;
/**
 * Banner group filter.
 * @nullable
 */
bannerGroups?: string[] | null;
/**
 * Rebate program filter (HOID values).
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Country filter (ISO country codes).
 * @nullable
 */
countries?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include rows with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaigns?: number[] | null;
/**
 * Sort column id (matches a table column); omit for default sort.
 */
sortColumn?: string;
/**
 * Sort descending when true, ascending when false.
 */
sortDesc?: boolean;
/**
 * Page number (1-based).
 * @minimum 1
 */
page?: number;
/**
 * Rows per page.
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
};

export type GetPerformanceReportV2Tab = typeof GetPerformanceReportV2Tab[keyof typeof GetPerformanceReportV2Tab];


export const GetPerformanceReportV2Tab = {
  source: 'source',
  country: 'country',
  rebate: 'rebate',
  campaign: 'campaign',
} as const;

export type ExportPerformanceReportV2Params = {
/**
 * View tab: source, country, rebate or campaign. Determines the dimension column and grouping.
 */
tab?: ExportPerformanceReportV2Tab;
/**
 * Inclusive start date (YYYY-MM-DD).
 */
startDate?: string;
/**
 * Inclusive end date (YYYY-MM-DD).
 */
endDate?: string;
/**
 * Source-type filter: Links and/or Banners.
 * @nullable
 */
sourceTypes?: string[] | null;
/**
 * Filter by landing page id.
 * @nullable
 */
landingPages?: string[] | null;
/**
 * Filter by banner group.
 * @nullable
 */
bannerGroups?: string[] | null;
/**
 * Filter by rebate program (HOID).
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Filter by ISO country code.
 * @nullable
 */
countries?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include rows with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaigns?: number[] | null;
/**
 * Sort column id (name, source, country, impressions, clicks, registration, approved, funded, traded, volume, earnings, cr_reg, cr_app, cr_funded, cr_traded); omit for default sort.
 */
sortColumn?: string;
/**
 * Sort descending when true.
 */
sortDesc?: boolean;
/**
 * Metric columns to include, matching the table's visible columns (impressions, clicks, registration, approved, funded, traded, cr_reg, cr_app, cr_funded, cr_traded, volume, earnings). Omit to export all columns, or pass 'none' to export only the dimension column when every metric column is hidden. Rendered in the table's canonical order regardless of the order supplied.
 * @nullable
 */
columns?: string[] | null;
};

export type ExportPerformanceReportV2Tab = typeof ExportPerformanceReportV2Tab[keyof typeof ExportPerformanceReportV2Tab];


export const ExportPerformanceReportV2Tab = {
  source: 'source',
  country: 'country',
  rebate: 'rebate',
  campaign: 'campaign',
} as const;

export type GetPerformanceReportStatsV2Params = {
/**
 * Start of the date range (YYYY-MM-DD, inclusive). Defaults to 30 days before 'endDate'.
 */
startDate?: string;
/**
 * End of the date range (YYYY-MM-DD, inclusive). Defaults to today (UTC).
 */
endDate?: string;
/**
 * Filter by MV source type (referral_link, marketing_banner).
 * @nullable
 */
sourceTypes?: string[] | null;
/**
 * Filter by specific referral link / banner id.
 * @nullable
 */
sourceIds?: string[] | null;
/**
 * Filter by ISO country code.
 * @nullable
 */
countries?: string[] | null;
/**
 * Filter by landing page id (tune_landing_page_id / offer_url_id).
 * @nullable
 */
landingPages?: string[] | null;
/**
 * Filter by banner group.
 * @nullable
 */
bannerGroups?: string[] | null;
/**
 * Filter by rebate program (HOID).
 * @nullable
 */
rebatePrograms?: string[] | null;
/**
 * Filter by campaign id. Pass 0 to include rows with no campaign attached (campaign_id IS NULL).
 * @nullable
 */
campaigns?: number[] | null;
};

export type GetClientsAccountReportV3Params = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
/**
 * direct = your clients (excludes rebate programs where you are a sub IB), indirect = clients shared with you.
 */
clientType?: GetClientsAccountReportV3ClientType;
/**
 * Ignored when clientType=indirect. direct excludes clients of your rebate programs shared with sub IBs; indirect keeps only those clients; all keeps both.
 */
filterClientType?: GetClientsAccountReportV3FilterClientType;
/**
 * With filterClientType=indirect or all, keeps only shared programs that include one of these sub IB IDs. Ignored with filterClientType=direct.
 * @nullable
 */
filterSubIBIDs?: string[] | null;
};

export type GetClientsAccountReportV3ClientType = typeof GetClientsAccountReportV3ClientType[keyof typeof GetClientsAccountReportV3ClientType];


export const GetClientsAccountReportV3ClientType = {
  direct: 'direct',
  indirect: 'indirect',
} as const;

export type GetClientsAccountReportV3FilterClientType = typeof GetClientsAccountReportV3FilterClientType[keyof typeof GetClientsAccountReportV3FilterClientType];


export const GetClientsAccountReportV3FilterClientType = {
  direct: 'direct',
  indirect: 'indirect',
  all: 'all',
} as const;

export type GetClientsAccountReportV3Headers = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type ExportClientsAccountReportV3Params = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
/**
 * direct = your clients (excludes rebate programs where you are a sub IB), indirect = clients shared with you.
 */
clientType?: ExportClientsAccountReportV3ClientType;
/**
 * Ignored when clientType=indirect. direct excludes clients of your rebate programs shared with sub IBs; indirect keeps only those clients; all keeps both.
 */
filterClientType?: ExportClientsAccountReportV3FilterClientType;
/**
 * With filterClientType=indirect or all, keeps only shared programs that include one of these sub IB IDs. Ignored with filterClientType=direct.
 * @nullable
 */
filterSubIBIDs?: string[] | null;
};

export type ExportClientsAccountReportV3ClientType = typeof ExportClientsAccountReportV3ClientType[keyof typeof ExportClientsAccountReportV3ClientType];


export const ExportClientsAccountReportV3ClientType = {
  direct: 'direct',
  indirect: 'indirect',
} as const;

export type ExportClientsAccountReportV3FilterClientType = typeof ExportClientsAccountReportV3FilterClientType[keyof typeof ExportClientsAccountReportV3FilterClientType];


export const ExportClientsAccountReportV3FilterClientType = {
  direct: 'direct',
  indirect: 'indirect',
  all: 'all',
} as const;

export type ExportClientsAccountReportV3Headers = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetClientsAccountReportStatsV3Params = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * direct = your clients (excludes rebate programs where you are a sub IB), indirect = clients shared with you.
 */
clientType?: GetClientsAccountReportStatsV3ClientType;
/**
 * Ignored when clientType=indirect. direct excludes clients of your rebate programs shared with sub IBs; indirect keeps only those clients; all keeps both.
 */
filterClientType?: GetClientsAccountReportStatsV3FilterClientType;
/**
 * With filterClientType=indirect or all, keeps only shared programs that include one of these sub IB IDs. Ignored with filterClientType=direct.
 * @nullable
 */
filterSubIBIDs?: string[] | null;
};

export type GetClientsAccountReportStatsV3ClientType = typeof GetClientsAccountReportStatsV3ClientType[keyof typeof GetClientsAccountReportStatsV3ClientType];


export const GetClientsAccountReportStatsV3ClientType = {
  direct: 'direct',
  indirect: 'indirect',
} as const;

export type GetClientsAccountReportStatsV3FilterClientType = typeof GetClientsAccountReportStatsV3FilterClientType[keyof typeof GetClientsAccountReportStatsV3FilterClientType];


export const GetClientsAccountReportStatsV3FilterClientType = {
  direct: 'direct',
  indirect: 'indirect',
  all: 'all',
} as const;

export type GetClientsTradingReportV3Params = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
/**
 * direct = your clients (excludes rebate programs where you are a sub IB), indirect = clients shared with you.
 */
clientType?: GetClientsTradingReportV3ClientType;
/**
 * Ignored when clientType=indirect. direct excludes clients of your rebate programs shared with sub IBs; indirect keeps only those clients; all keeps both.
 */
filterClientType?: GetClientsTradingReportV3FilterClientType;
/**
 * With filterClientType=indirect or all, keeps only shared programs that include one of these sub IB IDs. Ignored with filterClientType=direct.
 * @nullable
 */
filterSubIBIDs?: string[] | null;
};

export type GetClientsTradingReportV3ClientType = typeof GetClientsTradingReportV3ClientType[keyof typeof GetClientsTradingReportV3ClientType];


export const GetClientsTradingReportV3ClientType = {
  direct: 'direct',
  indirect: 'indirect',
} as const;

export type GetClientsTradingReportV3FilterClientType = typeof GetClientsTradingReportV3FilterClientType[keyof typeof GetClientsTradingReportV3FilterClientType];


export const GetClientsTradingReportV3FilterClientType = {
  direct: 'direct',
  indirect: 'indirect',
  all: 'all',
} as const;

export type GetClientsTradingReportV3Headers = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type ExportClientsTradingReportV3Params = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Page number (1-based). If provided, returns paginated data.
 * @minimum 1
 */
page?: number;
/**
 * Number of records per page
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * Sorting options for the report. Format: VolumeFX
 */
sortColumn?: string;
/**
 * Sorting options for the report. Format: desc: true
 */
sortDesc?: boolean;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
/**
 * direct = your clients (excludes rebate programs where you are a sub IB), indirect = clients shared with you.
 */
clientType?: ExportClientsTradingReportV3ClientType;
/**
 * Ignored when clientType=indirect. direct excludes clients of your rebate programs shared with sub IBs; indirect keeps only those clients; all keeps both.
 */
filterClientType?: ExportClientsTradingReportV3FilterClientType;
/**
 * With filterClientType=indirect or all, keeps only shared programs that include one of these sub IB IDs. Ignored with filterClientType=direct.
 * @nullable
 */
filterSubIBIDs?: string[] | null;
};

export type ExportClientsTradingReportV3ClientType = typeof ExportClientsTradingReportV3ClientType[keyof typeof ExportClientsTradingReportV3ClientType];


export const ExportClientsTradingReportV3ClientType = {
  direct: 'direct',
  indirect: 'indirect',
} as const;

export type ExportClientsTradingReportV3FilterClientType = typeof ExportClientsTradingReportV3FilterClientType[keyof typeof ExportClientsTradingReportV3FilterClientType];


export const ExportClientsTradingReportV3FilterClientType = {
  direct: 'direct',
  indirect: 'indirect',
  all: 'all',
} as const;

export type ExportClientsTradingReportV3Headers = {
/**
 * API version header for feature flagging
 */
version?: string;
};

export type GetClientsTradingReportStatsV3Params = {
/**
 * @nullable
 */
rebateAccountIDs?: string[] | null;
/**
 * Filter by rebate program offer IDs (see GET /v2/clients/rebate-programs).
 * @nullable
 */
rebateProgramIDs?: string[] | null;
/**
 * Start date for the client data.
 */
startDate?: string;
/**
 * End date for the client data.
 */
endDate?: string;
/**
 * Search term for the client data.
 */
search?: string;
/**
 * direct = your clients (excludes rebate programs where you are a sub IB), indirect = clients shared with you.
 */
clientType?: GetClientsTradingReportStatsV3ClientType;
/**
 * Ignored when clientType=indirect. direct excludes clients of your rebate programs shared with sub IBs; indirect keeps only those clients; all keeps both.
 */
filterClientType?: GetClientsTradingReportStatsV3FilterClientType;
/**
 * With filterClientType=indirect or all, keeps only shared programs that include one of these sub IB IDs. Ignored with filterClientType=direct.
 * @nullable
 */
filterSubIBIDs?: string[] | null;
};

export type GetClientsTradingReportStatsV3ClientType = typeof GetClientsTradingReportStatsV3ClientType[keyof typeof GetClientsTradingReportStatsV3ClientType];


export const GetClientsTradingReportStatsV3ClientType = {
  direct: 'direct',
  indirect: 'indirect',
} as const;

export type GetClientsTradingReportStatsV3FilterClientType = typeof GetClientsTradingReportStatsV3FilterClientType[keyof typeof GetClientsTradingReportStatsV3FilterClientType];


export const GetClientsTradingReportStatsV3FilterClientType = {
  direct: 'direct',
  indirect: 'indirect',
  all: 'all',
} as const;

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetEarningsUrl = () => {




  return `/earnings`
}

/**
 * @summary Get earnings data
 */
export const useGetEarningsHook = (): (headers?: GetEarningsHeaders, options?: RequestInit) => Promise<EarningsOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetEarningsHeaders, options?: RequestInit) => {

        return customFetcher(getGetEarningsUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetEarningsQueryKey = () => {
    return [
    `/earnings`
    ] as const;
    }


export const useGetEarningsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetEarningsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEarningsQueryKey();

  const getEarnings =  useGetEarningsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>> = ({ signal }) => getEarnings(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEarningsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>>
export type GetEarningsQueryError = ErrorType<ErrorModel>


export function useGetEarnings<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetEarningsHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEarnings<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEarnings<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get earnings data
 */

export function useGetEarnings<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetEarningsQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetEarningsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetEarningsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEarningsQueryKey();

  const getEarnings =  useGetEarningsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>> = ({ signal }) => getEarnings(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetEarningsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>>
export type GetEarningsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetEarningsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetEarningsHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEarningsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEarningsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get earnings data
 */

export function useGetEarningsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetEarningsSuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListFeatureflagsUrl = () => {




  return `/featureflag/list`
}

/**
 * @summary Get the list of featureflags and their statuses
 */
export const useListFeatureflagsHook = (): ( options?: RequestInit) => Promise<FeatureflagsListBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getListFeatureflagsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getListFeatureflagsQueryKey = () => {
    return [
    `/featureflag/list`
    ] as const;
    }


export const useListFeatureflagsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeatureflagsQueryKey();

  const listFeatureflags =  useListFeatureflagsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>> = ({ signal }) => listFeatureflags({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFeatureflagsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>>
export type ListFeatureflagsQueryError = ErrorType<ErrorModel>


export function useListFeatureflags<TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFeatureflags<TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFeatureflags<TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the list of featureflags and their statuses
 */

export function useListFeatureflags<TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListFeatureflagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListFeatureflagsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeatureflagsQueryKey();

  const listFeatureflags =  useListFeatureflagsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>> = ({ signal }) => listFeatureflags({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ListFeatureflagsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>>
export type ListFeatureflagsSuspenseQueryError = ErrorType<ErrorModel>


export function useListFeatureflagsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFeatureflagsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFeatureflagsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the list of featureflags and their statuses
 */

export function useListFeatureflagsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListFeatureflagsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListFeatureflagsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getHealthcheckUrl = () => {




  return `/healthcheck`
}

/**
 * @summary Healthcheck
 */
export const useHealthcheckHook = (): ( options?: RequestInit) => Promise<HealthcheckOutputBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getHealthcheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getHealthcheckQueryKey = () => {
    return [
    `/healthcheck`
    ] as const;
    }


export const useHealthcheckQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckQueryKey();

  const healthcheck =  useHealthcheckHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>> = ({ signal }) => healthcheck({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthcheckQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>>
export type HealthcheckQueryError = ErrorType<ErrorModel>


export function useHealthcheck<TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Healthcheck
 */

export function useHealthcheck<TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useHealthcheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useHealthcheckSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckQueryKey();

  const healthcheck =  useHealthcheckHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>> = ({ signal }) => healthcheck({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type HealthcheckSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>>
export type HealthcheckSuspenseQueryError = ErrorType<ErrorModel>


export function useHealthcheckSuspense<TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheckSuspense<TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheckSuspense<TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Healthcheck
 */

export function useHealthcheckSuspense<TData = Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthcheckHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useHealthcheckSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getProcessIbReapplicationUrl = () => {




  return `/ib-reapplication/process`
}

/**
 * Validate user for reapplication and archive old submitted questionnaire answers
 * @summary Process IB Reapplication
 */
export const useProcessIbReapplicationHook = (): ( options?: RequestInit) => Promise<ProcessReapplicationOutputBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getProcessIbReapplicationUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }





export const getProcessIbReapplicationMutationKey = () => ['processIbReapplication'] as const;

export const useProcessIbReapplicationMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useProcessIbReapplicationHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useProcessIbReapplicationHook>>>, TError,void, TContext> => {

const mutationKey = getProcessIbReapplicationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const processIbReapplication =  useProcessIbReapplicationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useProcessIbReapplicationHook>>>, void> = () => {


          return  processIbReapplication()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProcessIbReapplicationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useProcessIbReapplicationHook>>>>

    export type ProcessIbReapplicationMutationError = ErrorType<ErrorModel>


    /**
 * @summary Process IB Reapplication
 */
export const useProcessIbReapplication = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useProcessIbReapplicationHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useProcessIbReapplicationHook>>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(useProcessIbReapplicationMutationOptions(options), queryClient);
    }

export const getInitiateIbRegistrationUrl = () => {




  return `/ib-registration`
}

/**
 * @summary Initiate IB Registration
 */
export const useInitiateIbRegistrationHook = (): (iBRegistrationInputBody?: NonReadonly<IBRegistrationInputBody>,
    headers?: InitiateIbRegistrationHeaders, options?: RequestInit) => Promise<IBRegistrationOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (iBRegistrationInputBody?: NonReadonly<IBRegistrationInputBody>,
    headers?: InitiateIbRegistrationHeaders, options?: RequestInit) => {

        return customFetcher(getInitiateIbRegistrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(iBRegistrationInputBody)
  }
);
      }
  }





export const getInitiateIbRegistrationMutationKey = () => ['initiateIbRegistration'] as const;

export const useInitiateIbRegistrationMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInitiateIbRegistrationHook>>>, TError,InitiateIbRegistrationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInitiateIbRegistrationHook>>>, TError,InitiateIbRegistrationMutationVariables, TContext> => {

const mutationKey = getInitiateIbRegistrationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const initiateIbRegistration =  useInitiateIbRegistrationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useInitiateIbRegistrationHook>>>, InitiateIbRegistrationMutationVariables> = (props) => {
          const {data,headers} = props ?? {};

          return  initiateIbRegistration(data,headers,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiateIbRegistrationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useInitiateIbRegistrationHook>>>>
    export type InitiateIbRegistrationMutationBody = BodyType<NonReadonly<IBRegistrationInputBody>> | undefined
    export type InitiateIbRegistrationMutationError = ErrorType<ErrorModel>
    export type InitiateIbRegistrationMutationVariables = {data?: BodyType<NonReadonly<IBRegistrationInputBody>>;headers?: InitiateIbRegistrationHeaders}

    /**
 * @summary Initiate IB Registration
 */
export const useInitiateIbRegistration = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useInitiateIbRegistrationHook>>>, TError,InitiateIbRegistrationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useInitiateIbRegistrationHook>>>,
        TError,
        InitiateIbRegistrationMutationVariables,
        TContext
      > => {
      return useMutation(useInitiateIbRegistrationMutationOptions(options), queryClient);
    }

export const getGetMarketingAssetsUrl = (params?: GetMarketingAssetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/marketing?${stringifiedParams}` : `/marketing`
}

/**
 * @summary Get Marketing data from Tune
 */
export const useGetMarketingAssetsHook = (): (params?: GetMarketingAssetsParams, options?: RequestInit) => Promise<MarketingOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetMarketingAssetsParams, options?: RequestInit) => {

        return customFetcher(getGetMarketingAssetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetMarketingAssetsQueryKey = (params?: GetMarketingAssetsParams,) => {
    return [
    `/marketing`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetMarketingAssetsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetMarketingAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingAssetsQueryKey(params);

  const getMarketingAssets =  useGetMarketingAssetsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>> = ({ signal }) => getMarketingAssets(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingAssetsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>>
export type GetMarketingAssetsQueryError = ErrorType<ErrorModel>


export function useGetMarketingAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetMarketingAssetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Marketing data from Tune
 */

export function useGetMarketingAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMarketingAssetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetMarketingAssetsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetMarketingAssetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingAssetsQueryKey(params);

  const getMarketingAssets =  useGetMarketingAssetsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>> = ({ signal }) => getMarketingAssets(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMarketingAssetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>>
export type GetMarketingAssetsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetMarketingAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetMarketingAssetsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingAssetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingAssetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Marketing data from Tune
 */

export function useGetMarketingAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingAssetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMarketingAssetsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCreativeCodeUrl = (params?: GetCreativeCodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/marketing/creative-code?${stringifiedParams}` : `/marketing/creative-code`
}

/**
 * @summary Get creative code data from Tune
 */
export const useGetCreativeCodeHook = (): (params?: GetCreativeCodeParams, options?: RequestInit) => Promise<CreativeCodeOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetCreativeCodeParams, options?: RequestInit) => {

        return customFetcher(getGetCreativeCodeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetCreativeCodeQueryKey = (params?: GetCreativeCodeParams,) => {
    return [
    `/marketing/creative-code`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetCreativeCodeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(params?: GetCreativeCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreativeCodeQueryKey(params);

  const getCreativeCode =  useGetCreativeCodeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>> = ({ signal }) => getCreativeCode(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreativeCodeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>>
export type GetCreativeCodeQueryError = ErrorType<ErrorModel>


export function useGetCreativeCode<TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetCreativeCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreativeCode<TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCreativeCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreativeCode<TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCreativeCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get creative code data from Tune
 */

export function useGetCreativeCode<TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCreativeCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCreativeCodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetCreativeCodeSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(params?: GetCreativeCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreativeCodeQueryKey(params);

  const getCreativeCode =  useGetCreativeCodeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>> = ({ signal }) => getCreativeCode(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCreativeCodeSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>>
export type GetCreativeCodeSuspenseQueryError = ErrorType<ErrorModel>


export function useGetCreativeCodeSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetCreativeCodeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreativeCodeSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCreativeCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreativeCodeSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCreativeCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get creative code data from Tune
 */

export function useGetCreativeCodeSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCreativeCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCreativeCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCreativeCodeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLabgroupRegistrationLinkUrl = (triageID: string,) => {




  return `/onboarding/${triageID}/labgroup-registration-link`
}

/**
 * @summary Get LabGroup Registration Link
 */
export const useGetLabgroupRegistrationLinkHook = (): (triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: RequestInit) => Promise<LabgroupRegistrationLinkBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: RequestInit) => {

        return customFetcher(getGetLabgroupRegistrationLinkUrl(triageID),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetLabgroupRegistrationLinkQueryKey = (triageID: string,) => {
    return [
    `/onboarding/${triageID}/labgroup-registration-link`
    ] as const;
    }


export const useGetLabgroupRegistrationLinkQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabgroupRegistrationLinkQueryKey(triageID);

  const getLabgroupRegistrationLink =  useGetLabgroupRegistrationLinkHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>> = ({ signal }) => getLabgroupRegistrationLink(triageID,headers, { signal });





   return  { queryKey, queryFn, enabled: triageID !== null && triageID !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLabgroupRegistrationLinkQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>>
export type GetLabgroupRegistrationLinkQueryError = ErrorType<ErrorModel>


export function useGetLabgroupRegistrationLink<TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string,
    headers: undefined |  GetLabgroupRegistrationLinkHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLabgroupRegistrationLink<TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLabgroupRegistrationLink<TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get LabGroup Registration Link
 */

export function useGetLabgroupRegistrationLink<TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLabgroupRegistrationLinkQueryOptions(triageID,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetLabgroupRegistrationLinkSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLabgroupRegistrationLinkQueryKey(triageID);

  const getLabgroupRegistrationLink =  useGetLabgroupRegistrationLinkHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>> = ({ signal }) => getLabgroupRegistrationLink(triageID,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLabgroupRegistrationLinkSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>>
export type GetLabgroupRegistrationLinkSuspenseQueryError = ErrorType<ErrorModel>


export function useGetLabgroupRegistrationLinkSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string,
    headers: undefined |  GetLabgroupRegistrationLinkHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLabgroupRegistrationLinkSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLabgroupRegistrationLinkSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get LabGroup Registration Link
 */

export function useGetLabgroupRegistrationLinkSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string,
    headers?: GetLabgroupRegistrationLinkHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLabgroupRegistrationLinkHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLabgroupRegistrationLinkSuspenseQueryOptions(triageID,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetIbOnboardingStatusUrl = (triageID: string,) => {




  return `/onboarding/${triageID}/status`
}

/**
 * Poll this endpoint to check the processing status of IB registration job
 * @summary Get IB Onboarding Status
 */
export const useGetIbOnboardingStatusHook = (): (triageID: string, options?: RequestInit) => Promise<OnboardingStatusBody> => {

      const customFetcher = useFetchWrapper();
      return (triageID: string, options?: RequestInit) => {

        return customFetcher(getGetIbOnboardingStatusUrl(triageID),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetIbOnboardingStatusQueryKey = (triageID: string,) => {
    return [
    `/onboarding/${triageID}/status`
    ] as const;
    }


export const useGetIbOnboardingStatusQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(triageID: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIbOnboardingStatusQueryKey(triageID);

  const getIbOnboardingStatus =  useGetIbOnboardingStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>> = ({ signal }) => getIbOnboardingStatus(triageID, { signal });





   return  { queryKey, queryFn, enabled: triageID !== null && triageID !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIbOnboardingStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>>
export type GetIbOnboardingStatusQueryError = ErrorType<ErrorModel>


export function useGetIbOnboardingStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIbOnboardingStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIbOnboardingStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get IB Onboarding Status
 */

export function useGetIbOnboardingStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetIbOnboardingStatusQueryOptions(triageID,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetIbOnboardingStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(triageID: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIbOnboardingStatusQueryKey(triageID);

  const getIbOnboardingStatus =  useGetIbOnboardingStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>> = ({ signal }) => getIbOnboardingStatus(triageID, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetIbOnboardingStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>>
export type GetIbOnboardingStatusSuspenseQueryError = ErrorType<ErrorModel>


export function useGetIbOnboardingStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIbOnboardingStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIbOnboardingStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get IB Onboarding Status
 */

export function useGetIbOnboardingStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError = ErrorType<ErrorModel>>(
 triageID: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIbOnboardingStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetIbOnboardingStatusSuspenseQueryOptions(triageID,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveQuestionnaireAnswersUrl = () => {




  return `/questionnaires/answers`
}

/**
 * Save or submit answers for a questionnaire
 * @summary Save/Submit questionnaire answers
 */
export const useSaveQuestionnaireAnswersHook = (): (saveAnswersRequest: NonReadonly<SaveAnswersRequest>, options?: RequestInit) => Promise<SaveAnswersResponse> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (saveAnswersRequest: NonReadonly<SaveAnswersRequest>, options?: RequestInit) => {

        return customFetcher(getSaveQuestionnaireAnswersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveAnswersRequest)
  }
);
      }
  }





export const getSaveQuestionnaireAnswersMutationKey = () => ['saveQuestionnaireAnswers'] as const;

export const useSaveQuestionnaireAnswersMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveQuestionnaireAnswersHook>>>, TError,SaveQuestionnaireAnswersMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveQuestionnaireAnswersHook>>>, TError,SaveQuestionnaireAnswersMutationVariables, TContext> => {

const mutationKey = getSaveQuestionnaireAnswersMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const saveQuestionnaireAnswers =  useSaveQuestionnaireAnswersHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSaveQuestionnaireAnswersHook>>>, SaveQuestionnaireAnswersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  saveQuestionnaireAnswers(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveQuestionnaireAnswersMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveQuestionnaireAnswersHook>>>>
    export type SaveQuestionnaireAnswersMutationBody = BodyType<NonReadonly<SaveAnswersRequest>>
    export type SaveQuestionnaireAnswersMutationError = ErrorType<ErrorModel>
    export type SaveQuestionnaireAnswersMutationVariables = {data: BodyType<NonReadonly<SaveAnswersRequest>>}

    /**
 * @summary Save/Submit questionnaire answers
 */
export const useSaveQuestionnaireAnswers = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveQuestionnaireAnswersHook>>>, TError,SaveQuestionnaireAnswersMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useSaveQuestionnaireAnswersHook>>>,
        TError,
        SaveQuestionnaireAnswersMutationVariables,
        TContext
      > => {
      return useMutation(useSaveQuestionnaireAnswersMutationOptions(options), queryClient);
    }

export const getGetQuestionnaireAnswersByLicenseUrl = (license: string,) => {




  return `/questionnaires/answers/${license}`
}

/**
 * Get the current user's saved questionnaire answers for a specific license
 * @summary Get user's questionnaire answers by license
 */
export const useGetQuestionnaireAnswersByLicenseHook = (): (license: string, options?: RequestInit) => Promise<GetAnswersResponse> => {

      const customFetcher = useFetchWrapper();
      return (license: string, options?: RequestInit) => {

        return customFetcher(getGetQuestionnaireAnswersByLicenseUrl(license),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetQuestionnaireAnswersByLicenseQueryKey = (license: string,) => {
    return [
    `/questionnaires/answers/${license}`
    ] as const;
    }


export const useGetQuestionnaireAnswersByLicenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(license: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireAnswersByLicenseQueryKey(license);

  const getQuestionnaireAnswersByLicense =  useGetQuestionnaireAnswersByLicenseHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>> = ({ signal }) => getQuestionnaireAnswersByLicense(license, { signal });





   return  { queryKey, queryFn, enabled: license !== null && license !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuestionnaireAnswersByLicenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>>
export type GetQuestionnaireAnswersByLicenseQueryError = ErrorType<ErrorModel>


export function useGetQuestionnaireAnswersByLicense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuestionnaireAnswersByLicense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuestionnaireAnswersByLicense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user's questionnaire answers by license
 */

export function useGetQuestionnaireAnswersByLicense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuestionnaireAnswersByLicenseQueryOptions(license,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetQuestionnaireAnswersByLicenseSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(license: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireAnswersByLicenseQueryKey(license);

  const getQuestionnaireAnswersByLicense =  useGetQuestionnaireAnswersByLicenseHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>> = ({ signal }) => getQuestionnaireAnswersByLicense(license, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetQuestionnaireAnswersByLicenseSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>>
export type GetQuestionnaireAnswersByLicenseSuspenseQueryError = ErrorType<ErrorModel>


export function useGetQuestionnaireAnswersByLicenseSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuestionnaireAnswersByLicenseSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuestionnaireAnswersByLicenseSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user's questionnaire answers by license
 */

export function useGetQuestionnaireAnswersByLicenseSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireAnswersByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuestionnaireAnswersByLicenseSuspenseQueryOptions(license,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetQuestionnaireQuestionsByLicenseUrl = (license: string,) => {




  return `/questionnaires/questions/${license}`
}

/**
 * Get all available questionnaire questions for a specific license
 * @summary Get questionnaire questions by license
 */
export const useGetQuestionnaireQuestionsByLicenseHook = (): (license: string, options?: RequestInit) => Promise<QuestionsResponse> => {

      const customFetcher = useFetchWrapper();
      return (license: string, options?: RequestInit) => {

        return customFetcher(getGetQuestionnaireQuestionsByLicenseUrl(license),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetQuestionnaireQuestionsByLicenseQueryKey = (license: string,) => {
    return [
    `/questionnaires/questions/${license}`
    ] as const;
    }


export const useGetQuestionnaireQuestionsByLicenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(license: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireQuestionsByLicenseQueryKey(license);

  const getQuestionnaireQuestionsByLicense =  useGetQuestionnaireQuestionsByLicenseHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>> = ({ signal }) => getQuestionnaireQuestionsByLicense(license, { signal });





   return  { queryKey, queryFn, enabled: license !== null && license !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuestionnaireQuestionsByLicenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>>
export type GetQuestionnaireQuestionsByLicenseQueryError = ErrorType<ErrorModel>


export function useGetQuestionnaireQuestionsByLicense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuestionnaireQuestionsByLicense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuestionnaireQuestionsByLicense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get questionnaire questions by license
 */

export function useGetQuestionnaireQuestionsByLicense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuestionnaireQuestionsByLicenseQueryOptions(license,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetQuestionnaireQuestionsByLicenseSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(license: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireQuestionsByLicenseQueryKey(license);

  const getQuestionnaireQuestionsByLicense =  useGetQuestionnaireQuestionsByLicenseHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>> = ({ signal }) => getQuestionnaireQuestionsByLicense(license, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetQuestionnaireQuestionsByLicenseSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>>
export type GetQuestionnaireQuestionsByLicenseSuspenseQueryError = ErrorType<ErrorModel>


export function useGetQuestionnaireQuestionsByLicenseSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuestionnaireQuestionsByLicenseSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuestionnaireQuestionsByLicenseSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get questionnaire questions by license
 */

export function useGetQuestionnaireQuestionsByLicenseSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError = ErrorType<ErrorModel>>(
 license: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetQuestionnaireQuestionsByLicenseHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetQuestionnaireQuestionsByLicenseSuspenseQueryOptions(license,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitQuestionnaireUrl = () => {




  return `/questionnaires/submit`
}

/**
 * Submit user's questionnaire answers to SCA and mark as submitted
 * @summary Submit questionnaire answers to SCA
 */
export const useSubmitQuestionnaireHook = (): (submitQuestionnairePayload: NonReadonly<SubmitQuestionnairePayload>, options?: RequestInit) => Promise<SaveAnswersResponse> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (submitQuestionnairePayload: NonReadonly<SubmitQuestionnairePayload>, options?: RequestInit) => {

        return customFetcher(getSubmitQuestionnaireUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(submitQuestionnairePayload)
  }
);
      }
  }





export const getSubmitQuestionnaireMutationKey = () => ['submitQuestionnaire'] as const;

export const useSubmitQuestionnaireMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSubmitQuestionnaireHook>>>, TError,SubmitQuestionnaireMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSubmitQuestionnaireHook>>>, TError,SubmitQuestionnaireMutationVariables, TContext> => {

const mutationKey = getSubmitQuestionnaireMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const submitQuestionnaire =  useSubmitQuestionnaireHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSubmitQuestionnaireHook>>>, SubmitQuestionnaireMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  submitQuestionnaire(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitQuestionnaireMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSubmitQuestionnaireHook>>>>
    export type SubmitQuestionnaireMutationBody = BodyType<NonReadonly<SubmitQuestionnairePayload>>
    export type SubmitQuestionnaireMutationError = ErrorType<ErrorModel>
    export type SubmitQuestionnaireMutationVariables = {data: BodyType<NonReadonly<SubmitQuestionnairePayload>>}

    /**
 * @summary Submit questionnaire answers to SCA
 */
export const useSubmitQuestionnaire = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSubmitQuestionnaireHook>>>, TError,SubmitQuestionnaireMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useSubmitQuestionnaireHook>>>,
        TError,
        SubmitQuestionnaireMutationVariables,
        TContext
      > => {
      return useMutation(useSubmitQuestionnaireMutationOptions(options), queryClient);
    }

export const getTestSaveAndSubmitQuestionnaireUrl = () => {




  return `/questionnaires/test/save-and-submit`
}

/**
 * Testing endpoint that allows saving and submitting questionnaire answers for any SCA user ID. Only available in non-production environments.
 * @summary Test endpoint: Save and submit questionnaire for any SCA user ID
 */
export const useTestSaveAndSubmitQuestionnaireHook = (): (testSaveAndSubmitRequest: NonReadonly<TestSaveAndSubmitRequest>, options?: RequestInit) => Promise<SaveAnswersResponse> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (testSaveAndSubmitRequest: NonReadonly<TestSaveAndSubmitRequest>, options?: RequestInit) => {

        return customFetcher(getTestSaveAndSubmitQuestionnaireUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testSaveAndSubmitRequest)
  }
);
      }
  }





export const getTestSaveAndSubmitQuestionnaireMutationKey = () => ['testSaveAndSubmitQuestionnaire'] as const;

export const useTestSaveAndSubmitQuestionnaireMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useTestSaveAndSubmitQuestionnaireHook>>>, TError,TestSaveAndSubmitQuestionnaireMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useTestSaveAndSubmitQuestionnaireHook>>>, TError,TestSaveAndSubmitQuestionnaireMutationVariables, TContext> => {

const mutationKey = getTestSaveAndSubmitQuestionnaireMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const testSaveAndSubmitQuestionnaire =  useTestSaveAndSubmitQuestionnaireHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useTestSaveAndSubmitQuestionnaireHook>>>, TestSaveAndSubmitQuestionnaireMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  testSaveAndSubmitQuestionnaire(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestSaveAndSubmitQuestionnaireMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useTestSaveAndSubmitQuestionnaireHook>>>>
    export type TestSaveAndSubmitQuestionnaireMutationBody = BodyType<NonReadonly<TestSaveAndSubmitRequest>>
    export type TestSaveAndSubmitQuestionnaireMutationError = ErrorType<ErrorModel>
    export type TestSaveAndSubmitQuestionnaireMutationVariables = {data: BodyType<NonReadonly<TestSaveAndSubmitRequest>>}

    /**
 * @summary Test endpoint: Save and submit questionnaire for any SCA user ID
 */
export const useTestSaveAndSubmitQuestionnaire = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useTestSaveAndSubmitQuestionnaireHook>>>, TError,TestSaveAndSubmitQuestionnaireMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useTestSaveAndSubmitQuestionnaireHook>>>,
        TError,
        TestSaveAndSubmitQuestionnaireMutationVariables,
        TContext
      > => {
      return useMutation(useTestSaveAndSubmitQuestionnaireMutationOptions(options), queryClient);
    }

export const getRateUrl = (base: string,
    target: string,
    date: string,) => {




  return `/rate/${base}/${target}/${date}`
}

/**
 * @summary Get rate for currency pair
 */
export const useRateHook = (): (base: string,
    target: string,
    date: string, options?: RequestInit) => Promise<RateOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (base: string,
    target: string,
    date: string, options?: RequestInit) => {

        return customFetcher(getRateUrl(base,target,date),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getRateQueryKey = (base: string,
    target: string,
    date: string,) => {
    return [
    `/rate/${base}/${target}/${date}`
    ] as const;
    }


export const useRateQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(base: string,
    target: string,
    date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRateQueryKey(base,target,date);

  const rate =  useRateHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useRateHook>>>> = ({ signal }) => rate(base,target,date, { signal });





   return  { queryKey, queryFn, enabled: base !== null && base !== undefined && target !== null && target !== undefined && date !== null && date !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RateQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRateHook>>>>
export type RateQueryError = ErrorType<ErrorModel>


export function useRate<TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(
 base: string,
    target: string,
    date: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useRateHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useRateHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRate<TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(
 base: string,
    target: string,
    date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useRateHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useRateHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRate<TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(
 base: string,
    target: string,
    date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rate for currency pair
 */

export function useRate<TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(
 base: string,
    target: string,
    date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useRateQueryOptions(base,target,date,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useRateSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(base: string,
    target: string,
    date: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRateQueryKey(base,target,date);

  const rate =  useRateHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useRateHook>>>> = ({ signal }) => rate(base,target,date, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type RateSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRateHook>>>>
export type RateSuspenseQueryError = ErrorType<ErrorModel>


export function useRateSuspense<TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(
 base: string,
    target: string,
    date: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRateSuspense<TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(
 base: string,
    target: string,
    date: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRateSuspense<TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(
 base: string,
    target: string,
    date: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rate for currency pair
 */

export function useRateSuspense<TData = Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError = ErrorType<ErrorModel>>(
 base: string,
    target: string,
    date: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useRateHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useRateSuspenseQueryOptions(base,target,date,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSubIbsSharedDataExportUrl = (params: CreateSubIbsSharedDataExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/reports/sub-ibs/exports?${stringifiedParams}` : `/reports/sub-ibs/exports`
}

/**
 * Create a new export job for Sub-IBS shared data reports. Restricted to authorized Sub-IBS users only via LaunchDarkly feature flag.
 * @summary Create Sub-IBS Shared Data Export
 */
export const useCreateSubIbsSharedDataExportHook = (): (params: CreateSubIbsSharedDataExportParams, options?: RequestInit) => Promise<Blob> => {

      const customFetcher = useFetchWrapper();
      return (params: CreateSubIbsSharedDataExportParams, options?: RequestInit) => {

        return customFetcher(getCreateSubIbsSharedDataExportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getCreateSubIbsSharedDataExportQueryKey = (params?: CreateSubIbsSharedDataExportParams,) => {
    return [
    `/reports/sub-ibs/exports`, ...(params ? [params] : [])
    ] as const;
    }


export const useCreateSubIbsSharedDataExportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(params: CreateSubIbsSharedDataExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateSubIbsSharedDataExportQueryKey(params);

  const createSubIbsSharedDataExport =  useCreateSubIbsSharedDataExportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>> = ({ signal }) => createSubIbsSharedDataExport(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreateSubIbsSharedDataExportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>>
export type CreateSubIbsSharedDataExportQueryError = ErrorType<ErrorModel>


export function useCreateSubIbsSharedDataExport<TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(
 params: CreateSubIbsSharedDataExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateSubIbsSharedDataExport<TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(
 params: CreateSubIbsSharedDataExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateSubIbsSharedDataExport<TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(
 params: CreateSubIbsSharedDataExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create Sub-IBS Shared Data Export
 */

export function useCreateSubIbsSharedDataExport<TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(
 params: CreateSubIbsSharedDataExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCreateSubIbsSharedDataExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useCreateSubIbsSharedDataExportSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(params: CreateSubIbsSharedDataExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateSubIbsSharedDataExportQueryKey(params);

  const createSubIbsSharedDataExport =  useCreateSubIbsSharedDataExportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>> = ({ signal }) => createSubIbsSharedDataExport(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type CreateSubIbsSharedDataExportSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>>
export type CreateSubIbsSharedDataExportSuspenseQueryError = ErrorType<ErrorModel>


export function useCreateSubIbsSharedDataExportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(
 params: CreateSubIbsSharedDataExportParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateSubIbsSharedDataExportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(
 params: CreateSubIbsSharedDataExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateSubIbsSharedDataExportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(
 params: CreateSubIbsSharedDataExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create Sub-IBS Shared Data Export
 */

export function useCreateSubIbsSharedDataExportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError = ErrorType<ErrorModel>>(
 params: CreateSubIbsSharedDataExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCreateSubIbsSharedDataExportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCreateSubIbsSharedDataExportSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostTriageUrl = () => {




  return `/triage`
}

/**
 * @summary Start the triage process
 */
export const usePostTriageHook = (): (postTriageInputBody?: NonReadonly<PostTriageInputBody>, options?: RequestInit) => Promise<TriageOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (postTriageInputBody?: NonReadonly<PostTriageInputBody>, options?: RequestInit) => {

        return customFetcher(getPostTriageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(postTriageInputBody)
  }
);
      }
  }





export const getPostTriageMutationKey = () => ['postTriage'] as const;

export const usePostTriageMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTriageHook>>>, TError,PostTriageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTriageHook>>>, TError,PostTriageMutationVariables, TContext> => {

const mutationKey = getPostTriageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postTriage =  usePostTriageHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTriageHook>>>, PostTriageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postTriage(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostTriageMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTriageHook>>>>
    export type PostTriageMutationBody = BodyType<NonReadonly<PostTriageInputBody>> | undefined
    export type PostTriageMutationError = ErrorType<ErrorModel>
    export type PostTriageMutationVariables = {data?: BodyType<NonReadonly<PostTriageInputBody>>}

    /**
 * @summary Start the triage process
 */
export const usePostTriage = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTriageHook>>>, TError,PostTriageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTriageHook>>>,
        TError,
        PostTriageMutationVariables,
        TContext
      > => {
      return useMutation(usePostTriageMutationOptions(options), queryClient);
    }

export const getFindLatestTriageUrl = (params: FindLatestTriageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/triage/latest?${stringifiedParams}` : `/triage/latest`
}

/**
 * @summary Find latest triage by partner type
 */
export const useFindLatestTriageHook = (): (params: FindLatestTriageParams, options?: RequestInit) => Promise<GetTriageListOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params: FindLatestTriageParams, options?: RequestInit) => {

        return customFetcher(getFindLatestTriageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getFindLatestTriageQueryKey = (params?: FindLatestTriageParams,) => {
    return [
    `/triage/latest`, ...(params ? [params] : [])
    ] as const;
    }


export const useFindLatestTriageQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(params: FindLatestTriageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindLatestTriageQueryKey(params);

  const findLatestTriage =  useFindLatestTriageHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>> = ({ signal }) => findLatestTriage(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindLatestTriageQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>>
export type FindLatestTriageQueryError = ErrorType<ErrorModel>


export function useFindLatestTriage<TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(
 params: FindLatestTriageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindLatestTriage<TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(
 params: FindLatestTriageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindLatestTriage<TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(
 params: FindLatestTriageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find latest triage by partner type
 */

export function useFindLatestTriage<TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(
 params: FindLatestTriageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useFindLatestTriageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useFindLatestTriageSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(params: FindLatestTriageParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindLatestTriageQueryKey(params);

  const findLatestTriage =  useFindLatestTriageHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>> = ({ signal }) => findLatestTriage(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type FindLatestTriageSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>>
export type FindLatestTriageSuspenseQueryError = ErrorType<ErrorModel>


export function useFindLatestTriageSuspense<TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(
 params: FindLatestTriageParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindLatestTriageSuspense<TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(
 params: FindLatestTriageParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindLatestTriageSuspense<TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(
 params: FindLatestTriageParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find latest triage by partner type
 */

export function useFindLatestTriageSuspense<TData = Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError = ErrorType<ErrorModel>>(
 params: FindLatestTriageParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFindLatestTriageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useFindLatestTriageSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTriagesUrl = (params?: GetTriagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/triage/list?${stringifiedParams}` : `/triage/list`
}

/**
 * @summary Get triages
 */
export const useGetTriagesHook = (): (params?: GetTriagesParams, options?: RequestInit) => Promise<GetTriageListOutputBody[] | null> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetTriagesParams, options?: RequestInit) => {

        return customFetcher(getGetTriagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetTriagesQueryKey = (params?: GetTriagesParams,) => {
    return [
    `/triage/list`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetTriagesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(params?: GetTriagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTriagesQueryKey(params);

  const getTriages =  useGetTriagesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>> = ({ signal }) => getTriages(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTriagesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>>
export type GetTriagesQueryError = ErrorType<ErrorModel>


export function useGetTriages<TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetTriagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTriages<TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTriagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTriages<TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTriagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get triages
 */

export function useGetTriages<TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTriagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTriagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetTriagesSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(params?: GetTriagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTriagesQueryKey(params);

  const getTriages =  useGetTriagesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>> = ({ signal }) => getTriages(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetTriagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>>
export type GetTriagesSuspenseQueryError = ErrorType<ErrorModel>


export function useGetTriagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetTriagesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTriagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTriagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTriagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTriagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get triages
 */

export function useGetTriagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTriagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTriagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTriagesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchTriageUrl = (triageID: string,) => {




  return `/triage/${triageID}`
}

/**
 * @summary Patch triage process
 */
export const usePatchTriageHook = (): (triageID: string,
    patchTriageInputBody: NonReadonly<PatchTriageInputBody>, options?: RequestInit) => Promise<void> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (triageID: string,
    patchTriageInputBody: NonReadonly<PatchTriageInputBody>, options?: RequestInit) => {

        return customFetcher(getPatchTriageUrl(triageID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchTriageInputBody)
  }
);
      }
  }





export const getPatchTriageMutationKey = () => ['patchTriage'] as const;

export const usePatchTriageMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchTriageHook>>>, TError,PatchTriageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchTriageHook>>>, TError,PatchTriageMutationVariables, TContext> => {

const mutationKey = getPatchTriageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const patchTriage =  usePatchTriageHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePatchTriageHook>>>, PatchTriageMutationVariables> = (props) => {
          const {triageID,data} = props ?? {};

          return  patchTriage(triageID,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchTriageMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePatchTriageHook>>>>
    export type PatchTriageMutationBody = BodyType<NonReadonly<PatchTriageInputBody>>
    export type PatchTriageMutationError = ErrorType<ErrorModel>
    export type PatchTriageMutationVariables = {triageID: string;data: BodyType<NonReadonly<PatchTriageInputBody>>}

    /**
 * @summary Patch triage process
 */
export const usePatchTriage = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchTriageHook>>>, TError,PatchTriageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePatchTriageHook>>>,
        TError,
        PatchTriageMutationVariables,
        TContext
      > => {
      return useMutation(usePatchTriageMutationOptions(options), queryClient);
    }

export const getGetUserUrl = () => {




  return `/user`
}

/**
 * @summary Get user data
 */
export const useGetUserHook = (): (headers?: GetUserHeaders, options?: RequestInit) => Promise<UserProfile> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetUserHeaders, options?: RequestInit) => {

        return customFetcher(getGetUserUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetUserQueryKey = () => {
    return [
    `/user`
    ] as const;
    }


export const useGetUserQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetUserHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey();

  const getUser =  useGetUserHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>> = ({ signal }) => getUser(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>>
export type GetUserQueryError = ErrorType<ErrorModel>


export function useGetUser<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetUserHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetUserHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetUserHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user data
 */

export function useGetUser<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetUserHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetUserSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetUserHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey();

  const getUser =  useGetUserHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>> = ({ signal }) => getUser(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>>
export type GetUserSuspenseQueryError = ErrorType<ErrorModel>


export function useGetUserSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetUserHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetUserHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetUserHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user data
 */

export function useGetUserSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetUserHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserSuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAllChildIbsUrl = () => {




  return `/user/child-ibs`
}

/**
 * @summary Get child IBs for the authenticated user
 */
export const useGetAllChildIbsHook = (): ( options?: RequestInit) => Promise<ChildIB[] | null> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetAllChildIbsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetAllChildIbsQueryKey = () => {
    return [
    `/user/child-ibs`
    ] as const;
    }


export const useGetAllChildIbsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllChildIbsQueryKey();

  const getAllChildIbs =  useGetAllChildIbsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>> = ({ signal }) => getAllChildIbs({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllChildIbsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>>
export type GetAllChildIbsQueryError = ErrorType<ErrorModel>


export function useGetAllChildIbs<TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllChildIbs<TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllChildIbs<TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get child IBs for the authenticated user
 */

export function useGetAllChildIbs<TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAllChildIbsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetAllChildIbsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllChildIbsQueryKey();

  const getAllChildIbs =  useGetAllChildIbsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>> = ({ signal }) => getAllChildIbs({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAllChildIbsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>>
export type GetAllChildIbsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetAllChildIbsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllChildIbsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllChildIbsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get child IBs for the authenticated user
 */

export function useGetAllChildIbsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllChildIbsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAllChildIbsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUserOfferIdsUrl = () => {




  return `/user/offer-ids`
}

/**
 * @summary Get all offer IDs (HOIDs) for the authenticated user
 */
export const useGetUserOfferIdsHook = (): ( options?: RequestInit) => Promise<OfferProgram[] | null> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetUserOfferIdsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetUserOfferIdsQueryKey = () => {
    return [
    `/user/offer-ids`
    ] as const;
    }


export const useGetUserOfferIdsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserOfferIdsQueryKey();

  const getUserOfferIds =  useGetUserOfferIdsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>> = ({ signal }) => getUserOfferIds({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserOfferIdsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>>
export type GetUserOfferIdsQueryError = ErrorType<ErrorModel>


export function useGetUserOfferIds<TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserOfferIds<TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserOfferIds<TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all offer IDs (HOIDs) for the authenticated user
 */

export function useGetUserOfferIds<TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserOfferIdsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetUserOfferIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserOfferIdsQueryKey();

  const getUserOfferIds =  useGetUserOfferIdsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>> = ({ signal }) => getUserOfferIds({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserOfferIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>>
export type GetUserOfferIdsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetUserOfferIdsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserOfferIdsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserOfferIdsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all offer IDs (HOIDs) for the authenticated user
 */

export function useGetUserOfferIdsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserOfferIdsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserOfferIdsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchUserPreferencesUrl = () => {




  return `/user/preferences`
}

/**
 * @summary Patch user preferences
 */
export const usePatchUserPreferencesHook = (): (userPreferencesInputBody: NonReadonly<UserPreferencesInputBody>, options?: RequestInit) => Promise<void> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (userPreferencesInputBody: NonReadonly<UserPreferencesInputBody>, options?: RequestInit) => {

        return customFetcher(getPatchUserPreferencesUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userPreferencesInputBody)
  }
);
      }
  }





export const getPatchUserPreferencesMutationKey = () => ['patchUserPreferences'] as const;

export const usePatchUserPreferencesMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchUserPreferencesHook>>>, TError,PatchUserPreferencesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchUserPreferencesHook>>>, TError,PatchUserPreferencesMutationVariables, TContext> => {

const mutationKey = getPatchUserPreferencesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const patchUserPreferences =  usePatchUserPreferencesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePatchUserPreferencesHook>>>, PatchUserPreferencesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patchUserPreferences(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchUserPreferencesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePatchUserPreferencesHook>>>>
    export type PatchUserPreferencesMutationBody = BodyType<NonReadonly<UserPreferencesInputBody>>
    export type PatchUserPreferencesMutationError = ErrorType<ErrorModel>
    export type PatchUserPreferencesMutationVariables = {data: BodyType<NonReadonly<UserPreferencesInputBody>>}

    /**
 * @summary Patch user preferences
 */
export const usePatchUserPreferences = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchUserPreferencesHook>>>, TError,PatchUserPreferencesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePatchUserPreferencesHook>>>,
        TError,
        PatchUserPreferencesMutationVariables,
        TContext
      > => {
      return useMutation(usePatchUserPreferencesMutationOptions(options), queryClient);
    }

export const getGetUserSubProgramUrl = () => {




  return `/user/sub-program`
}

/**
 * @summary Get whether the IB is a Sub IB in any rebate program
 */
export const useGetUserSubProgramHook = (): ( options?: RequestInit) => Promise<SubProgram> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetUserSubProgramUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetUserSubProgramQueryKey = () => {
    return [
    `/user/sub-program`
    ] as const;
    }


export const useGetUserSubProgramQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSubProgramQueryKey();

  const getUserSubProgram =  useGetUserSubProgramHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>> = ({ signal }) => getUserSubProgram({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSubProgramQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>>
export type GetUserSubProgramQueryError = ErrorType<ErrorModel>


export function useGetUserSubProgram<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSubProgram<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSubProgram<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get whether the IB is a Sub IB in any rebate program
 */

export function useGetUserSubProgram<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserSubProgramQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetUserSubProgramSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSubProgramQueryKey();

  const getUserSubProgram =  useGetUserSubProgramHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>> = ({ signal }) => getUserSubProgram({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserSubProgramSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>>
export type GetUserSubProgramSuspenseQueryError = ErrorType<ErrorModel>


export function useGetUserSubProgramSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSubProgramSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSubProgramSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get whether the IB is a Sub IB in any rebate program
 */

export function useGetUserSubProgramSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserSubProgramHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserSubProgramSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateApiKeyUrl = () => {




  return `/v1/api-keys`
}

/**
 * Creates a Public API key for the authenticated partner and returns its value once. The partner must be eligible for API access, not banned, and have no active key.
 * @summary Create a public API key
 */
export const useCreateApiKeyHook = (): (createAPIKeyInputBody?: NonReadonly<CreateAPIKeyInputBody>, options?: RequestInit) => Promise<CreateAPIKeyOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (createAPIKeyInputBody?: NonReadonly<CreateAPIKeyInputBody>, options?: RequestInit) => {

        return customFetcher(getCreateApiKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAPIKeyInputBody)
  }
);
      }
  }





export const getCreateApiKeyMutationKey = () => ['createApiKey'] as const;

export const useCreateApiKeyMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>, TError,CreateApiKeyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>, TError,CreateApiKeyMutationVariables, TContext> => {

const mutationKey = getCreateApiKeyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createApiKey =  useCreateApiKeyHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>, CreateApiKeyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createApiKey(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>>
    export type CreateApiKeyMutationBody = BodyType<NonReadonly<CreateAPIKeyInputBody>> | undefined
    export type CreateApiKeyMutationError = ErrorType<ErrorModel>
    export type CreateApiKeyMutationVariables = {data?: BodyType<NonReadonly<CreateAPIKeyInputBody>>}

    /**
 * @summary Create a public API key
 */
export const useCreateApiKey = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>, TError,CreateApiKeyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateApiKeyHook>>>,
        TError,
        CreateApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(useCreateApiKeyMutationOptions(options), queryClient);
    }

export const getGetEmailVerificationStatusUrl = () => {




  return `/v1/auth/email-verification-status`
}

/**
 * @summary Get whether the authenticated user's email address is verified
 */
export const useGetEmailVerificationStatusHook = (): ( options?: RequestInit) => Promise<EmailVerificationStatusBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetEmailVerificationStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetEmailVerificationStatusQueryKey = () => {
    return [
    `/v1/auth/email-verification-status`
    ] as const;
    }


export const useGetEmailVerificationStatusQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailVerificationStatusQueryKey();

  const getEmailVerificationStatus =  useGetEmailVerificationStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>> = ({ signal }) => getEmailVerificationStatus({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailVerificationStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>>
export type GetEmailVerificationStatusQueryError = ErrorType<ErrorModel>


export function useGetEmailVerificationStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailVerificationStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailVerificationStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get whether the authenticated user's email address is verified
 */

export function useGetEmailVerificationStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetEmailVerificationStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetEmailVerificationStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailVerificationStatusQueryKey();

  const getEmailVerificationStatus =  useGetEmailVerificationStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>> = ({ signal }) => getEmailVerificationStatus({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetEmailVerificationStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>>
export type GetEmailVerificationStatusSuspenseQueryError = ErrorType<ErrorModel>


export function useGetEmailVerificationStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailVerificationStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailVerificationStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get whether the authenticated user's email address is verified
 */

export function useGetEmailVerificationStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEmailVerificationStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetEmailVerificationStatusSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStepUpMethodUrl = () => {




  return `/v1/auth/step-up-method`
}

/**
 * @summary Get the authenticated user's resolved step-up authentication method (MFA or email)
 */
export const useGetStepUpMethodHook = (): ( options?: RequestInit) => Promise<StepUpMethodBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetStepUpMethodUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetStepUpMethodQueryKey = () => {
    return [
    `/v1/auth/step-up-method`
    ] as const;
    }


export const useGetStepUpMethodQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStepUpMethodQueryKey();

  const getStepUpMethod =  useGetStepUpMethodHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>> = ({ signal }) => getStepUpMethod({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStepUpMethodQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>>
export type GetStepUpMethodQueryError = ErrorType<ErrorModel>


export function useGetStepUpMethod<TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStepUpMethod<TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStepUpMethod<TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the authenticated user's resolved step-up authentication method (MFA or email)
 */

export function useGetStepUpMethod<TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetStepUpMethodQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetStepUpMethodSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStepUpMethodQueryKey();

  const getStepUpMethod =  useGetStepUpMethodHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>> = ({ signal }) => getStepUpMethod({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetStepUpMethodSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>>
export type GetStepUpMethodSuspenseQueryError = ErrorType<ErrorModel>


export function useGetStepUpMethodSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStepUpMethodSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStepUpMethodSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the authenticated user's resolved step-up authentication method (MFA or email)
 */

export function useGetStepUpMethodSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStepUpMethodHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetStepUpMethodSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendVerificationEmailUrl = () => {




  return `/v1/auth/verification-email/send`
}

/**
 * @summary Trigger an Auth0 identity-verification email for the authenticated user
 */
export const useSendVerificationEmailHook = (): ( options?: RequestInit) => Promise<VerifyEmailOutputBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getSendVerificationEmailUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }





export const getSendVerificationEmailMutationKey = () => ['sendVerificationEmail'] as const;

export const useSendVerificationEmailMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendVerificationEmailHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendVerificationEmailHook>>>, TError,void, TContext> => {

const mutationKey = getSendVerificationEmailMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const sendVerificationEmail =  useSendVerificationEmailHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSendVerificationEmailHook>>>, void> = () => {


          return  sendVerificationEmail()
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendVerificationEmailMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSendVerificationEmailHook>>>>

    export type SendVerificationEmailMutationError = ErrorType<ErrorModel>


    /**
 * @summary Trigger an Auth0 identity-verification email for the authenticated user
 */
export const useSendVerificationEmail = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSendVerificationEmailHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useSendVerificationEmailHook>>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(useSendVerificationEmailMutationOptions(options), queryClient);
    }

export const getGetCampaignsUrl = (params?: GetCampaignsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/campaigns?${stringifiedParams}` : `/v1/campaigns`
}

/**
 * Returns the campaigns owned by the authenticated partner, optionally filtered and paginated. The owning partner is always resolved from the auth token.
 * @summary Get campaigns for the authenticated partner
 */
export const useGetCampaignsHook = (): (params?: GetCampaignsParams, options?: RequestInit) => Promise<GetCampaignsOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetCampaignsParams, options?: RequestInit) => {

        return customFetcher(getGetCampaignsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetCampaignsQueryKey = (params?: GetCampaignsParams,) => {
    return [
    `/v1/campaigns`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetCampaignsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignsQueryKey(params);

  const getCampaigns =  useGetCampaignsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>> = ({ signal }) => getCampaigns(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>>
export type GetCampaignsQueryError = ErrorType<ErrorModel>


export function useGetCampaigns<TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetCampaignsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaigns<TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaigns<TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get campaigns for the authenticated partner
 */

export function useGetCampaigns<TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCampaignsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetCampaignsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetCampaignsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignsQueryKey(params);

  const getCampaigns =  useGetCampaignsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>> = ({ signal }) => getCampaigns(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCampaignsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>>
export type GetCampaignsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetCampaignsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetCampaignsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCampaignsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCampaignsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get campaigns for the authenticated partner
 */

export function useGetCampaignsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetCampaignsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCampaignsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCampaignsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCampaignUrl = () => {




  return `/v1/campaigns`
}

/**
 * Creates a campaign owned by the authenticated partner. The owning partner is always resolved from the auth token, never from the request body.
 * @summary Create a campaign
 */
export const useCreateCampaignHook = (): (createCampaignInputBody: NonReadonly<CreateCampaignInputBody>, options?: RequestInit) => Promise<CreateCampaignOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (createCampaignInputBody: NonReadonly<CreateCampaignInputBody>, options?: RequestInit) => {

        return customFetcher(getCreateCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCampaignInputBody)
  }
);
      }
  }





export const getCreateCampaignMutationKey = () => ['createCampaign'] as const;

export const useCreateCampaignMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateCampaignHook>>>, TError,CreateCampaignMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateCampaignHook>>>, TError,CreateCampaignMutationVariables, TContext> => {

const mutationKey = getCreateCampaignMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createCampaign =  useCreateCampaignHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateCampaignHook>>>, CreateCampaignMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCampaign(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCampaignMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateCampaignHook>>>>
    export type CreateCampaignMutationBody = BodyType<NonReadonly<CreateCampaignInputBody>>
    export type CreateCampaignMutationError = ErrorType<ErrorModel>
    export type CreateCampaignMutationVariables = {data: BodyType<NonReadonly<CreateCampaignInputBody>>}

    /**
 * @summary Create a campaign
 */
export const useCreateCampaign = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateCampaignHook>>>, TError,CreateCampaignMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateCampaignHook>>>,
        TError,
        CreateCampaignMutationVariables,
        TContext
      > => {
      return useMutation(useCreateCampaignMutationOptions(options), queryClient);
    }

export const getGetKycApplicantUrl = () => {




  return `/v1/kyc/applicant`
}

/**
 * Retrieves the KYC applicant information for the authenticated user
 * @summary Get KYC Applicant
 */
export const useGetKycApplicantHook = (): ( options?: RequestInit) => Promise<KYCApplicantResponse> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetKycApplicantUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetKycApplicantQueryKey = () => {
    return [
    `/v1/kyc/applicant`
    ] as const;
    }


export const useGetKycApplicantQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetKycApplicantQueryKey();

  const getKycApplicant =  useGetKycApplicantHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>> = ({ signal }) => getKycApplicant({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetKycApplicantQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>>
export type GetKycApplicantQueryError = ErrorType<ErrorModel>


export function useGetKycApplicant<TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKycApplicant<TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKycApplicant<TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get KYC Applicant
 */

export function useGetKycApplicant<TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetKycApplicantQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetKycApplicantSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetKycApplicantQueryKey();

  const getKycApplicant =  useGetKycApplicantHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>> = ({ signal }) => getKycApplicant({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetKycApplicantSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>>
export type GetKycApplicantSuspenseQueryError = ErrorType<ErrorModel>


export function useGetKycApplicantSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKycApplicantSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKycApplicantSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get KYC Applicant
 */

export function useGetKycApplicantSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetKycApplicantHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetKycApplicantSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGenerateKycSessionUrl = () => {




  return `/v1/kyc/session`
}

/**
 * Generates a session for a user to access KYC SDK
 * @summary Generate KYC Session
 */
export const useGenerateKycSessionHook = (): ( options?: RequestInit) => Promise<KYCSessionResponse> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGenerateKycSessionUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }





export const getGenerateKycSessionMutationKey = () => ['generateKycSession'] as const;

export const useGenerateKycSessionMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGenerateKycSessionHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGenerateKycSessionHook>>>, TError,void, TContext> => {

const mutationKey = getGenerateKycSessionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const generateKycSession =  useGenerateKycSessionHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useGenerateKycSessionHook>>>, void> = () => {


          return  generateKycSession()
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateKycSessionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGenerateKycSessionHook>>>>

    export type GenerateKycSessionMutationError = ErrorType<ErrorModel>


    /**
 * @summary Generate KYC Session
 */
export const useGenerateKycSession = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGenerateKycSessionHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useGenerateKycSessionHook>>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(useGenerateKycSessionMutationOptions(options), queryClient);
    }

export const getGetLandingPagesUrl = (params?: GetLandingPagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/links/landing-pages?${stringifiedParams}` : `/v1/links/landing-pages`
}

/**
 * @summary Get landing pages from Tune
 */
export const useGetLandingPagesHook = (): (params?: GetLandingPagesParams, options?: RequestInit) => Promise<GetLandingPagesOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetLandingPagesParams, options?: RequestInit) => {

        return customFetcher(getGetLandingPagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetLandingPagesQueryKey = (params?: GetLandingPagesParams,) => {
    return [
    `/v1/links/landing-pages`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetLandingPagesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(params?: GetLandingPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLandingPagesQueryKey(params);

  const getLandingPages =  useGetLandingPagesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>> = ({ signal }) => getLandingPages(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLandingPagesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>>
export type GetLandingPagesQueryError = ErrorType<ErrorModel>


export function useGetLandingPages<TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLandingPagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLandingPages<TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLandingPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLandingPages<TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLandingPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get landing pages from Tune
 */

export function useGetLandingPages<TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLandingPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLandingPagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetLandingPagesSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(params?: GetLandingPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLandingPagesQueryKey(params);

  const getLandingPages =  useGetLandingPagesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>> = ({ signal }) => getLandingPages(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLandingPagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>>
export type GetLandingPagesSuspenseQueryError = ErrorType<ErrorModel>


export function useGetLandingPagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLandingPagesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLandingPagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLandingPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLandingPagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLandingPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get landing pages from Tune
 */

export function useGetLandingPagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLandingPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLandingPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLandingPagesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReferralLinksUrl = (params?: GetReferralLinksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/links/referral-links?${stringifiedParams}` : `/v1/links/referral-links`
}

/**
 * @summary Get referral links
 */
export const useGetReferralLinksHook = (): (params?: GetReferralLinksParams, options?: RequestInit) => Promise<GetReferralLinksOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetReferralLinksParams, options?: RequestInit) => {

        return customFetcher(getGetReferralLinksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetReferralLinksQueryKey = (params?: GetReferralLinksParams,) => {
    return [
    `/v1/links/referral-links`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetReferralLinksQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(params?: GetReferralLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferralLinksQueryKey(params);

  const getReferralLinks =  useGetReferralLinksHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>> = ({ signal }) => getReferralLinks(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferralLinksQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>>
export type GetReferralLinksQueryError = ErrorType<ErrorModel>


export function useGetReferralLinks<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetReferralLinksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralLinks<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetReferralLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralLinks<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetReferralLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get referral links
 */

export function useGetReferralLinks<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetReferralLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReferralLinksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetReferralLinksSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(params?: GetReferralLinksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferralLinksQueryKey(params);

  const getReferralLinks =  useGetReferralLinksHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>> = ({ signal }) => getReferralLinks(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetReferralLinksSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>>
export type GetReferralLinksSuspenseQueryError = ErrorType<ErrorModel>


export function useGetReferralLinksSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetReferralLinksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralLinksSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetReferralLinksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralLinksSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetReferralLinksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get referral links
 */

export function useGetReferralLinksSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetReferralLinksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReferralLinksSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateReferralLinkUrl = () => {




  return `/v1/links/referral-links`
}

/**
 * @summary Create referral links
 */
export const useCreateReferralLinkHook = (): (createReferralLinkInputBody: NonReadonly<CreateReferralLinkInputBody>, options?: RequestInit) => Promise<CreateReferralLinkOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (createReferralLinkInputBody: NonReadonly<CreateReferralLinkInputBody>, options?: RequestInit) => {

        return customFetcher(getCreateReferralLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createReferralLinkInputBody)
  }
);
      }
  }





export const getCreateReferralLinkMutationKey = () => ['createReferralLink'] as const;

export const useCreateReferralLinkMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReferralLinkHook>>>, TError,CreateReferralLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReferralLinkHook>>>, TError,CreateReferralLinkMutationVariables, TContext> => {

const mutationKey = getCreateReferralLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createReferralLink =  useCreateReferralLinkHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateReferralLinkHook>>>, CreateReferralLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createReferralLink(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReferralLinkMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateReferralLinkHook>>>>
    export type CreateReferralLinkMutationBody = BodyType<NonReadonly<CreateReferralLinkInputBody>>
    export type CreateReferralLinkMutationError = ErrorType<ErrorModel>
    export type CreateReferralLinkMutationVariables = {data: BodyType<NonReadonly<CreateReferralLinkInputBody>>}

    /**
 * @summary Create referral links
 */
export const useCreateReferralLink = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReferralLinkHook>>>, TError,CreateReferralLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateReferralLinkHook>>>,
        TError,
        CreateReferralLinkMutationVariables,
        TContext
      > => {
      return useMutation(useCreateReferralLinkMutationOptions(options), queryClient);
    }

export const getExportReferralLinksUrl = (params?: ExportReferralLinksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/links/referral-links/export?${stringifiedParams}` : `/v1/links/referral-links/export`
}

/**
 * @summary Export referral links as a CSV file
 */
export const useExportReferralLinksHook = (): (params?: ExportReferralLinksParams, options?: RequestInit) => Promise<Blob> => {

      const customFetcher = useFetchWrapper();
      return (params?: ExportReferralLinksParams, options?: RequestInit) => {

        return customFetcher(getExportReferralLinksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getExportReferralLinksQueryKey = (params?: ExportReferralLinksParams,) => {
    return [
    `/v1/links/referral-links/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportReferralLinksQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportReferralLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportReferralLinksQueryKey(params);

  const exportReferralLinks =  useExportReferralLinksHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>> = ({ signal }) => exportReferralLinks(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportReferralLinksQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>>
export type ExportReferralLinksQueryError = ErrorType<ErrorModel>


export function useExportReferralLinks<TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportReferralLinksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportReferralLinks<TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportReferralLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportReferralLinks<TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportReferralLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export referral links as a CSV file
 */

export function useExportReferralLinks<TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportReferralLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportReferralLinksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportReferralLinksSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportReferralLinksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportReferralLinksQueryKey(params);

  const exportReferralLinks =  useExportReferralLinksHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>> = ({ signal }) => exportReferralLinks(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportReferralLinksSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>>
export type ExportReferralLinksSuspenseQueryError = ErrorType<ErrorModel>


export function useExportReferralLinksSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportReferralLinksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportReferralLinksSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportReferralLinksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportReferralLinksSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportReferralLinksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export referral links as a CSV file
 */

export function useExportReferralLinksSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportReferralLinksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportReferralLinksHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportReferralLinksSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetReferralLinksFilterOptionsUrl = () => {




  return `/v1/links/referral-links/filter-options`
}

/**
 * @summary Get filter options for referral links
 */
export const useGetReferralLinksFilterOptionsHook = (): ( options?: RequestInit) => Promise<FilterOptionsOutputBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetReferralLinksFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetReferralLinksFilterOptionsQueryKey = () => {
    return [
    `/v1/links/referral-links/filter-options`
    ] as const;
    }


export const useGetReferralLinksFilterOptionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferralLinksFilterOptionsQueryKey();

  const getReferralLinksFilterOptions =  useGetReferralLinksFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>> = ({ signal }) => getReferralLinksFilterOptions({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferralLinksFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>>
export type GetReferralLinksFilterOptionsQueryError = ErrorType<ErrorModel>


export function useGetReferralLinksFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralLinksFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralLinksFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter options for referral links
 */

export function useGetReferralLinksFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReferralLinksFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetReferralLinksFilterOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferralLinksFilterOptionsQueryKey();

  const getReferralLinksFilterOptions =  useGetReferralLinksFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>> = ({ signal }) => getReferralLinksFilterOptions({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetReferralLinksFilterOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>>
export type GetReferralLinksFilterOptionsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetReferralLinksFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralLinksFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralLinksFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter options for referral links
 */

export function useGetReferralLinksFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReferralLinksFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReferralLinksFilterOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRenameReferralLinkUrl = (id: string,) => {




  return `/v1/links/referral-links/${id}`
}

/**
 * @summary Rename a referral link
 */
export const useRenameReferralLinkHook = (): (id: string,
    renameReferralLinkInputBody: NonReadonly<RenameReferralLinkInputBody>, options?: RequestInit) => Promise<void> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (id: string,
    renameReferralLinkInputBody: NonReadonly<RenameReferralLinkInputBody>, options?: RequestInit) => {

        return customFetcher(getRenameReferralLinkUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(renameReferralLinkInputBody)
  }
);
      }
  }





export const getRenameReferralLinkMutationKey = () => ['renameReferralLink'] as const;

export const useRenameReferralLinkMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRenameReferralLinkHook>>>, TError,RenameReferralLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRenameReferralLinkHook>>>, TError,RenameReferralLinkMutationVariables, TContext> => {

const mutationKey = getRenameReferralLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const renameReferralLink =  useRenameReferralLinkHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useRenameReferralLinkHook>>>, RenameReferralLinkMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  renameReferralLink(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameReferralLinkMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRenameReferralLinkHook>>>>
    export type RenameReferralLinkMutationBody = BodyType<NonReadonly<RenameReferralLinkInputBody>>
    export type RenameReferralLinkMutationError = ErrorType<ErrorModel>
    export type RenameReferralLinkMutationVariables = {id: string;data: BodyType<NonReadonly<RenameReferralLinkInputBody>>}

    /**
 * @summary Rename a referral link
 */
export const useRenameReferralLink = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRenameReferralLinkHook>>>, TError,RenameReferralLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useRenameReferralLinkHook>>>,
        TError,
        RenameReferralLinkMutationVariables,
        TContext
      > => {
      return useMutation(useRenameReferralLinkMutationOptions(options), queryClient);
    }

export const getGetTargetPagesUrl = (params?: GetTargetPagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/links/target-pages?${stringifiedParams}` : `/v1/links/target-pages`
}

/**
 * @summary Get target pages from Tune
 */
export const useGetTargetPagesHook = (): (params?: GetTargetPagesParams, options?: RequestInit) => Promise<OutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetTargetPagesParams, options?: RequestInit) => {

        return customFetcher(getGetTargetPagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetTargetPagesQueryKey = (params?: GetTargetPagesParams,) => {
    return [
    `/v1/links/target-pages`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetTargetPagesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(params?: GetTargetPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetPagesQueryKey(params);

  const getTargetPages =  useGetTargetPagesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>> = ({ signal }) => getTargetPages(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargetPagesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>>
export type GetTargetPagesQueryError = ErrorType<ErrorModel>


export function useGetTargetPages<TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetTargetPagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetPages<TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTargetPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetPages<TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTargetPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target pages from Tune
 */

export function useGetTargetPages<TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTargetPagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTargetPagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetTargetPagesSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(params?: GetTargetPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargetPagesQueryKey(params);

  const getTargetPages =  useGetTargetPagesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>> = ({ signal }) => getTargetPages(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetTargetPagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>>
export type GetTargetPagesSuspenseQueryError = ErrorType<ErrorModel>


export function useGetTargetPagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetTargetPagesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetPagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTargetPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargetPagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTargetPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get target pages from Tune
 */

export function useGetTargetPagesSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetTargetPagesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTargetPagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTargetPagesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketingBannersUrl = (params?: GetMarketingBannersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/marketing-banners?${stringifiedParams}` : `/v1/marketing-banners`
}

/**
 * @summary List the calling IB's marketing banners
 */
export const useGetMarketingBannersHook = (): (params?: GetMarketingBannersParams, options?: RequestInit) => Promise<GetMarketingBannersOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetMarketingBannersParams, options?: RequestInit) => {

        return customFetcher(getGetMarketingBannersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetMarketingBannersQueryKey = (params?: GetMarketingBannersParams,) => {
    return [
    `/v1/marketing-banners`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetMarketingBannersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(params?: GetMarketingBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingBannersQueryKey(params);

  const getMarketingBanners =  useGetMarketingBannersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>> = ({ signal }) => getMarketingBanners(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingBannersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>>
export type GetMarketingBannersQueryError = ErrorType<ErrorModel>


export function useGetMarketingBanners<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetMarketingBannersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingBanners<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingBanners<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the calling IB's marketing banners
 */

export function useGetMarketingBanners<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMarketingBannersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetMarketingBannersSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(params?: GetMarketingBannersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingBannersQueryKey(params);

  const getMarketingBanners =  useGetMarketingBannersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>> = ({ signal }) => getMarketingBanners(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMarketingBannersSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>>
export type GetMarketingBannersSuspenseQueryError = ErrorType<ErrorModel>


export function useGetMarketingBannersSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetMarketingBannersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingBannersSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingBannersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingBannersSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingBannersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the calling IB's marketing banners
 */

export function useGetMarketingBannersSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetMarketingBannersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMarketingBannersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateMarketingBannerUrl = () => {




  return `/v1/marketing-banners`
}

/**
 * @summary Create marketing banner (HTML creative code)
 */
export const useCreateMarketingBannerHook = (): (createMarketingBannerInputBody: NonReadonly<CreateMarketingBannerInputBody>, options?: RequestInit) => Promise<CreateMarketingBannerOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (createMarketingBannerInputBody: NonReadonly<CreateMarketingBannerInputBody>, options?: RequestInit) => {

        return customFetcher(getCreateMarketingBannerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createMarketingBannerInputBody)
  }
);
      }
  }





export const getCreateMarketingBannerMutationKey = () => ['createMarketingBanner'] as const;

export const useCreateMarketingBannerMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateMarketingBannerHook>>>, TError,CreateMarketingBannerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateMarketingBannerHook>>>, TError,CreateMarketingBannerMutationVariables, TContext> => {

const mutationKey = getCreateMarketingBannerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createMarketingBanner =  useCreateMarketingBannerHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateMarketingBannerHook>>>, CreateMarketingBannerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMarketingBanner(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMarketingBannerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateMarketingBannerHook>>>>
    export type CreateMarketingBannerMutationBody = BodyType<NonReadonly<CreateMarketingBannerInputBody>>
    export type CreateMarketingBannerMutationError = ErrorType<ErrorModel>
    export type CreateMarketingBannerMutationVariables = {data: BodyType<NonReadonly<CreateMarketingBannerInputBody>>}

    /**
 * @summary Create marketing banner (HTML creative code)
 */
export const useCreateMarketingBanner = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateMarketingBannerHook>>>, TError,CreateMarketingBannerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateMarketingBannerHook>>>,
        TError,
        CreateMarketingBannerMutationVariables,
        TContext
      > => {
      return useMutation(useCreateMarketingBannerMutationOptions(options), queryClient);
    }

export const getGetAffiliateApprovalStatusUrl = (params: GetAffiliateApprovalStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/marketing-banners/affiliate-approval-status?${stringifiedParams}` : `/v1/marketing-banners/affiliate-approval-status`
}

/**
 * @summary Get affiliate approval status for an offer
 */
export const useGetAffiliateApprovalStatusHook = (): (params: GetAffiliateApprovalStatusParams, options?: RequestInit) => Promise<GetAffiliateApprovalStatusBody> => {

      const customFetcher = useFetchWrapper();
      return (params: GetAffiliateApprovalStatusParams, options?: RequestInit) => {

        return customFetcher(getGetAffiliateApprovalStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetAffiliateApprovalStatusQueryKey = (params?: GetAffiliateApprovalStatusParams,) => {
    return [
    `/v1/marketing-banners/affiliate-approval-status`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetAffiliateApprovalStatusQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(params: GetAffiliateApprovalStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAffiliateApprovalStatusQueryKey(params);

  const getAffiliateApprovalStatus =  useGetAffiliateApprovalStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>> = ({ signal }) => getAffiliateApprovalStatus(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAffiliateApprovalStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>>
export type GetAffiliateApprovalStatusQueryError = ErrorType<ErrorModel>


export function useGetAffiliateApprovalStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetAffiliateApprovalStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAffiliateApprovalStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetAffiliateApprovalStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAffiliateApprovalStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetAffiliateApprovalStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get affiliate approval status for an offer
 */

export function useGetAffiliateApprovalStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetAffiliateApprovalStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAffiliateApprovalStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetAffiliateApprovalStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(params: GetAffiliateApprovalStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAffiliateApprovalStatusQueryKey(params);

  const getAffiliateApprovalStatus =  useGetAffiliateApprovalStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>> = ({ signal }) => getAffiliateApprovalStatus(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAffiliateApprovalStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>>
export type GetAffiliateApprovalStatusSuspenseQueryError = ErrorType<ErrorModel>


export function useGetAffiliateApprovalStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetAffiliateApprovalStatusParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAffiliateApprovalStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetAffiliateApprovalStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAffiliateApprovalStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetAffiliateApprovalStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get affiliate approval status for an offer
 */

export function useGetAffiliateApprovalStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetAffiliateApprovalStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAffiliateApprovalStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAffiliateApprovalStatusSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBannerAssetsUrl = (params?: GetBannerAssetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/marketing-banners/assets?${stringifiedParams}` : `/v1/marketing-banners/assets`
}

/**
 * @summary Get banner assets
 */
export const useGetBannerAssetsHook = (): (params?: GetBannerAssetsParams, options?: RequestInit) => Promise<GetBannerAssetsBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetBannerAssetsParams, options?: RequestInit) => {

        return customFetcher(getGetBannerAssetsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetBannerAssetsQueryKey = (params?: GetBannerAssetsParams,) => {
    return [
    `/v1/marketing-banners/assets`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetBannerAssetsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetBannerAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBannerAssetsQueryKey(params);

  const getBannerAssets =  useGetBannerAssetsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>> = ({ signal }) => getBannerAssets(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBannerAssetsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>>
export type GetBannerAssetsQueryError = ErrorType<ErrorModel>


export function useGetBannerAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetBannerAssetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBannerAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetBannerAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBannerAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetBannerAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get banner assets
 */

export function useGetBannerAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetBannerAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBannerAssetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetBannerAssetsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetBannerAssetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBannerAssetsQueryKey(params);

  const getBannerAssets =  useGetBannerAssetsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>> = ({ signal }) => getBannerAssets(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetBannerAssetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>>
export type GetBannerAssetsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetBannerAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetBannerAssetsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBannerAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetBannerAssetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBannerAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetBannerAssetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get banner assets
 */

export function useGetBannerAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetBannerAssetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBannerAssetsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBannerAssetsFilterOptionsUrl = () => {




  return `/v1/marketing-banners/assets/filter-options`
}

/**
 * @summary Get filter dropdown values (languages, sizes) across all banner assets
 */
export const useGetBannerAssetsFilterOptionsHook = (): ( options?: RequestInit) => Promise<BannerAssetsFilterOptionsOutputBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetBannerAssetsFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetBannerAssetsFilterOptionsQueryKey = () => {
    return [
    `/v1/marketing-banners/assets/filter-options`
    ] as const;
    }


export const useGetBannerAssetsFilterOptionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBannerAssetsFilterOptionsQueryKey();

  const getBannerAssetsFilterOptions =  useGetBannerAssetsFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>> = ({ signal }) => getBannerAssetsFilterOptions({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBannerAssetsFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>>
export type GetBannerAssetsFilterOptionsQueryError = ErrorType<ErrorModel>


export function useGetBannerAssetsFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBannerAssetsFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBannerAssetsFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter dropdown values (languages, sizes) across all banner assets
 */

export function useGetBannerAssetsFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBannerAssetsFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetBannerAssetsFilterOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBannerAssetsFilterOptionsQueryKey();

  const getBannerAssetsFilterOptions =  useGetBannerAssetsFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>> = ({ signal }) => getBannerAssetsFilterOptions({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetBannerAssetsFilterOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>>
export type GetBannerAssetsFilterOptionsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetBannerAssetsFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBannerAssetsFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBannerAssetsFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter dropdown values (languages, sizes) across all banner assets
 */

export function useGetBannerAssetsFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBannerAssetsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBannerAssetsFilterOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDownloadBannerImageUrl = (params: DownloadBannerImageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/marketing-banners/download?${stringifiedParams}` : `/v1/marketing-banners/download`
}

/**
 * @summary Proxy-download a banner image from an allow-listed media host
 */
export const useDownloadBannerImageHook = (): (params: DownloadBannerImageParams, options?: RequestInit) => Promise<Blob> => {

      const customFetcher = useFetchWrapper();
      return (params: DownloadBannerImageParams, options?: RequestInit) => {

        return customFetcher(getDownloadBannerImageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getDownloadBannerImageQueryKey = (params?: DownloadBannerImageParams,) => {
    return [
    `/v1/marketing-banners/download`, ...(params ? [params] : [])
    ] as const;
    }


export const useDownloadBannerImageQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(params: DownloadBannerImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadBannerImageQueryKey(params);

  const downloadBannerImage =  useDownloadBannerImageHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>> = ({ signal }) => downloadBannerImage(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadBannerImageQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>>
export type DownloadBannerImageQueryError = ErrorType<ErrorModel>


export function useDownloadBannerImage<TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(
 params: DownloadBannerImageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadBannerImage<TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(
 params: DownloadBannerImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadBannerImage<TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(
 params: DownloadBannerImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Proxy-download a banner image from an allow-listed media host
 */

export function useDownloadBannerImage<TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(
 params: DownloadBannerImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadBannerImageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useDownloadBannerImageSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(params: DownloadBannerImageParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadBannerImageQueryKey(params);

  const downloadBannerImage =  useDownloadBannerImageHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>> = ({ signal }) => downloadBannerImage(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type DownloadBannerImageSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>>
export type DownloadBannerImageSuspenseQueryError = ErrorType<ErrorModel>


export function useDownloadBannerImageSuspense<TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(
 params: DownloadBannerImageParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadBannerImageSuspense<TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(
 params: DownloadBannerImageParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadBannerImageSuspense<TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(
 params: DownloadBannerImageParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Proxy-download a banner image from an allow-listed media host
 */

export function useDownloadBannerImageSuspense<TData = Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError = ErrorType<ErrorModel>>(
 params: DownloadBannerImageParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDownloadBannerImageHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadBannerImageSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportMarketingBannersUrl = (params?: ExportMarketingBannersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/marketing-banners/export?${stringifiedParams}` : `/v1/marketing-banners/export`
}

/**
 * @summary Export the calling IB's marketing banners as a CSV file
 */
export const useExportMarketingBannersHook = (): (params?: ExportMarketingBannersParams, options?: RequestInit) => Promise<Blob> => {

      const customFetcher = useFetchWrapper();
      return (params?: ExportMarketingBannersParams, options?: RequestInit) => {

        return customFetcher(getExportMarketingBannersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getExportMarketingBannersQueryKey = (params?: ExportMarketingBannersParams,) => {
    return [
    `/v1/marketing-banners/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportMarketingBannersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportMarketingBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportMarketingBannersQueryKey(params);

  const exportMarketingBanners =  useExportMarketingBannersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>> = ({ signal }) => exportMarketingBanners(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportMarketingBannersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>>
export type ExportMarketingBannersQueryError = ErrorType<ErrorModel>


export function useExportMarketingBanners<TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportMarketingBannersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportMarketingBanners<TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportMarketingBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportMarketingBanners<TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportMarketingBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export the calling IB's marketing banners as a CSV file
 */

export function useExportMarketingBanners<TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportMarketingBannersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportMarketingBannersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportMarketingBannersSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportMarketingBannersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportMarketingBannersQueryKey(params);

  const exportMarketingBanners =  useExportMarketingBannersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>> = ({ signal }) => exportMarketingBanners(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportMarketingBannersSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>>
export type ExportMarketingBannersSuspenseQueryError = ErrorType<ErrorModel>


export function useExportMarketingBannersSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportMarketingBannersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportMarketingBannersSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportMarketingBannersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportMarketingBannersSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportMarketingBannersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export the calling IB's marketing banners as a CSV file
 */

export function useExportMarketingBannersSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportMarketingBannersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportMarketingBannersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportMarketingBannersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketingBannersFilterOptionsUrl = () => {




  return `/v1/marketing-banners/filter-options`
}

/**
 * @summary Get filter dropdown values (banner groups, rebate programs) for the calling IB's marketing banners
 */
export const useGetMarketingBannersFilterOptionsHook = (): ( options?: RequestInit) => Promise<MarketingBannersFilterOptionsOutputBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetMarketingBannersFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetMarketingBannersFilterOptionsQueryKey = () => {
    return [
    `/v1/marketing-banners/filter-options`
    ] as const;
    }


export const useGetMarketingBannersFilterOptionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingBannersFilterOptionsQueryKey();

  const getMarketingBannersFilterOptions =  useGetMarketingBannersFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>> = ({ signal }) => getMarketingBannersFilterOptions({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingBannersFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>>
export type GetMarketingBannersFilterOptionsQueryError = ErrorType<ErrorModel>


export function useGetMarketingBannersFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingBannersFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingBannersFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter dropdown values (banner groups, rebate programs) for the calling IB's marketing banners
 */

export function useGetMarketingBannersFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMarketingBannersFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetMarketingBannersFilterOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingBannersFilterOptionsQueryKey();

  const getMarketingBannersFilterOptions =  useGetMarketingBannersFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>> = ({ signal }) => getMarketingBannersFilterOptions({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMarketingBannersFilterOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>>
export type GetMarketingBannersFilterOptionsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetMarketingBannersFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingBannersFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingBannersFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter dropdown values (banner groups, rebate programs) for the calling IB's marketing banners
 */

export function useGetMarketingBannersFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMarketingBannersFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMarketingBannersFilterOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getLocateMarketingBannerUrl = (params: LocateMarketingBannerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/marketing-banners/locate?${stringifiedParams}` : `/v1/marketing-banners/locate`
}

/**
 * @summary Find which page a marketing banner falls on (for deep-linking to it)
 */
export const useLocateMarketingBannerHook = (): (params: LocateMarketingBannerParams, options?: RequestInit) => Promise<LocateMarketingBannerOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params: LocateMarketingBannerParams, options?: RequestInit) => {

        return customFetcher(getLocateMarketingBannerUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getLocateMarketingBannerQueryKey = (params?: LocateMarketingBannerParams,) => {
    return [
    `/v1/marketing-banners/locate`, ...(params ? [params] : [])
    ] as const;
    }


export const useLocateMarketingBannerQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(params: LocateMarketingBannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocateMarketingBannerQueryKey(params);

  const locateMarketingBanner =  useLocateMarketingBannerHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>> = ({ signal }) => locateMarketingBanner(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocateMarketingBannerQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>>
export type LocateMarketingBannerQueryError = ErrorType<ErrorModel>


export function useLocateMarketingBanner<TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(
 params: LocateMarketingBannerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocateMarketingBanner<TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(
 params: LocateMarketingBannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocateMarketingBanner<TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(
 params: LocateMarketingBannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find which page a marketing banner falls on (for deep-linking to it)
 */

export function useLocateMarketingBanner<TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(
 params: LocateMarketingBannerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useLocateMarketingBannerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useLocateMarketingBannerSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(params: LocateMarketingBannerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocateMarketingBannerQueryKey(params);

  const locateMarketingBanner =  useLocateMarketingBannerHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>> = ({ signal }) => locateMarketingBanner(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type LocateMarketingBannerSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>>
export type LocateMarketingBannerSuspenseQueryError = ErrorType<ErrorModel>


export function useLocateMarketingBannerSuspense<TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(
 params: LocateMarketingBannerParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocateMarketingBannerSuspense<TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(
 params: LocateMarketingBannerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocateMarketingBannerSuspense<TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(
 params: LocateMarketingBannerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find which page a marketing banner falls on (for deep-linking to it)
 */

export function useLocateMarketingBannerSuspense<TData = Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError = ErrorType<ErrorModel>>(
 params: LocateMarketingBannerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLocateMarketingBannerHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useLocateMarketingBannerSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRenameMarketingBannerUrl = (id: string,) => {




  return `/v1/marketing-banners/${id}`
}

/**
 * @summary Rename a marketing banner
 */
export const useRenameMarketingBannerHook = (): (id: string,
    renameMarketingBannerInputBody: NonReadonly<RenameMarketingBannerInputBody>, options?: RequestInit) => Promise<void> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (id: string,
    renameMarketingBannerInputBody: NonReadonly<RenameMarketingBannerInputBody>, options?: RequestInit) => {

        return customFetcher(getRenameMarketingBannerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(renameMarketingBannerInputBody)
  }
);
      }
  }





export const getRenameMarketingBannerMutationKey = () => ['renameMarketingBanner'] as const;

export const useRenameMarketingBannerMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRenameMarketingBannerHook>>>, TError,RenameMarketingBannerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRenameMarketingBannerHook>>>, TError,RenameMarketingBannerMutationVariables, TContext> => {

const mutationKey = getRenameMarketingBannerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const renameMarketingBanner =  useRenameMarketingBannerHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useRenameMarketingBannerHook>>>, RenameMarketingBannerMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  renameMarketingBanner(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameMarketingBannerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRenameMarketingBannerHook>>>>
    export type RenameMarketingBannerMutationBody = BodyType<NonReadonly<RenameMarketingBannerInputBody>>
    export type RenameMarketingBannerMutationError = ErrorType<ErrorModel>
    export type RenameMarketingBannerMutationVariables = {id: string;data: BodyType<NonReadonly<RenameMarketingBannerInputBody>>}

    /**
 * @summary Rename a marketing banner
 */
export const useRenameMarketingBanner = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRenameMarketingBannerHook>>>, TError,RenameMarketingBannerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useRenameMarketingBannerHook>>>,
        TError,
        RenameMarketingBannerMutationVariables,
        TContext
      > => {
      return useMutation(useRenameMarketingBannerMutationOptions(options), queryClient);
    }

export const getGetRebateProgramsUrl = (params: GetRebateProgramsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/master/rebate-programs?${stringifiedParams}` : `/v1/master/rebate-programs`
}

/**
 * @summary List a Master's shared rebate programs (search, filter, sort, paginate)
 */
export const useGetRebateProgramsHook = (): (params: GetRebateProgramsParams, options?: RequestInit) => Promise<SharedRebateProgramsListBody> => {

      const customFetcher = useFetchWrapper();
      return (params: GetRebateProgramsParams, options?: RequestInit) => {

        return customFetcher(getGetRebateProgramsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetRebateProgramsQueryKey = (params?: GetRebateProgramsParams,) => {
    return [
    `/v1/master/rebate-programs`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetRebateProgramsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(params: GetRebateProgramsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsQueryKey(params);

  const getRebatePrograms =  useGetRebateProgramsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>> = ({ signal }) => getRebatePrograms(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateProgramsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>>
export type GetRebateProgramsQueryError = ErrorType<ErrorModel>


export function useGetRebatePrograms<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebatePrograms<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebatePrograms<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a Master's shared rebate programs (search, filter, sort, paginate)
 */

export function useGetRebatePrograms<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateProgramsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(params: GetRebateProgramsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsQueryKey(params);

  const getRebatePrograms =  useGetRebateProgramsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>> = ({ signal }) => getRebatePrograms(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateProgramsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>>
export type GetRebateProgramsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a Master's shared rebate programs (search, filter, sort, paginate)
 */

export function useGetRebateProgramsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateRebateProgramUrl = () => {




  return `/v1/master/rebate-programs`
}

/**
 * Mints a HOID on Tune, registers the split in GRS, and mirrors the program into Partners Registry. Optional per-symbol and per-asset-class overrides are set at creation time only.
 * @summary Create a shared rebate program with 1-2 Sub IBs
 */
export const useCreateRebateProgramHook = (): (createInputBody: NonReadonly<CreateInputBody>,
    headers?: CreateRebateProgramHeaders, options?: RequestInit) => Promise<CreateOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (createInputBody: NonReadonly<CreateInputBody>,
    headers?: CreateRebateProgramHeaders, options?: RequestInit) => {

        return customFetcher(getCreateRebateProgramUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(createInputBody)
  }
);
      }
  }





export const getCreateRebateProgramMutationKey = () => ['createRebateProgram'] as const;

export const useCreateRebateProgramMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateRebateProgramHook>>>, TError,CreateRebateProgramMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateRebateProgramHook>>>, TError,CreateRebateProgramMutationVariables, TContext> => {

const mutationKey = getCreateRebateProgramMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createRebateProgram =  useCreateRebateProgramHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateRebateProgramHook>>>, CreateRebateProgramMutationVariables> = (props) => {
          const {data,headers} = props ?? {};

          return  createRebateProgram(data,headers,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRebateProgramMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateRebateProgramHook>>>>
    export type CreateRebateProgramMutationBody = BodyType<NonReadonly<CreateInputBody>>
    export type CreateRebateProgramMutationError = ErrorType<ErrorModel>
    export type CreateRebateProgramMutationVariables = {data: BodyType<NonReadonly<CreateInputBody>>;headers?: CreateRebateProgramHeaders}

    /**
 * @summary Create a shared rebate program with 1-2 Sub IBs
 */
export const useCreateRebateProgram = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateRebateProgramHook>>>, TError,CreateRebateProgramMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateRebateProgramHook>>>,
        TError,
        CreateRebateProgramMutationVariables,
        TContext
      > => {
      return useMutation(useCreateRebateProgramMutationOptions(options), queryClient);
    }

export const getGetRebateProgramsAssetsUrl = () => {




  return `/v1/master/rebate-programs/assets`
}

/**
 * @summary Get the catalogue of asset classes and symbols available for rebate programs
 */
export const useGetRebateProgramsAssetsHook = (): ( options?: RequestInit) => Promise<AssetsOutputBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetRebateProgramsAssetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetRebateProgramsAssetsQueryKey = () => {
    return [
    `/v1/master/rebate-programs/assets`
    ] as const;
    }


export const useGetRebateProgramsAssetsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsAssetsQueryKey();

  const getRebateProgramsAssets =  useGetRebateProgramsAssetsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>> = ({ signal }) => getRebateProgramsAssets({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateProgramsAssetsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>>
export type GetRebateProgramsAssetsQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the catalogue of asset classes and symbols available for rebate programs
 */

export function useGetRebateProgramsAssets<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsAssetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateProgramsAssetsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsAssetsQueryKey();

  const getRebateProgramsAssets =  useGetRebateProgramsAssetsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>> = ({ signal }) => getRebateProgramsAssets({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateProgramsAssetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>>
export type GetRebateProgramsAssetsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the catalogue of asset classes and symbols available for rebate programs
 */

export function useGetRebateProgramsAssetsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsAssetsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsAssetsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportRebateProgramsUrl = (params: ExportRebateProgramsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/master/rebate-programs/export?${stringifiedParams}` : `/v1/master/rebate-programs/export`
}

/**
 * @summary Export a Master's shared rebate programs as CSV (same filters as the list endpoint, unpaginated)
 */
export const useExportRebateProgramsHook = (): (params: ExportRebateProgramsParams, options?: RequestInit) => Promise<Blob> => {

      const customFetcher = useFetchWrapper();
      return (params: ExportRebateProgramsParams, options?: RequestInit) => {

        return customFetcher(getExportRebateProgramsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getExportRebateProgramsQueryKey = (params?: ExportRebateProgramsParams,) => {
    return [
    `/v1/master/rebate-programs/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportRebateProgramsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(params: ExportRebateProgramsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportRebateProgramsQueryKey(params);

  const exportRebatePrograms =  useExportRebateProgramsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>> = ({ signal }) => exportRebatePrograms(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportRebateProgramsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>>
export type ExportRebateProgramsQueryError = ErrorType<ErrorModel>


export function useExportRebatePrograms<TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: ExportRebateProgramsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportRebatePrograms<TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: ExportRebateProgramsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportRebatePrograms<TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: ExportRebateProgramsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export a Master's shared rebate programs as CSV (same filters as the list endpoint, unpaginated)
 */

export function useExportRebatePrograms<TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: ExportRebateProgramsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportRebateProgramsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportRebateProgramsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(params: ExportRebateProgramsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportRebateProgramsQueryKey(params);

  const exportRebatePrograms =  useExportRebateProgramsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>> = ({ signal }) => exportRebatePrograms(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportRebateProgramsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>>
export type ExportRebateProgramsSuspenseQueryError = ErrorType<ErrorModel>


export function useExportRebateProgramsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: ExportRebateProgramsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportRebateProgramsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: ExportRebateProgramsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportRebateProgramsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: ExportRebateProgramsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export a Master's shared rebate programs as CSV (same filters as the list endpoint, unpaginated)
 */

export function useExportRebateProgramsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError = ErrorType<ErrorModel>>(
 params: ExportRebateProgramsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportRebateProgramsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportRebateProgramsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRebateProgramsFilterOptionsUrl = () => {




  return `/v1/master/rebate-programs/filter-options`
}

/**
 * @summary Get filter dropdown options for shared rebate programs
 */
export const useGetRebateProgramsFilterOptionsHook = (): ( options?: RequestInit) => Promise<SharedRebateProgramsFilterOptionsOutputBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetRebateProgramsFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetRebateProgramsFilterOptionsQueryKey = () => {
    return [
    `/v1/master/rebate-programs/filter-options`
    ] as const;
    }


export const useGetRebateProgramsFilterOptionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsFilterOptionsQueryKey();

  const getRebateProgramsFilterOptions =  useGetRebateProgramsFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>> = ({ signal }) => getRebateProgramsFilterOptions({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateProgramsFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>>
export type GetRebateProgramsFilterOptionsQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter dropdown options for shared rebate programs
 */

export function useGetRebateProgramsFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateProgramsFilterOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsFilterOptionsQueryKey();

  const getRebateProgramsFilterOptions =  useGetRebateProgramsFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>> = ({ signal }) => getRebateProgramsFilterOptions({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateProgramsFilterOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>>
export type GetRebateProgramsFilterOptionsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter dropdown options for shared rebate programs
 */

export function useGetRebateProgramsFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsFilterOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRebateProgramsStatsUrl = (params: GetRebateProgramsStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/master/rebate-programs/stats?${stringifiedParams}` : `/v1/master/rebate-programs/stats`
}

/**
 * @summary Get KPI stats for shared rebate programs
 */
export const useGetRebateProgramsStatsHook = (): (params: GetRebateProgramsStatsParams, options?: RequestInit) => Promise<SharedRebateProgramsStats> => {

      const customFetcher = useFetchWrapper();
      return (params: GetRebateProgramsStatsParams, options?: RequestInit) => {

        return customFetcher(getGetRebateProgramsStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetRebateProgramsStatsQueryKey = (params?: GetRebateProgramsStatsParams,) => {
    return [
    `/v1/master/rebate-programs/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetRebateProgramsStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(params: GetRebateProgramsStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsStatsQueryKey(params);

  const getRebateProgramsStats =  useGetRebateProgramsStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>> = ({ signal }) => getRebateProgramsStats(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateProgramsStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>>
export type GetRebateProgramsStatsQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get KPI stats for shared rebate programs
 */

export function useGetRebateProgramsStats<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateProgramsStatsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(params: GetRebateProgramsStatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsStatsQueryKey(params);

  const getRebateProgramsStats =  useGetRebateProgramsStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>> = ({ signal }) => getRebateProgramsStats(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateProgramsStatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>>
export type GetRebateProgramsStatsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsStatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsStatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsStatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get KPI stats for shared rebate programs
 */

export function useGetRebateProgramsStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateProgramsStatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsStatsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRebateProgramDetailUrl = (id: string,
    params: GetRebateProgramDetailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/master/rebate-programs/${id}?${stringifiedParams}` : `/v1/master/rebate-programs/${id}`
}

/**
 * @summary Get detail (performance + rebate split payout) for one shared rebate program
 */
export const useGetRebateProgramDetailHook = (): (id: string,
    params: GetRebateProgramDetailParams, options?: RequestInit) => Promise<ProgramDetail> => {

      const customFetcher = useFetchWrapper();
      return (id: string,
    params: GetRebateProgramDetailParams, options?: RequestInit) => {

        return customFetcher(getGetRebateProgramDetailUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetRebateProgramDetailQueryKey = (id: string,
    params?: GetRebateProgramDetailParams,) => {
    return [
    `/v1/master/rebate-programs/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetRebateProgramDetailQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(id: string,
    params: GetRebateProgramDetailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramDetailQueryKey(id,params);

  const getRebateProgramDetail =  useGetRebateProgramDetailHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>> = ({ signal }) => getRebateProgramDetail(id,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateProgramDetailQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>>
export type GetRebateProgramDetailQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramDetail<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(
 id: string,
    params: GetRebateProgramDetailParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramDetail<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(
 id: string,
    params: GetRebateProgramDetailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramDetail<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(
 id: string,
    params: GetRebateProgramDetailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get detail (performance + rebate split payout) for one shared rebate program
 */

export function useGetRebateProgramDetail<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(
 id: string,
    params: GetRebateProgramDetailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramDetailQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateProgramDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(id: string,
    params: GetRebateProgramDetailParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramDetailQueryKey(id,params);

  const getRebateProgramDetail =  useGetRebateProgramDetailHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>> = ({ signal }) => getRebateProgramDetail(id,params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateProgramDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>>
export type GetRebateProgramDetailSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramDetailSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(
 id: string,
    params: GetRebateProgramDetailParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramDetailSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(
 id: string,
    params: GetRebateProgramDetailParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramDetailSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(
 id: string,
    params: GetRebateProgramDetailParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get detail (performance + rebate split payout) for one shared rebate program
 */

export function useGetRebateProgramDetailSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError = ErrorType<ErrorModel>>(
 id: string,
    params: GetRebateProgramDetailParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramDetailHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramDetailSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getArchiveSharedRebateProgramUrl = (id: number,) => {




  return `/v1/master/rebate-programs/${id}/archive`
}

/**
 * Archive a shared rebate program owned by the authenticated Master IB. After archival, new clients in the program contribute 100% rebate to Master.
 * @summary Archive a single shared rebate program
 */
export const useArchiveSharedRebateProgramHook = (): (id: number,
    headers?: ArchiveSharedRebateProgramHeaders, options?: RequestInit) => Promise<ArchiveSingleOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (id: number,
    headers?: ArchiveSharedRebateProgramHeaders, options?: RequestInit) => {

        return customFetcher(getArchiveSharedRebateProgramUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getArchiveSharedRebateProgramMutationKey = () => ['archiveSharedRebateProgram'] as const;

export const useArchiveSharedRebateProgramMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useArchiveSharedRebateProgramHook>>>, TError,ArchiveSharedRebateProgramMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useArchiveSharedRebateProgramHook>>>, TError,ArchiveSharedRebateProgramMutationVariables, TContext> => {

const mutationKey = getArchiveSharedRebateProgramMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const archiveSharedRebateProgram =  useArchiveSharedRebateProgramHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useArchiveSharedRebateProgramHook>>>, ArchiveSharedRebateProgramMutationVariables> = (props) => {
          const {id,headers} = props ?? {};

          return  archiveSharedRebateProgram(id,headers,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveSharedRebateProgramMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useArchiveSharedRebateProgramHook>>>>

    export type ArchiveSharedRebateProgramMutationError = ErrorType<ErrorModel>
    export type ArchiveSharedRebateProgramMutationVariables = {id: number;headers?: ArchiveSharedRebateProgramHeaders}

    /**
 * @summary Archive a single shared rebate program
 */
export const useArchiveSharedRebateProgram = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useArchiveSharedRebateProgramHook>>>, TError,ArchiveSharedRebateProgramMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useArchiveSharedRebateProgramHook>>>,
        TError,
        ArchiveSharedRebateProgramMutationVariables,
        TContext
      > => {
      return useMutation(useArchiveSharedRebateProgramMutationOptions(options), queryClient);
    }

export const getGetMasterStatusUrl = () => {




  return `/v1/master/status`
}

/**
 * @summary Get the caller's Master status: active shared rebate program count and enabled rebate account flag (PART-3973)
 */
export const useGetMasterStatusHook = (): ( options?: RequestInit) => Promise<MasterStatus> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetMasterStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetMasterStatusQueryKey = () => {
    return [
    `/v1/master/status`
    ] as const;
    }


export const useGetMasterStatusQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMasterStatusQueryKey();

  const getMasterStatus =  useGetMasterStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>> = ({ signal }) => getMasterStatus({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMasterStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>>
export type GetMasterStatusQueryError = ErrorType<ErrorModel>


export function useGetMasterStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMasterStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMasterStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the caller's Master status: active shared rebate program count and enabled rebate account flag (PART-3973)
 */

export function useGetMasterStatus<TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMasterStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetMasterStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMasterStatusQueryKey();

  const getMasterStatus =  useGetMasterStatusHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>> = ({ signal }) => getMasterStatus({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMasterStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>>
export type GetMasterStatusSuspenseQueryError = ErrorType<ErrorModel>


export function useGetMasterStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMasterStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMasterStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the caller's Master status: active shared rebate program count and enabled rebate account flag (PART-3973)
 */

export function useGetMasterStatusSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMasterStatusHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMasterStatusSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSubIbLookupUrl = (params: GetSubIbLookupParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/master/sub-ibs/lookup?${stringifiedParams}` : `/v1/master/sub-ibs/lookup`
}

/**
 * @summary Look up a Sub IB by email (approved or pending KYC; rejected returns sub_ib_rejected)
 */
export const useGetSubIbLookupHook = (): (params: GetSubIbLookupParams, options?: RequestInit) => Promise<SubIBLookup> => {

      const customFetcher = useFetchWrapper();
      return (params: GetSubIbLookupParams, options?: RequestInit) => {

        return customFetcher(getGetSubIbLookupUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetSubIbLookupQueryKey = (params?: GetSubIbLookupParams,) => {
    return [
    `/v1/master/sub-ibs/lookup`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetSubIbLookupQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(params: GetSubIbLookupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubIbLookupQueryKey(params);

  const getSubIbLookup =  useGetSubIbLookupHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>> = ({ signal }) => getSubIbLookup(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubIbLookupQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>>
export type GetSubIbLookupQueryError = ErrorType<ErrorModel>


export function useGetSubIbLookup<TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetSubIbLookupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubIbLookup<TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetSubIbLookupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubIbLookup<TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetSubIbLookupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Look up a Sub IB by email (approved or pending KYC; rejected returns sub_ib_rejected)
 */

export function useGetSubIbLookup<TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetSubIbLookupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSubIbLookupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetSubIbLookupSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(params: GetSubIbLookupParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubIbLookupQueryKey(params);

  const getSubIbLookup =  useGetSubIbLookupHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>> = ({ signal }) => getSubIbLookup(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSubIbLookupSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>>
export type GetSubIbLookupSuspenseQueryError = ErrorType<ErrorModel>


export function useGetSubIbLookupSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetSubIbLookupParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubIbLookupSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetSubIbLookupParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubIbLookupSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetSubIbLookupParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Look up a Sub IB by email (approved or pending KYC; rejected returns sub_ib_rejected)
 */

export function useGetSubIbLookupSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetSubIbLookupParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubIbLookupHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSubIbLookupSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLatestNotificationUrl = (params?: GetLatestNotificationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/notifications/latest?${stringifiedParams}` : `/v1/notifications/latest`
}

/**
 * Returns the partner's most recent notification, dismissed or not, or null when they have none at all. Dismissed rows are included on purpose so that dismissing the newest notification cannot make an older, superseded one resurface as the latest -- use dismissedAt to decide whether to show it. Copy is returned exactly as stored.
 * @summary Get the latest notification for the partner
 */
export const useGetLatestNotificationHook = (): (params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: RequestInit) => Promise<GetLatestNotificationOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: RequestInit) => {

        return customFetcher(getGetLatestNotificationUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetLatestNotificationQueryKey = (params?: GetLatestNotificationParams,) => {
    return [
    `/v1/notifications/latest`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetLatestNotificationQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestNotificationQueryKey(params);

  const getLatestNotification =  useGetLatestNotificationHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>> = ({ signal }) => getLatestNotification(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestNotificationQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>>
export type GetLatestNotificationQueryError = ErrorType<ErrorModel>


export function useGetLatestNotification<TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLatestNotificationParams,
    headers: undefined |  GetLatestNotificationHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestNotification<TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestNotification<TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the latest notification for the partner
 */

export function useGetLatestNotification<TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLatestNotificationQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetLatestNotificationSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestNotificationQueryKey(params);

  const getLatestNotification =  useGetLatestNotificationHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>> = ({ signal }) => getLatestNotification(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLatestNotificationSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>>
export type GetLatestNotificationSuspenseQueryError = ErrorType<ErrorModel>


export function useGetLatestNotificationSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLatestNotificationParams,
    headers: undefined |  GetLatestNotificationHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestNotificationSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestNotificationSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the latest notification for the partner
 */

export function useGetLatestNotificationSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLatestNotificationParams,
    headers?: GetLatestNotificationHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLatestNotificationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLatestNotificationSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateNotificationUrl = (id: string,) => {




  return `/v1/notifications/${id}`
}

/**
 * Applies an action to one of the partner's own notifications. Dismissing is permanent and stamps dismissedAt, which the latest-notification endpoint returns so the client stops showing it -- the row itself is still served. Responds 404 when the notification does not exist, is already dismissed, or belongs to another partner.
 * @summary Apply an action to a notification
 */
export const useUpdateNotificationHook = (): (id: string,
    updateNotificationInputBody: NonReadonly<UpdateNotificationInputBody>,
    headers?: UpdateNotificationHeaders, options?: RequestInit) => Promise<void> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (id: string,
    updateNotificationInputBody: NonReadonly<UpdateNotificationInputBody>,
    headers?: UpdateNotificationHeaders, options?: RequestInit) => {

        return customFetcher(getUpdateNotificationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateNotificationInputBody)
  }
);
      }
  }





export const getUpdateNotificationMutationKey = () => ['updateNotification'] as const;

export const useUpdateNotificationMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>, TError,UpdateNotificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>, TError,UpdateNotificationMutationVariables, TContext> => {

const mutationKey = getUpdateNotificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateNotification =  useUpdateNotificationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>, UpdateNotificationMutationVariables> = (props) => {
          const {id,data,headers} = props ?? {};

          return  updateNotification(id,data,headers,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>>
    export type UpdateNotificationMutationBody = BodyType<NonReadonly<UpdateNotificationInputBody>>
    export type UpdateNotificationMutationError = ErrorType<ErrorModel>
    export type UpdateNotificationMutationVariables = {id: string;data: BodyType<NonReadonly<UpdateNotificationInputBody>>;headers?: UpdateNotificationHeaders}

    /**
 * @summary Apply an action to a notification
 */
export const useUpdateNotification = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>, TError,UpdateNotificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>,
        TError,
        UpdateNotificationMutationVariables,
        TContext
      > => {
      return useMutation(useUpdateNotificationMutationOptions(options), queryClient);
    }

export const getGetPerformanceReportUrl = (params?: GetPerformanceReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/performance-report?${stringifiedParams}` : `/v1/performance-report`
}

/**
 * Returns the Performance Report table rows (impressions, clicks, registrations, approved, funded, traded, volume and earnings) grouped by source, country or rebate program, with filters, server-side sorting and pagination. Scoped to the authenticated IB.
 * @summary Get Performance Report table view
 */
export const useGetPerformanceReportHook = (): (params?: GetPerformanceReportParams, options?: RequestInit) => Promise<PerformanceReportTableBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetPerformanceReportParams, options?: RequestInit) => {

        return customFetcher(getGetPerformanceReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetPerformanceReportQueryKey = (params?: GetPerformanceReportParams,) => {
    return [
    `/v1/performance-report`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetPerformanceReportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(params?: GetPerformanceReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportQueryKey(params);

  const getPerformanceReport =  useGetPerformanceReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>> = ({ signal }) => getPerformanceReport(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>>
export type GetPerformanceReportQueryError = ErrorType<ErrorModel>


export function useGetPerformanceReport<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetPerformanceReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReport<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReport<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report table view
 */

export function useGetPerformanceReport<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetPerformanceReportSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(params?: GetPerformanceReportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportQueryKey(params);

  const getPerformanceReport =  useGetPerformanceReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>> = ({ signal }) => getPerformanceReport(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPerformanceReportSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>>
export type GetPerformanceReportSuspenseQueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetPerformanceReportParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report table view
 */

export function useGetPerformanceReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportPerformanceReportUrl = (params?: ExportPerformanceReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/performance-report/export?${stringifiedParams}` : `/v1/performance-report/export`
}

/**
 * Exports the Performance Report table rows (impressions, clicks, registrations, approved, funded, traded and the four conversion rates) grouped by source, country or rebate program, honouring the same filters and sorting as the table view. Scoped to the authenticated IB.
 * @summary Export Performance Report table view as CSV
 */
export const useExportPerformanceReportHook = (): (params?: ExportPerformanceReportParams, options?: RequestInit) => Promise<Blob> => {

      const customFetcher = useFetchWrapper();
      return (params?: ExportPerformanceReportParams, options?: RequestInit) => {

        return customFetcher(getExportPerformanceReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getExportPerformanceReportQueryKey = (params?: ExportPerformanceReportParams,) => {
    return [
    `/v1/performance-report/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportPerformanceReportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportPerformanceReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPerformanceReportQueryKey(params);

  const exportPerformanceReport =  useExportPerformanceReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>> = ({ signal }) => exportPerformanceReport(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportPerformanceReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>>
export type ExportPerformanceReportQueryError = ErrorType<ErrorModel>


export function useExportPerformanceReport<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportPerformanceReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPerformanceReport<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPerformanceReport<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Performance Report table view as CSV
 */

export function useExportPerformanceReport<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportPerformanceReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportPerformanceReportSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportPerformanceReportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPerformanceReportQueryKey(params);

  const exportPerformanceReport =  useExportPerformanceReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>> = ({ signal }) => exportPerformanceReport(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportPerformanceReportSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>>
export type ExportPerformanceReportSuspenseQueryError = ErrorType<ErrorModel>


export function useExportPerformanceReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportPerformanceReportParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPerformanceReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPerformanceReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Performance Report table view as CSV
 */

export function useExportPerformanceReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportPerformanceReportSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPerformanceReportFilterOptionsUrl = () => {




  return `/v1/performance-report/filter-options`
}

/**
 * Returns the filter dropdown values for the Performance Report page: source types, rebate programs, countries, landing pages and banner groups.
 * @summary Get Performance Report filter options
 */
export const useGetPerformanceReportFilterOptionsHook = (): ( options?: RequestInit) => Promise<PerformanceReportFilterOptionsBody> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetPerformanceReportFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetPerformanceReportFilterOptionsQueryKey = () => {
    return [
    `/v1/performance-report/filter-options`
    ] as const;
    }


export const useGetPerformanceReportFilterOptionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportFilterOptionsQueryKey();

  const getPerformanceReportFilterOptions =  useGetPerformanceReportFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>> = ({ signal }) => getPerformanceReportFilterOptions({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReportFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>>
export type GetPerformanceReportFilterOptionsQueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report filter options
 */

export function useGetPerformanceReportFilterOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetPerformanceReportFilterOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportFilterOptionsQueryKey();

  const getPerformanceReportFilterOptions =  useGetPerformanceReportFilterOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>> = ({ signal }) => getPerformanceReportFilterOptions({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPerformanceReportFilterOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>>
export type GetPerformanceReportFilterOptionsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report filter options
 */

export function useGetPerformanceReportFilterOptionsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportFilterOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportFilterOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPerformanceReportStatsUrl = (params?: GetPerformanceReportStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/performance-report/stats?${stringifiedParams}` : `/v1/performance-report/stats`
}

/**
 * Returns the five Performance Report summary metrics (clicks, registration, active clients, trading volume, earnings) for the authenticated partner, scoped to the selected date range and filters.
 * @summary Get Performance Report summary metrics
 */
export const useGetPerformanceReportStatsHook = (): (params?: GetPerformanceReportStatsParams, options?: RequestInit) => Promise<PerformanceReportStats> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetPerformanceReportStatsParams, options?: RequestInit) => {

        return customFetcher(getGetPerformanceReportStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetPerformanceReportStatsQueryKey = (params?: GetPerformanceReportStatsParams,) => {
    return [
    `/v1/performance-report/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetPerformanceReportStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetPerformanceReportStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportStatsQueryKey(params);

  const getPerformanceReportStats =  useGetPerformanceReportStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>> = ({ signal }) => getPerformanceReportStats(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReportStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>>
export type GetPerformanceReportStatsQueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetPerformanceReportStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report summary metrics
 */

export function useGetPerformanceReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetPerformanceReportStatsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetPerformanceReportStatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportStatsQueryKey(params);

  const getPerformanceReportStats =  useGetPerformanceReportStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>> = ({ signal }) => getPerformanceReportStats(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPerformanceReportStatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>>
export type GetPerformanceReportStatsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetPerformanceReportStatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report summary metrics
 */

export function useGetPerformanceReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportStatsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRebateTierLadderUrl = () => {




  return `/v1/rebate-tiers/ladder`
}

/**
 * @summary Get the caller's own rebate tier ladder
 */
export const useGetRebateTierLadderHook = (): (headers?: GetRebateTierLadderHeaders, options?: RequestInit) => Promise<RebateTierLadderOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetRebateTierLadderHeaders, options?: RequestInit) => {

        return customFetcher(getGetRebateTierLadderUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetRebateTierLadderQueryKey = () => {
    return [
    `/v1/rebate-tiers/ladder`
    ] as const;
    }


export const useGetRebateTierLadderQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetRebateTierLadderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateTierLadderQueryKey();

  const getRebateTierLadder =  useGetRebateTierLadderHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>> = ({ signal }) => getRebateTierLadder(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateTierLadderQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>>
export type GetRebateTierLadderQueryError = ErrorType<ErrorModel>


export function useGetRebateTierLadder<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetRebateTierLadderHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateTierLadder<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierLadderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateTierLadder<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierLadderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the caller's own rebate tier ladder
 */

export function useGetRebateTierLadder<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierLadderHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateTierLadderQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateTierLadderSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetRebateTierLadderHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateTierLadderQueryKey();

  const getRebateTierLadder =  useGetRebateTierLadderHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>> = ({ signal }) => getRebateTierLadder(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateTierLadderSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>>
export type GetRebateTierLadderSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateTierLadderSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetRebateTierLadderHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateTierLadderSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierLadderHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateTierLadderSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierLadderHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the caller's own rebate tier ladder
 */

export function useGetRebateTierLadderSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierLadderHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierLadderHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateTierLadderSuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMaxRebatePerLotUrl = () => {




  return `/v1/rebate-tiers/max-rebate-per-lot`
}

/**
 * @summary Get the max rebate per lot for every tier in the caller's region
 */
export const useGetMaxRebatePerLotHook = (): (headers?: GetMaxRebatePerLotHeaders, options?: RequestInit) => Promise<MaxRebatePerLotOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetMaxRebatePerLotHeaders, options?: RequestInit) => {

        return customFetcher(getGetMaxRebatePerLotUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetMaxRebatePerLotQueryKey = () => {
    return [
    `/v1/rebate-tiers/max-rebate-per-lot`
    ] as const;
    }


export const useGetMaxRebatePerLotQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetMaxRebatePerLotHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMaxRebatePerLotQueryKey();

  const getMaxRebatePerLot =  useGetMaxRebatePerLotHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>> = ({ signal }) => getMaxRebatePerLot(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMaxRebatePerLotQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>>
export type GetMaxRebatePerLotQueryError = ErrorType<ErrorModel>


export function useGetMaxRebatePerLot<TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetMaxRebatePerLotHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxRebatePerLot<TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetMaxRebatePerLotHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxRebatePerLot<TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetMaxRebatePerLotHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the max rebate per lot for every tier in the caller's region
 */

export function useGetMaxRebatePerLot<TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetMaxRebatePerLotHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMaxRebatePerLotQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetMaxRebatePerLotSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetMaxRebatePerLotHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMaxRebatePerLotQueryKey();

  const getMaxRebatePerLot =  useGetMaxRebatePerLotHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>> = ({ signal }) => getMaxRebatePerLot(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMaxRebatePerLotSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>>
export type GetMaxRebatePerLotSuspenseQueryError = ErrorType<ErrorModel>


export function useGetMaxRebatePerLotSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetMaxRebatePerLotHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxRebatePerLotSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetMaxRebatePerLotHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxRebatePerLotSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetMaxRebatePerLotHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the max rebate per lot for every tier in the caller's region
 */

export function useGetMaxRebatePerLotSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetMaxRebatePerLotHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMaxRebatePerLotHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMaxRebatePerLotSuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRebateTierUrl = () => {




  return `/v1/rebate-tiers/me`
}

/**
 * @summary Get current rebate tier for the partner
 */
export const useGetRebateTierHook = (): (headers?: GetRebateTierHeaders, options?: RequestInit) => Promise<RebateTierOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetRebateTierHeaders, options?: RequestInit) => {

        return customFetcher(getGetRebateTierUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetRebateTierQueryKey = () => {
    return [
    `/v1/rebate-tiers/me`
    ] as const;
    }


export const useGetRebateTierQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetRebateTierHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateTierQueryKey();

  const getRebateTier =  useGetRebateTierHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>> = ({ signal }) => getRebateTier(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateTierQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>>
export type GetRebateTierQueryError = ErrorType<ErrorModel>


export function useGetRebateTier<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetRebateTierHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateTier<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateTier<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current rebate tier for the partner
 */

export function useGetRebateTier<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateTierQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateTierSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetRebateTierHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateTierQueryKey();

  const getRebateTier =  useGetRebateTierHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>> = ({ signal }) => getRebateTier(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateTierSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>>
export type GetRebateTierSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateTierSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetRebateTierHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateTierSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateTierSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current rebate tier for the partner
 */

export function useGetRebateTierSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateTierHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateTierHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateTierSuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchRebateTierUrl = () => {




  return `/v1/rebate-tiers/me`
}

/**
 * Only defaultVolumeUnit is writable; every other field of the rebate-tier resource is computed.
 * @summary Update the partner's writable rebate-tier settings
 */
export const usePatchRebateTierHook = (): (patchRebateTierInputBody: NonReadonly<PatchRebateTierInputBody>,
    headers?: PatchRebateTierHeaders, options?: RequestInit) => Promise<void> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (patchRebateTierInputBody: NonReadonly<PatchRebateTierInputBody>,
    headers?: PatchRebateTierHeaders, options?: RequestInit) => {

        return customFetcher(getPatchRebateTierUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(patchRebateTierInputBody)
  }
);
      }
  }





export const getPatchRebateTierMutationKey = () => ['patchRebateTier'] as const;

export const usePatchRebateTierMutationOptions = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchRebateTierHook>>>, TError,PatchRebateTierMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchRebateTierHook>>>, TError,PatchRebateTierMutationVariables, TContext> => {

const mutationKey = getPatchRebateTierMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const patchRebateTier =  usePatchRebateTierHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePatchRebateTierHook>>>, PatchRebateTierMutationVariables> = (props) => {
          const {data,headers} = props ?? {};

          return  patchRebateTier(data,headers,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchRebateTierMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePatchRebateTierHook>>>>
    export type PatchRebateTierMutationBody = BodyType<NonReadonly<PatchRebateTierInputBody>>
    export type PatchRebateTierMutationError = ErrorType<ErrorModel>
    export type PatchRebateTierMutationVariables = {data: BodyType<NonReadonly<PatchRebateTierInputBody>>;headers?: PatchRebateTierHeaders}

    /**
 * @summary Update the partner's writable rebate-tier settings
 */
export const usePatchRebateTier = <TError = ErrorType<ErrorModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePatchRebateTierHook>>>, TError,PatchRebateTierMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePatchRebateTierHook>>>,
        TError,
        PatchRebateTierMutationVariables,
        TContext
      > => {
      return useMutation(usePatchRebateTierMutationOptions(options), queryClient);
    }

export const getGetRebateDetailsUrl = (params: GetRebateDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/rebate-tiers/rebate-details?${stringifiedParams}` : `/v1/rebate-tiers/rebate-details`
}

/**
 * @summary Get rebate details (rates by asset/symbol) for a default set
 */
export const useGetRebateDetailsHook = (): (params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: RequestInit) => Promise<GetRebateRatesOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: RequestInit) => {

        return customFetcher(getGetRebateDetailsUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetRebateDetailsQueryKey = (params?: GetRebateDetailsParams,) => {
    return [
    `/v1/rebate-tiers/rebate-details`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetRebateDetailsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateDetailsQueryKey(params);

  const getRebateDetails =  useGetRebateDetailsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>> = ({ signal }) => getRebateDetails(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateDetailsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>>
export type GetRebateDetailsQueryError = ErrorType<ErrorModel>


export function useGetRebateDetails<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateDetailsParams,
    headers: undefined |  GetRebateDetailsHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateDetails<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateDetails<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rebate details (rates by asset/symbol) for a default set
 */

export function useGetRebateDetails<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateDetailsQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateDetailsQueryKey(params);

  const getRebateDetails =  useGetRebateDetailsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>> = ({ signal }) => getRebateDetails(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>>
export type GetRebateDetailsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateDetailsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateDetailsParams,
    headers: undefined |  GetRebateDetailsHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateDetailsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateDetailsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rebate details (rates by asset/symbol) for a default set
 */

export function useGetRebateDetailsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError = ErrorType<ErrorModel>>(
 params: GetRebateDetailsParams,
    headers?: GetRebateDetailsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateDetailsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateDetailsSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetVolumeUnitsUrl = () => {




  return `/v1/rebate-tiers/volume-units`
}

/**
 * @summary Get the USD value of one lot for each supported volume unit symbol
 */
export const useGetVolumeUnitsHook = (): (headers?: GetVolumeUnitsHeaders, options?: RequestInit) => Promise<GetVolumeUnitsOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetVolumeUnitsHeaders, options?: RequestInit) => {

        return customFetcher(getGetVolumeUnitsUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetVolumeUnitsQueryKey = () => {
    return [
    `/v1/rebate-tiers/volume-units`
    ] as const;
    }


export const useGetVolumeUnitsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetVolumeUnitsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVolumeUnitsQueryKey();

  const getVolumeUnits =  useGetVolumeUnitsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>> = ({ signal }) => getVolumeUnits(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVolumeUnitsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>>
export type GetVolumeUnitsQueryError = ErrorType<ErrorModel>


export function useGetVolumeUnits<TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetVolumeUnitsHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVolumeUnits<TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetVolumeUnitsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVolumeUnits<TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetVolumeUnitsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the USD value of one lot for each supported volume unit symbol
 */

export function useGetVolumeUnits<TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetVolumeUnitsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetVolumeUnitsQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetVolumeUnitsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetVolumeUnitsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVolumeUnitsQueryKey();

  const getVolumeUnits =  useGetVolumeUnitsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>> = ({ signal }) => getVolumeUnits(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetVolumeUnitsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>>
export type GetVolumeUnitsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetVolumeUnitsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetVolumeUnitsHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVolumeUnitsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetVolumeUnitsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVolumeUnitsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetVolumeUnitsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the USD value of one lot for each supported volume unit symbol
 */

export function useGetVolumeUnitsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetVolumeUnitsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetVolumeUnitsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetVolumeUnitsSuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsAccountReportUrl = (params?: GetClientsAccountReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/account-report?${stringifiedParams}` : `/v2/clients/account-report`
}

/**
 * @summary Get clients account report
 */
export const useGetClientsAccountReportHook = (): (params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: RequestInit) => Promise<AccountReport> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: RequestInit) => {

        return customFetcher(getGetClientsAccountReportUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetClientsAccountReportQueryKey = (params?: GetClientsAccountReportParams,) => {
    return [
    `/v2/clients/account-report`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsAccountReportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsAccountReportQueryKey(params);

  const getClientsAccountReport =  useGetClientsAccountReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>> = ({ signal }) => getClientsAccountReport(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsAccountReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>>
export type GetClientsAccountReportQueryError = ErrorType<ErrorModel>


export function useGetClientsAccountReport<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsAccountReportParams,
    headers: undefined |  GetClientsAccountReportHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReport<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReport<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients account report
 */

export function useGetClientsAccountReport<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsAccountReportQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsAccountReportSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsAccountReportQueryKey(params);

  const getClientsAccountReport =  useGetClientsAccountReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>> = ({ signal }) => getClientsAccountReport(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsAccountReportSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>>
export type GetClientsAccountReportSuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsAccountReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsAccountReportParams,
    headers: undefined |  GetClientsAccountReportHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients account report
 */

export function useGetClientsAccountReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportParams,
    headers?: GetClientsAccountReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsAccountReportSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportClientsAccountReportUrl = (params?: ExportClientsAccountReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/account-report/export?${stringifiedParams}` : `/v2/clients/account-report/export`
}

/**
 * @summary Export clients account report
 */
export const useExportClientsAccountReportHook = (): (params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: RequestInit) => Promise<Blob> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: RequestInit) => {

        return customFetcher(getExportClientsAccountReportUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getExportClientsAccountReportQueryKey = (params?: ExportClientsAccountReportParams,) => {
    return [
    `/v2/clients/account-report/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportClientsAccountReportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportClientsAccountReportQueryKey(params);

  const exportClientsAccountReport =  useExportClientsAccountReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>> = ({ signal }) => exportClientsAccountReport(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportClientsAccountReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>>
export type ExportClientsAccountReportQueryError = ErrorType<ErrorModel>


export function useExportClientsAccountReport<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportClientsAccountReportParams,
    headers: undefined |  ExportClientsAccountReportHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsAccountReport<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsAccountReport<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients account report
 */

export function useExportClientsAccountReport<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportClientsAccountReportQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportClientsAccountReportSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportClientsAccountReportQueryKey(params);

  const exportClientsAccountReport =  useExportClientsAccountReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>> = ({ signal }) => exportClientsAccountReport(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportClientsAccountReportSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>>
export type ExportClientsAccountReportSuspenseQueryError = ErrorType<ErrorModel>


export function useExportClientsAccountReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportClientsAccountReportParams,
    headers: undefined |  ExportClientsAccountReportHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsAccountReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsAccountReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients account report
 */

export function useExportClientsAccountReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportParams,
    headers?: ExportClientsAccountReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportClientsAccountReportSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsAccountReportStatsUrl = (params?: GetClientsAccountReportStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/account-report/stats?${stringifiedParams}` : `/v2/clients/account-report/stats`
}

/**
 * @summary Get clients account report stats
 */
export const useGetClientsAccountReportStatsHook = (): (params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: RequestInit) => Promise<AccountReportStats> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: RequestInit) => {

        return customFetcher(getGetClientsAccountReportStatsUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetClientsAccountReportStatsQueryKey = (params?: GetClientsAccountReportStatsParams,) => {
    return [
    `/v2/clients/account-report/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsAccountReportStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsAccountReportStatsQueryKey(params);

  const getClientsAccountReportStats =  useGetClientsAccountReportStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>> = ({ signal }) => getClientsAccountReportStats(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsAccountReportStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>>
export type GetClientsAccountReportStatsQueryError = ErrorType<ErrorModel>


export function useGetClientsAccountReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsAccountReportStatsParams,
    headers: undefined |  GetClientsAccountReportStatsHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients account report stats
 */

export function useGetClientsAccountReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsAccountReportStatsQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsAccountReportStatsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsAccountReportStatsQueryKey(params);

  const getClientsAccountReportStats =  useGetClientsAccountReportStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>> = ({ signal }) => getClientsAccountReportStats(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsAccountReportStatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>>
export type GetClientsAccountReportStatsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsAccountReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsAccountReportStatsParams,
    headers: undefined |  GetClientsAccountReportStatsHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients account report stats
 */

export function useGetClientsAccountReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsParams,
    headers?: GetClientsAccountReportStatsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsAccountReportStatsSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsApprovedNotFundedUrl = (params?: GetClientsApprovedNotFundedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/approved-not-funded?${stringifiedParams}` : `/v2/clients/approved-not-funded`
}

/**
 * @summary Get approved but not funded clients
 */
export const useGetClientsApprovedNotFundedHook = (): (params?: GetClientsApprovedNotFundedParams, options?: RequestInit) => Promise<ANFReportOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsApprovedNotFundedParams, options?: RequestInit) => {

        return customFetcher(getGetClientsApprovedNotFundedUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetClientsApprovedNotFundedQueryKey = (params?: GetClientsApprovedNotFundedParams,) => {
    return [
    `/v2/clients/approved-not-funded`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsApprovedNotFundedQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsApprovedNotFundedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsApprovedNotFundedQueryKey(params);

  const getClientsApprovedNotFunded =  useGetClientsApprovedNotFundedHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>> = ({ signal }) => getClientsApprovedNotFunded(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsApprovedNotFundedQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>>
export type GetClientsApprovedNotFundedQueryError = ErrorType<ErrorModel>


export function useGetClientsApprovedNotFunded<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsApprovedNotFundedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsApprovedNotFunded<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsApprovedNotFundedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsApprovedNotFunded<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsApprovedNotFundedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get approved but not funded clients
 */

export function useGetClientsApprovedNotFunded<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsApprovedNotFundedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsApprovedNotFundedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsApprovedNotFundedSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsApprovedNotFundedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsApprovedNotFundedQueryKey(params);

  const getClientsApprovedNotFunded =  useGetClientsApprovedNotFundedHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>> = ({ signal }) => getClientsApprovedNotFunded(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsApprovedNotFundedSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>>
export type GetClientsApprovedNotFundedSuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsApprovedNotFundedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsApprovedNotFundedParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsApprovedNotFundedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsApprovedNotFundedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsApprovedNotFundedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsApprovedNotFundedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get approved but not funded clients
 */

export function useGetClientsApprovedNotFundedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsApprovedNotFundedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsApprovedNotFundedSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportApprovedNotFundedUrl = (params?: ExportApprovedNotFundedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/approved-not-funded/export?${stringifiedParams}` : `/v2/clients/approved-not-funded/export`
}

/**
 * @summary Export clients approved not funded
 */
export const useExportApprovedNotFundedHook = (): (params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: RequestInit) => Promise<Blob> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: RequestInit) => {

        return customFetcher(getExportApprovedNotFundedUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getExportApprovedNotFundedQueryKey = (params?: ExportApprovedNotFundedParams,) => {
    return [
    `/v2/clients/approved-not-funded/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportApprovedNotFundedQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportApprovedNotFundedQueryKey(params);

  const exportApprovedNotFunded =  useExportApprovedNotFundedHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>> = ({ signal }) => exportApprovedNotFunded(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportApprovedNotFundedQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>>
export type ExportApprovedNotFundedQueryError = ErrorType<ErrorModel>


export function useExportApprovedNotFunded<TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportApprovedNotFundedParams,
    headers: undefined |  ExportApprovedNotFundedHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportApprovedNotFunded<TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportApprovedNotFunded<TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients approved not funded
 */

export function useExportApprovedNotFunded<TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportApprovedNotFundedQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportApprovedNotFundedSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportApprovedNotFundedQueryKey(params);

  const exportApprovedNotFunded =  useExportApprovedNotFundedHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>> = ({ signal }) => exportApprovedNotFunded(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportApprovedNotFundedSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>>
export type ExportApprovedNotFundedSuspenseQueryError = ErrorType<ErrorModel>


export function useExportApprovedNotFundedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportApprovedNotFundedParams,
    headers: undefined |  ExportApprovedNotFundedHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportApprovedNotFundedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportApprovedNotFundedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients approved not funded
 */

export function useExportApprovedNotFundedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportApprovedNotFundedParams,
    headers?: ExportApprovedNotFundedHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportApprovedNotFundedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportApprovedNotFundedSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsFundedNotTradedUrl = (params?: GetClientsFundedNotTradedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/funded-not-traded?${stringifiedParams}` : `/v2/clients/funded-not-traded`
}

/**
 * @summary Get clients funded not traded
 */
export const useGetClientsFundedNotTradedHook = (): (params?: GetClientsFundedNotTradedParams, options?: RequestInit) => Promise<FNTReport> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsFundedNotTradedParams, options?: RequestInit) => {

        return customFetcher(getGetClientsFundedNotTradedUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetClientsFundedNotTradedQueryKey = (params?: GetClientsFundedNotTradedParams,) => {
    return [
    `/v2/clients/funded-not-traded`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsFundedNotTradedQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsFundedNotTradedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsFundedNotTradedQueryKey(params);

  const getClientsFundedNotTraded =  useGetClientsFundedNotTradedHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>> = ({ signal }) => getClientsFundedNotTraded(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsFundedNotTradedQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>>
export type GetClientsFundedNotTradedQueryError = ErrorType<ErrorModel>


export function useGetClientsFundedNotTraded<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsFundedNotTradedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsFundedNotTraded<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsFundedNotTradedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsFundedNotTraded<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsFundedNotTradedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients funded not traded
 */

export function useGetClientsFundedNotTraded<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsFundedNotTradedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsFundedNotTradedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsFundedNotTradedSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsFundedNotTradedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsFundedNotTradedQueryKey(params);

  const getClientsFundedNotTraded =  useGetClientsFundedNotTradedHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>> = ({ signal }) => getClientsFundedNotTraded(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsFundedNotTradedSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>>
export type GetClientsFundedNotTradedSuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsFundedNotTradedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsFundedNotTradedParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsFundedNotTradedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsFundedNotTradedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsFundedNotTradedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsFundedNotTradedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients funded not traded
 */

export function useGetClientsFundedNotTradedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsFundedNotTradedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsFundedNotTradedSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportFundedNotTradedUrl = (params?: ExportFundedNotTradedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/funded-not-traded/export?${stringifiedParams}` : `/v2/clients/funded-not-traded/export`
}

/**
 * @summary Export clients funded not traded
 */
export const useExportFundedNotTradedHook = (): (params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: RequestInit) => Promise<Blob> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: RequestInit) => {

        return customFetcher(getExportFundedNotTradedUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getExportFundedNotTradedQueryKey = (params?: ExportFundedNotTradedParams,) => {
    return [
    `/v2/clients/funded-not-traded/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportFundedNotTradedQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportFundedNotTradedQueryKey(params);

  const exportFundedNotTraded =  useExportFundedNotTradedHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>> = ({ signal }) => exportFundedNotTraded(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportFundedNotTradedQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>>
export type ExportFundedNotTradedQueryError = ErrorType<ErrorModel>


export function useExportFundedNotTraded<TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportFundedNotTradedParams,
    headers: undefined |  ExportFundedNotTradedHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportFundedNotTraded<TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportFundedNotTraded<TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients funded not traded
 */

export function useExportFundedNotTraded<TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportFundedNotTradedQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportFundedNotTradedSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportFundedNotTradedQueryKey(params);

  const exportFundedNotTraded =  useExportFundedNotTradedHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>> = ({ signal }) => exportFundedNotTraded(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportFundedNotTradedSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>>
export type ExportFundedNotTradedSuspenseQueryError = ErrorType<ErrorModel>


export function useExportFundedNotTradedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportFundedNotTradedParams,
    headers: undefined |  ExportFundedNotTradedHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportFundedNotTradedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportFundedNotTradedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients funded not traded
 */

export function useExportFundedNotTradedSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportFundedNotTradedParams,
    headers?: ExportFundedNotTradedHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportFundedNotTradedHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportFundedNotTradedSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRebateAccountsForIbUrl = () => {




  return `/v2/clients/rebate-accounts`
}

/**
 * @summary Get rebate accounts for IB
 */
export const useGetRebateAccountsForIbHook = (): (headers?: GetRebateAccountsForIbHeaders, options?: RequestInit) => Promise<RebateAccountOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetRebateAccountsForIbHeaders, options?: RequestInit) => {

        return customFetcher(getGetRebateAccountsForIbUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetRebateAccountsForIbQueryKey = () => {
    return [
    `/v2/clients/rebate-accounts`
    ] as const;
    }


export const useGetRebateAccountsForIbQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetRebateAccountsForIbHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateAccountsForIbQueryKey();

  const getRebateAccountsForIb =  useGetRebateAccountsForIbHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>> = ({ signal }) => getRebateAccountsForIb(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateAccountsForIbQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>>
export type GetRebateAccountsForIbQueryError = ErrorType<ErrorModel>


export function useGetRebateAccountsForIb<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetRebateAccountsForIbHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateAccountsForIb<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateAccountsForIbHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateAccountsForIb<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateAccountsForIbHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rebate accounts for IB
 */

export function useGetRebateAccountsForIb<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateAccountsForIbHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateAccountsForIbQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateAccountsForIbSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetRebateAccountsForIbHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateAccountsForIbQueryKey();

  const getRebateAccountsForIb =  useGetRebateAccountsForIbHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>> = ({ signal }) => getRebateAccountsForIb(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateAccountsForIbSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>>
export type GetRebateAccountsForIbSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateAccountsForIbSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetRebateAccountsForIbHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateAccountsForIbSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateAccountsForIbHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateAccountsForIbSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateAccountsForIbHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rebate accounts for IB
 */

export function useGetRebateAccountsForIbSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateAccountsForIbHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateAccountsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateAccountsForIbSuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRebateProgramsForIbUrl = () => {




  return `/v2/clients/rebate-programs`
}

/**
 * @summary Get rebate programs for IB
 */
export const useGetRebateProgramsForIbHook = (): (headers?: GetRebateProgramsForIbHeaders, options?: RequestInit) => Promise<RebateProgramOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetRebateProgramsForIbHeaders, options?: RequestInit) => {

        return customFetcher(getGetRebateProgramsForIbUrl(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetRebateProgramsForIbQueryKey = () => {
    return [
    `/v2/clients/rebate-programs`
    ] as const;
    }


export const useGetRebateProgramsForIbQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetRebateProgramsForIbHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsForIbQueryKey();

  const getRebateProgramsForIb =  useGetRebateProgramsForIbHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>> = ({ signal }) => getRebateProgramsForIb(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRebateProgramsForIbQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>>
export type GetRebateProgramsForIbQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsForIb<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetRebateProgramsForIbHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsForIb<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateProgramsForIbHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsForIb<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateProgramsForIbHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rebate programs for IB
 */

export function useGetRebateProgramsForIb<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateProgramsForIbHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsForIbQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetRebateProgramsForIbSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(headers?: GetRebateProgramsForIbHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRebateProgramsForIbQueryKey();

  const getRebateProgramsForIb =  useGetRebateProgramsForIbHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>> = ({ signal }) => getRebateProgramsForIb(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRebateProgramsForIbSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>>
export type GetRebateProgramsForIbSuspenseQueryError = ErrorType<ErrorModel>


export function useGetRebateProgramsForIbSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetRebateProgramsForIbHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsForIbSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateProgramsForIbHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRebateProgramsForIbSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateProgramsForIbHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rebate programs for IB
 */

export function useGetRebateProgramsForIbSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetRebateProgramsForIbHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRebateProgramsForIbHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRebateProgramsForIbSuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsTradingReportUrl = (params?: GetClientsTradingReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/trading-report?${stringifiedParams}` : `/v2/clients/trading-report`
}

/**
 * @summary Get clients trading report
 */
export const useGetClientsTradingReportHook = (): (params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: RequestInit) => Promise<TradingReport> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: RequestInit) => {

        return customFetcher(getGetClientsTradingReportUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetClientsTradingReportQueryKey = (params?: GetClientsTradingReportParams,) => {
    return [
    `/v2/clients/trading-report`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsTradingReportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsTradingReportQueryKey(params);

  const getClientsTradingReport =  useGetClientsTradingReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>> = ({ signal }) => getClientsTradingReport(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsTradingReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>>
export type GetClientsTradingReportQueryError = ErrorType<ErrorModel>


export function useGetClientsTradingReport<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsTradingReportParams,
    headers: undefined |  GetClientsTradingReportHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReport<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReport<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients trading report
 */

export function useGetClientsTradingReport<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsTradingReportQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsTradingReportSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsTradingReportQueryKey(params);

  const getClientsTradingReport =  useGetClientsTradingReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>> = ({ signal }) => getClientsTradingReport(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsTradingReportSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>>
export type GetClientsTradingReportSuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsTradingReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsTradingReportParams,
    headers: undefined |  GetClientsTradingReportHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients trading report
 */

export function useGetClientsTradingReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportParams,
    headers?: GetClientsTradingReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsTradingReportSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportClientsTradingReportUrl = (params?: ExportClientsTradingReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/trading-report/export?${stringifiedParams}` : `/v2/clients/trading-report/export`
}

/**
 * @summary Export clients trading report
 */
export const useExportClientsTradingReportHook = (): (params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: RequestInit) => Promise<Blob> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: RequestInit) => {

        return customFetcher(getExportClientsTradingReportUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getExportClientsTradingReportQueryKey = (params?: ExportClientsTradingReportParams,) => {
    return [
    `/v2/clients/trading-report/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportClientsTradingReportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportClientsTradingReportQueryKey(params);

  const exportClientsTradingReport =  useExportClientsTradingReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>> = ({ signal }) => exportClientsTradingReport(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportClientsTradingReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>>
export type ExportClientsTradingReportQueryError = ErrorType<ErrorModel>


export function useExportClientsTradingReport<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportClientsTradingReportParams,
    headers: undefined |  ExportClientsTradingReportHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsTradingReport<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsTradingReport<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients trading report
 */

export function useExportClientsTradingReport<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportClientsTradingReportQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportClientsTradingReportSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportClientsTradingReportQueryKey(params);

  const exportClientsTradingReport =  useExportClientsTradingReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>> = ({ signal }) => exportClientsTradingReport(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportClientsTradingReportSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>>
export type ExportClientsTradingReportSuspenseQueryError = ErrorType<ErrorModel>


export function useExportClientsTradingReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportClientsTradingReportParams,
    headers: undefined |  ExportClientsTradingReportHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsTradingReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsTradingReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients trading report
 */

export function useExportClientsTradingReportSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportParams,
    headers?: ExportClientsTradingReportHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportClientsTradingReportSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsTradingReportStatsUrl = (params?: GetClientsTradingReportStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/clients/trading-report/stats?${stringifiedParams}` : `/v2/clients/trading-report/stats`
}

/**
 * @summary Get clients trading report stats
 */
export const useGetClientsTradingReportStatsHook = (): (params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: RequestInit) => Promise<TradingReportStatsOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: RequestInit) => {

        return customFetcher(getGetClientsTradingReportStatsUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetClientsTradingReportStatsQueryKey = (params?: GetClientsTradingReportStatsParams,) => {
    return [
    `/v2/clients/trading-report/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsTradingReportStatsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsTradingReportStatsQueryKey(params);

  const getClientsTradingReportStats =  useGetClientsTradingReportStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>> = ({ signal }) => getClientsTradingReportStats(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsTradingReportStatsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>>
export type GetClientsTradingReportStatsQueryError = ErrorType<ErrorModel>


export function useGetClientsTradingReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsTradingReportStatsParams,
    headers: undefined |  GetClientsTradingReportStatsHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients trading report stats
 */

export function useGetClientsTradingReportStats<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsTradingReportStatsQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsTradingReportStatsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsTradingReportStatsQueryKey(params);

  const getClientsTradingReportStats =  useGetClientsTradingReportStatsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>> = ({ signal }) => getClientsTradingReportStats(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsTradingReportStatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>>
export type GetClientsTradingReportStatsSuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsTradingReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsTradingReportStatsParams,
    headers: undefined |  GetClientsTradingReportStatsHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients trading report stats
 */

export function useGetClientsTradingReportStatsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsParams,
    headers?: GetClientsTradingReportStatsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsTradingReportStatsSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetEarningsV2Url = () => {




  return `/v2/earnings`
}

/**
 * @summary Get earnings v2 data
 */
export const useGetEarningsV2Hook = (): (headers?: GetEarningsV2Headers, options?: RequestInit) => Promise<EarningsOutputBody> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetEarningsV2Headers, options?: RequestInit) => {

        return customFetcher(getGetEarningsV2Url(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetEarningsV2QueryKey = () => {
    return [
    `/v2/earnings`
    ] as const;
    }


export const useGetEarningsV2QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(headers?: GetEarningsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEarningsV2QueryKey();

  const getEarningsV2 =  useGetEarningsV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>> = ({ signal }) => getEarningsV2(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEarningsV2QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>>
export type GetEarningsV2QueryError = ErrorType<ErrorModel>


export function useGetEarningsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetEarningsV2Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEarningsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEarningsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get earnings v2 data
 */

export function useGetEarningsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetEarningsV2QueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetEarningsV2SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(headers?: GetEarningsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEarningsV2QueryKey();

  const getEarningsV2 =  useGetEarningsV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>> = ({ signal }) => getEarningsV2(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetEarningsV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>>
export type GetEarningsV2SuspenseQueryError = ErrorType<ErrorModel>


export function useGetEarningsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetEarningsV2Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEarningsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEarningsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get earnings v2 data
 */

export function useGetEarningsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetEarningsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEarningsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetEarningsV2SuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLeadsV2Url = (params?: GetLeadsV2Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/leads?${stringifiedParams}` : `/v2/leads`
}

/**
 * @summary Get leads v2 data
 */
export const useGetLeadsV2Hook = (): (params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: RequestInit) => Promise<LeadsData> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: RequestInit) => {

        return customFetcher(getGetLeadsV2Url(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetLeadsV2QueryKey = (params?: GetLeadsV2Params,) => {
    return [
    `/v2/leads`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetLeadsV2QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadsV2QueryKey(params);

  const getLeadsV2 =  useGetLeadsV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>> = ({ signal }) => getLeadsV2(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeadsV2QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>>
export type GetLeadsV2QueryError = ErrorType<ErrorModel>


export function useGetLeadsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLeadsV2Params,
    headers: undefined |  GetLeadsV2Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get leads v2 data
 */

export function useGetLeadsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLeadsV2QueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetLeadsV2SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadsV2QueryKey(params);

  const getLeadsV2 =  useGetLeadsV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>> = ({ signal }) => getLeadsV2(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLeadsV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>>
export type GetLeadsV2SuspenseQueryError = ErrorType<ErrorModel>


export function useGetLeadsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLeadsV2Params,
    headers: undefined |  GetLeadsV2Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get leads v2 data
 */

export function useGetLeadsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsV2Params,
    headers?: GetLeadsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLeadsV2SuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportLeadsUrl = (params?: ExportLeadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/leads/export?${stringifiedParams}` : `/v2/leads/export`
}

/**
 * @summary Export leads report
 */
export const useExportLeadsHook = (): (params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: RequestInit) => Promise<Blob> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: RequestInit) => {

        return customFetcher(getExportLeadsUrl(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getExportLeadsQueryKey = (params?: ExportLeadsParams,) => {
    return [
    `/v2/leads/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportLeadsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportLeadsQueryKey(params);

  const exportLeads =  useExportLeadsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>> = ({ signal }) => exportLeads(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportLeadsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>>
export type ExportLeadsQueryError = ErrorType<unknown>


export function useExportLeads<TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(
 params: undefined |  ExportLeadsParams,
    headers: undefined |  ExportLeadsHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLeads<TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(
 params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLeads<TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(
 params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export leads report
 */

export function useExportLeads<TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(
 params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportLeadsQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportLeadsSuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportLeadsQueryKey(params);

  const exportLeads =  useExportLeadsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>> = ({ signal }) => exportLeads(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportLeadsSuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>>
export type ExportLeadsSuspenseQueryError = ErrorType<unknown>


export function useExportLeadsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(
 params: undefined |  ExportLeadsParams,
    headers: undefined |  ExportLeadsHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLeadsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(
 params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLeadsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(
 params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export leads report
 */

export function useExportLeadsSuspense<TData = Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError = ErrorType<unknown>>(
 params?: ExportLeadsParams,
    headers?: ExportLeadsHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportLeadsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportLeadsSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLeadsFiltersV2Url = (params?: GetLeadsFiltersV2Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/leads/filters?${stringifiedParams}` : `/v2/leads/filters`
}

/**
 * @summary Get available lead filter options (statuses with counts and country codes)
 */
export const useGetLeadsFiltersV2Hook = (): (params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: RequestInit) => Promise<LeadsFilters> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: RequestInit) => {

        return customFetcher(getGetLeadsFiltersV2Url(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetLeadsFiltersV2QueryKey = (params?: GetLeadsFiltersV2Params,) => {
    return [
    `/v2/leads/filters`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetLeadsFiltersV2QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadsFiltersV2QueryKey(params);

  const getLeadsFiltersV2 =  useGetLeadsFiltersV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>> = ({ signal }) => getLeadsFiltersV2(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeadsFiltersV2QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>>
export type GetLeadsFiltersV2QueryError = ErrorType<ErrorModel>


export function useGetLeadsFiltersV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLeadsFiltersV2Params,
    headers: undefined |  GetLeadsFiltersV2Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsFiltersV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsFiltersV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available lead filter options (statuses with counts and country codes)
 */

export function useGetLeadsFiltersV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLeadsFiltersV2QueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetLeadsFiltersV2SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadsFiltersV2QueryKey(params);

  const getLeadsFiltersV2 =  useGetLeadsFiltersV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>> = ({ signal }) => getLeadsFiltersV2(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLeadsFiltersV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>>
export type GetLeadsFiltersV2SuspenseQueryError = ErrorType<ErrorModel>


export function useGetLeadsFiltersV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLeadsFiltersV2Params,
    headers: undefined |  GetLeadsFiltersV2Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsFiltersV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsFiltersV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available lead filter options (statuses with counts and country codes)
 */

export function useGetLeadsFiltersV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsFiltersV2Params,
    headers?: GetLeadsFiltersV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsFiltersV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLeadsFiltersV2SuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLeadsStatsV2Url = (params?: GetLeadsStatsV2Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/leads/stats?${stringifiedParams}` : `/v2/leads/stats`
}

/**
 * @summary Get leads stats v2
 */
export const useGetLeadsStatsV2Hook = (): (params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: RequestInit) => Promise<LeadsStatsOutputBodyV2> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: RequestInit) => {

        return customFetcher(getGetLeadsStatsV2Url(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetLeadsStatsV2QueryKey = (params?: GetLeadsStatsV2Params,) => {
    return [
    `/v2/leads/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetLeadsStatsV2QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadsStatsV2QueryKey(params);

  const getLeadsStatsV2 =  useGetLeadsStatsV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>> = ({ signal }) => getLeadsStatsV2(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeadsStatsV2QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>>
export type GetLeadsStatsV2QueryError = ErrorType<ErrorModel>


export function useGetLeadsStatsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLeadsStatsV2Params,
    headers: undefined |  GetLeadsStatsV2Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsStatsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsStatsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get leads stats v2
 */

export function useGetLeadsStatsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLeadsStatsV2QueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetLeadsStatsV2SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadsStatsV2QueryKey(params);

  const getLeadsStatsV2 =  useGetLeadsStatsV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>> = ({ signal }) => getLeadsStatsV2(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLeadsStatsV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>>
export type GetLeadsStatsV2SuspenseQueryError = ErrorType<ErrorModel>


export function useGetLeadsStatsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetLeadsStatsV2Params,
    headers: undefined |  GetLeadsStatsV2Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsStatsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadsStatsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get leads stats v2
 */

export function useGetLeadsStatsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetLeadsStatsV2Params,
    headers?: GetLeadsStatsV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLeadsStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLeadsStatsV2SuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOverviewV2Url = () => {




  return `/v2/overview/ib`
}

/**
 * @summary Get overview data v2
 */
export const useGetOverviewV2Hook = (): (headers?: GetOverviewV2Headers, options?: RequestInit) => Promise<OverviewOutputBodyV2> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (headers?: GetOverviewV2Headers, options?: RequestInit) => {

        return customFetcher(getGetOverviewV2Url(),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetOverviewV2QueryKey = () => {
    return [
    `/v2/overview/ib`
    ] as const;
    }


export const useGetOverviewV2QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(headers?: GetOverviewV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverviewV2QueryKey();

  const getOverviewV2 =  useGetOverviewV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>> = ({ signal }) => getOverviewV2(headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverviewV2QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>>
export type GetOverviewV2QueryError = ErrorType<ErrorModel>


export function useGetOverviewV2<TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetOverviewV2Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewV2<TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetOverviewV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewV2<TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetOverviewV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get overview data v2
 */

export function useGetOverviewV2<TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetOverviewV2Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOverviewV2QueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetOverviewV2SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(headers?: GetOverviewV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverviewV2QueryKey();

  const getOverviewV2 =  useGetOverviewV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>> = ({ signal }) => getOverviewV2(headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetOverviewV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>>
export type GetOverviewV2SuspenseQueryError = ErrorType<ErrorModel>


export function useGetOverviewV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers: undefined |  GetOverviewV2Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetOverviewV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverviewV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetOverviewV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get overview data v2
 */

export function useGetOverviewV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError = ErrorType<ErrorModel>>(
 headers?: GetOverviewV2Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOverviewV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOverviewV2SuspenseQueryOptions(headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPerformanceReportV2Url = (params?: GetPerformanceReportV2Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/performance-report?${stringifiedParams}` : `/v2/performance-report`
}

/**
 * Same rows, filters, sorting and pagination as /v1/performance-report, read directly from the base tables (PART-4355) rather than mv_referral_performance. Callers choose between the two by route -- the server applies no feature flag of its own.
 * @summary Get Performance Report table view (v2)
 */
export const useGetPerformanceReportV2Hook = (): (params?: GetPerformanceReportV2Params, options?: RequestInit) => Promise<PerformanceReportTableBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetPerformanceReportV2Params, options?: RequestInit) => {

        return customFetcher(getGetPerformanceReportV2Url(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetPerformanceReportV2QueryKey = (params?: GetPerformanceReportV2Params,) => {
    return [
    `/v2/performance-report`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetPerformanceReportV2QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetPerformanceReportV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportV2QueryKey(params);

  const getPerformanceReportV2 =  useGetPerformanceReportV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>> = ({ signal }) => getPerformanceReportV2(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReportV2QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>>
export type GetPerformanceReportV2QueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportV2<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetPerformanceReportV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportV2<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportV2<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report table view (v2)
 */

export function useGetPerformanceReportV2<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetPerformanceReportV2SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetPerformanceReportV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportV2QueryKey(params);

  const getPerformanceReportV2 =  useGetPerformanceReportV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>> = ({ signal }) => getPerformanceReportV2(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPerformanceReportV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>>
export type GetPerformanceReportV2SuspenseQueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetPerformanceReportV2Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report table view (v2)
 */

export function useGetPerformanceReportV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportV2SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportPerformanceReportV2Url = (params?: ExportPerformanceReportV2Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/performance-report/export?${stringifiedParams}` : `/v2/performance-report/export`
}

/**
 * Same CSV as /v1/performance-report/export, read directly from the base tables (PART-4355) rather than mv_referral_performance -- the export counterpart of /v2/performance-report, so a caller on v2 gets the same rows in the table and in the download.
 * @summary Export Performance Report table view as CSV (v2)
 */
export const useExportPerformanceReportV2Hook = (): (params?: ExportPerformanceReportV2Params, options?: RequestInit) => Promise<Blob> => {

      const customFetcher = useFetchWrapper();
      return (params?: ExportPerformanceReportV2Params, options?: RequestInit) => {

        return customFetcher(getExportPerformanceReportV2Url(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getExportPerformanceReportV2QueryKey = (params?: ExportPerformanceReportV2Params,) => {
    return [
    `/v2/performance-report/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportPerformanceReportV2QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: ExportPerformanceReportV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPerformanceReportV2QueryKey(params);

  const exportPerformanceReportV2 =  useExportPerformanceReportV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>> = ({ signal }) => exportPerformanceReportV2(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportPerformanceReportV2QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>>
export type ExportPerformanceReportV2QueryError = ErrorType<ErrorModel>


export function useExportPerformanceReportV2<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportPerformanceReportV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPerformanceReportV2<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPerformanceReportV2<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Performance Report table view as CSV (v2)
 */

export function useExportPerformanceReportV2<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportPerformanceReportV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportPerformanceReportV2SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: ExportPerformanceReportV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportPerformanceReportV2QueryKey(params);

  const exportPerformanceReportV2 =  useExportPerformanceReportV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>> = ({ signal }) => exportPerformanceReportV2(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportPerformanceReportV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>>
export type ExportPerformanceReportV2SuspenseQueryError = ErrorType<ErrorModel>


export function useExportPerformanceReportV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportPerformanceReportV2Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPerformanceReportV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportPerformanceReportV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Performance Report table view as CSV (v2)
 */

export function useExportPerformanceReportV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportPerformanceReportV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportPerformanceReportV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportPerformanceReportV2SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPerformanceReportStatsV2Url = (params?: GetPerformanceReportStatsV2Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v2/performance-report/stats?${stringifiedParams}` : `/v2/performance-report/stats`
}

/**
 * Same five summary metrics as /v1/performance-report/stats, read directly from the base tables (PART-4355) rather than mv_referral_performance -- the KPI-card counterpart of /v2/performance-report, so the cards and the table below them always agree.
 * @summary Get Performance Report summary metrics (v2)
 */
export const useGetPerformanceReportStatsV2Hook = (): (params?: GetPerformanceReportStatsV2Params, options?: RequestInit) => Promise<PerformanceReportStats> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetPerformanceReportStatsV2Params, options?: RequestInit) => {

        return customFetcher(getGetPerformanceReportStatsV2Url(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetPerformanceReportStatsV2QueryKey = (params?: GetPerformanceReportStatsV2Params,) => {
    return [
    `/v2/performance-report/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetPerformanceReportStatsV2QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetPerformanceReportStatsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportStatsV2QueryKey(params);

  const getPerformanceReportStatsV2 =  useGetPerformanceReportStatsV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>> = ({ signal }) => getPerformanceReportStatsV2(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPerformanceReportStatsV2QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>>
export type GetPerformanceReportStatsV2QueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportStatsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetPerformanceReportStatsV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportStatsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportStatsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report summary metrics (v2)
 */

export function useGetPerformanceReportStatsV2<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportStatsV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetPerformanceReportStatsV2SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetPerformanceReportStatsV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceReportStatsV2QueryKey(params);

  const getPerformanceReportStatsV2 =  useGetPerformanceReportStatsV2Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>> = ({ signal }) => getPerformanceReportStatsV2(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPerformanceReportStatsV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>>
export type GetPerformanceReportStatsV2SuspenseQueryError = ErrorType<ErrorModel>


export function useGetPerformanceReportStatsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetPerformanceReportStatsV2Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportStatsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerformanceReportStatsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Performance Report summary metrics (v2)
 */

export function useGetPerformanceReportStatsV2Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetPerformanceReportStatsV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPerformanceReportStatsV2Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPerformanceReportStatsV2SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsAccountReportV3Url = (params?: GetClientsAccountReportV3Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v3/clients/account-report?${stringifiedParams}` : `/v3/clients/account-report`
}

/**
 * @summary Get clients account report split by direct and shared clients
 */
export const useGetClientsAccountReportV3Hook = (): (params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: RequestInit) => Promise<AccountReportV3> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: RequestInit) => {

        return customFetcher(getGetClientsAccountReportV3Url(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetClientsAccountReportV3QueryKey = (params?: GetClientsAccountReportV3Params,) => {
    return [
    `/v3/clients/account-report`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsAccountReportV3QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsAccountReportV3QueryKey(params);

  const getClientsAccountReportV3 =  useGetClientsAccountReportV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>> = ({ signal }) => getClientsAccountReportV3(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsAccountReportV3QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>>
export type GetClientsAccountReportV3QueryError = ErrorType<ErrorModel>


export function useGetClientsAccountReportV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsAccountReportV3Params,
    headers: undefined |  GetClientsAccountReportV3Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients account report split by direct and shared clients
 */

export function useGetClientsAccountReportV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsAccountReportV3QueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsAccountReportV3SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsAccountReportV3QueryKey(params);

  const getClientsAccountReportV3 =  useGetClientsAccountReportV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>> = ({ signal }) => getClientsAccountReportV3(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsAccountReportV3SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>>
export type GetClientsAccountReportV3SuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsAccountReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsAccountReportV3Params,
    headers: undefined |  GetClientsAccountReportV3Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients account report split by direct and shared clients
 */

export function useGetClientsAccountReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportV3Params,
    headers?: GetClientsAccountReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsAccountReportV3SuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportClientsAccountReportV3Url = (params?: ExportClientsAccountReportV3Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v3/clients/account-report/export?${stringifiedParams}` : `/v3/clients/account-report/export`
}

/**
 * @summary Export clients account report split by direct and shared clients
 */
export const useExportClientsAccountReportV3Hook = (): (params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: RequestInit) => Promise<Blob> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: RequestInit) => {

        return customFetcher(getExportClientsAccountReportV3Url(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getExportClientsAccountReportV3QueryKey = (params?: ExportClientsAccountReportV3Params,) => {
    return [
    `/v3/clients/account-report/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportClientsAccountReportV3QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportClientsAccountReportV3QueryKey(params);

  const exportClientsAccountReportV3 =  useExportClientsAccountReportV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>> = ({ signal }) => exportClientsAccountReportV3(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportClientsAccountReportV3QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>>
export type ExportClientsAccountReportV3QueryError = ErrorType<ErrorModel>


export function useExportClientsAccountReportV3<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportClientsAccountReportV3Params,
    headers: undefined |  ExportClientsAccountReportV3Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsAccountReportV3<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsAccountReportV3<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients account report split by direct and shared clients
 */

export function useExportClientsAccountReportV3<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportClientsAccountReportV3QueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportClientsAccountReportV3SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportClientsAccountReportV3QueryKey(params);

  const exportClientsAccountReportV3 =  useExportClientsAccountReportV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>> = ({ signal }) => exportClientsAccountReportV3(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportClientsAccountReportV3SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>>
export type ExportClientsAccountReportV3SuspenseQueryError = ErrorType<ErrorModel>


export function useExportClientsAccountReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportClientsAccountReportV3Params,
    headers: undefined |  ExportClientsAccountReportV3Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsAccountReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsAccountReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients account report split by direct and shared clients
 */

export function useExportClientsAccountReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsAccountReportV3Params,
    headers?: ExportClientsAccountReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsAccountReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportClientsAccountReportV3SuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsAccountReportStatsV3Url = (params?: GetClientsAccountReportStatsV3Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v3/clients/account-report/stats?${stringifiedParams}` : `/v3/clients/account-report/stats`
}

/**
 * @summary Get clients account report stats split by direct and shared clients
 */
export const useGetClientsAccountReportStatsV3Hook = (): (params?: GetClientsAccountReportStatsV3Params, options?: RequestInit) => Promise<AccountReportStats> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsAccountReportStatsV3Params, options?: RequestInit) => {

        return customFetcher(getGetClientsAccountReportStatsV3Url(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetClientsAccountReportStatsV3QueryKey = (params?: GetClientsAccountReportStatsV3Params,) => {
    return [
    `/v3/clients/account-report/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsAccountReportStatsV3QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsAccountReportStatsV3Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsAccountReportStatsV3QueryKey(params);

  const getClientsAccountReportStatsV3 =  useGetClientsAccountReportStatsV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>> = ({ signal }) => getClientsAccountReportStatsV3(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsAccountReportStatsV3QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>>
export type GetClientsAccountReportStatsV3QueryError = ErrorType<ErrorModel>


export function useGetClientsAccountReportStatsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsAccountReportStatsV3Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportStatsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsV3Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportStatsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsV3Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients account report stats split by direct and shared clients
 */

export function useGetClientsAccountReportStatsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsV3Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsAccountReportStatsV3QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsAccountReportStatsV3SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsAccountReportStatsV3Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsAccountReportStatsV3QueryKey(params);

  const getClientsAccountReportStatsV3 =  useGetClientsAccountReportStatsV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>> = ({ signal }) => getClientsAccountReportStatsV3(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsAccountReportStatsV3SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>>
export type GetClientsAccountReportStatsV3SuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsAccountReportStatsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsAccountReportStatsV3Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportStatsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsV3Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsAccountReportStatsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsV3Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients account report stats split by direct and shared clients
 */

export function useGetClientsAccountReportStatsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsAccountReportStatsV3Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsAccountReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsAccountReportStatsV3SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsSubIbsV3Url = () => {




  return `/v3/clients/sub-ibs`
}

/**
 * @summary List the Sub IBs of the authenticated IB
 */
export const useGetClientsSubIbsV3Hook = (): ( options?: RequestInit) => Promise<SubIBList> => {

      const customFetcher = useFetchWrapper();
      return ( options?: RequestInit) => {

        return customFetcher(getGetClientsSubIbsV3Url(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetClientsSubIbsV3QueryKey = () => {
    return [
    `/v3/clients/sub-ibs`
    ] as const;
    }


export const useGetClientsSubIbsV3QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsSubIbsV3QueryKey();

  const getClientsSubIbsV3 =  useGetClientsSubIbsV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>> = ({ signal }) => getClientsSubIbsV3({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsSubIbsV3QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>>
export type GetClientsSubIbsV3QueryError = ErrorType<ErrorModel>


export function useGetClientsSubIbsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsSubIbsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsSubIbsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the Sub IBs of the authenticated IB
 */

export function useGetClientsSubIbsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsSubIbsV3QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsSubIbsV3SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsSubIbsV3QueryKey();

  const getClientsSubIbsV3 =  useGetClientsSubIbsV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>> = ({ signal }) => getClientsSubIbsV3({ signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsSubIbsV3SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>>
export type GetClientsSubIbsV3SuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsSubIbsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsSubIbsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsSubIbsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the Sub IBs of the authenticated IB
 */

export function useGetClientsSubIbsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError = ErrorType<ErrorModel>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsSubIbsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsSubIbsV3SuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsTradingReportV3Url = (params?: GetClientsTradingReportV3Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v3/clients/trading-report?${stringifiedParams}` : `/v3/clients/trading-report`
}

/**
 * @summary Get clients trading report split by direct and shared clients
 */
export const useGetClientsTradingReportV3Hook = (): (params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: RequestInit) => Promise<TradingReportV3> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: RequestInit) => {

        return customFetcher(getGetClientsTradingReportV3Url(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getGetClientsTradingReportV3QueryKey = (params?: GetClientsTradingReportV3Params,) => {
    return [
    `/v3/clients/trading-report`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsTradingReportV3QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsTradingReportV3QueryKey(params);

  const getClientsTradingReportV3 =  useGetClientsTradingReportV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>> = ({ signal }) => getClientsTradingReportV3(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsTradingReportV3QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>>
export type GetClientsTradingReportV3QueryError = ErrorType<ErrorModel>


export function useGetClientsTradingReportV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsTradingReportV3Params,
    headers: undefined |  GetClientsTradingReportV3Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients trading report split by direct and shared clients
 */

export function useGetClientsTradingReportV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsTradingReportV3QueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsTradingReportV3SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsTradingReportV3QueryKey(params);

  const getClientsTradingReportV3 =  useGetClientsTradingReportV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>> = ({ signal }) => getClientsTradingReportV3(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsTradingReportV3SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>>
export type GetClientsTradingReportV3SuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsTradingReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsTradingReportV3Params,
    headers: undefined |  GetClientsTradingReportV3Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients trading report split by direct and shared clients
 */

export function useGetClientsTradingReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportV3Params,
    headers?: GetClientsTradingReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsTradingReportV3SuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportClientsTradingReportV3Url = (params?: ExportClientsTradingReportV3Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v3/clients/trading-report/export?${stringifiedParams}` : `/v3/clients/trading-report/export`
}

/**
 * @summary Export clients trading report split by direct and shared clients
 */
export const useExportClientsTradingReportV3Hook = (): (params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: RequestInit) => Promise<Blob> => {
      const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };

      const customFetcher = useFetchWrapper();
      return (params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: RequestInit) => {

        return customFetcher(getExportClientsTradingReportV3Url(params),
  {
    ...options,
    method: 'GET',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);
      }
  }





export const getExportClientsTradingReportV3QueryKey = (params?: ExportClientsTradingReportV3Params,) => {
    return [
    `/v3/clients/trading-report/export`, ...(params ? [params] : [])
    ] as const;
    }


export const useExportClientsTradingReportV3QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportClientsTradingReportV3QueryKey(params);

  const exportClientsTradingReportV3 =  useExportClientsTradingReportV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>> = ({ signal }) => exportClientsTradingReportV3(params,headers, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportClientsTradingReportV3QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>>
export type ExportClientsTradingReportV3QueryError = ErrorType<ErrorModel>


export function useExportClientsTradingReportV3<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportClientsTradingReportV3Params,
    headers: undefined |  ExportClientsTradingReportV3Headers, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsTradingReportV3<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsTradingReportV3<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients trading report split by direct and shared clients
 */

export function useExportClientsTradingReportV3<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportClientsTradingReportV3QueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useExportClientsTradingReportV3SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportClientsTradingReportV3QueryKey(params);

  const exportClientsTradingReportV3 =  useExportClientsTradingReportV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>> = ({ signal }) => exportClientsTradingReportV3(params,headers, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ExportClientsTradingReportV3SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>>
export type ExportClientsTradingReportV3SuspenseQueryError = ErrorType<ErrorModel>


export function useExportClientsTradingReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  ExportClientsTradingReportV3Params,
    headers: undefined |  ExportClientsTradingReportV3Headers, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsTradingReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportClientsTradingReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export clients trading report split by direct and shared clients
 */

export function useExportClientsTradingReportV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: ExportClientsTradingReportV3Params,
    headers?: ExportClientsTradingReportV3Headers, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useExportClientsTradingReportV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useExportClientsTradingReportV3SuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetClientsTradingReportStatsV3Url = (params?: GetClientsTradingReportStatsV3Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v3/clients/trading-report/stats?${stringifiedParams}` : `/v3/clients/trading-report/stats`
}

/**
 * @summary Get clients trading report stats split by direct and shared clients
 */
export const useGetClientsTradingReportStatsV3Hook = (): (params?: GetClientsTradingReportStatsV3Params, options?: RequestInit) => Promise<TradingReportStatsOutputBody> => {

      const customFetcher = useFetchWrapper();
      return (params?: GetClientsTradingReportStatsV3Params, options?: RequestInit) => {

        return customFetcher(getGetClientsTradingReportStatsV3Url(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }





export const getGetClientsTradingReportStatsV3QueryKey = (params?: GetClientsTradingReportStatsV3Params,) => {
    return [
    `/v3/clients/trading-report/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetClientsTradingReportStatsV3QueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsTradingReportStatsV3Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsTradingReportStatsV3QueryKey(params);

  const getClientsTradingReportStatsV3 =  useGetClientsTradingReportStatsV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>> = ({ signal }) => getClientsTradingReportStatsV3(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsTradingReportStatsV3QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>>
export type GetClientsTradingReportStatsV3QueryError = ErrorType<ErrorModel>


export function useGetClientsTradingReportStatsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsTradingReportStatsV3Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportStatsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsV3Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportStatsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsV3Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients trading report stats split by direct and shared clients
 */

export function useGetClientsTradingReportStatsV3<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsV3Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsTradingReportStatsV3QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetClientsTradingReportStatsV3SuspenseQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(params?: GetClientsTradingReportStatsV3Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsTradingReportStatsV3QueryKey(params);

  const getClientsTradingReportStatsV3 =  useGetClientsTradingReportStatsV3Hook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>> = ({ signal }) => getClientsTradingReportStatsV3(params, { signal });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetClientsTradingReportStatsV3SuspenseQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>>
export type GetClientsTradingReportStatsV3SuspenseQueryError = ErrorType<ErrorModel>


export function useGetClientsTradingReportStatsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params: undefined |  GetClientsTradingReportStatsV3Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportStatsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsV3Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsTradingReportStatsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsV3Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get clients trading report stats split by direct and shared clients
 */

export function useGetClientsTradingReportStatsV3Suspense<TData = Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError = ErrorType<ErrorModel>>(
 params?: GetClientsTradingReportStatsV3Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClientsTradingReportStatsV3Hook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClientsTradingReportStatsV3SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
